import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigInt: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  JSONObject: { input: any; output: any };
  JWT: { input: any; output: any };
  ObjectID: { input: any; output: any };
};

export type AddUpdateBetInput = {
  betAmount?: InputMaybe<Scalars["Float"]["input"]>;
  betId?: InputMaybe<Scalars["String"]["input"]>;
  oddId: Scalars["String"]["input"];
};

export type AllDetailedDailyReward = {
  __typename?: "AllDetailedDailyReward";
  continuousLoginDays: Scalars["Int"]["output"];
  rewardEndDate: Scalars["Date"]["output"];
  rewards: Array<DailyRewardItem>;
  timeLeft?: Maybe<Scalars["String"]["output"]>;
};

export type AllTeamRatingsRecalculation = {
  __typename?: "AllTeamRatingsRecalculation";
  _id: Scalars["ObjectID"]["output"];
  endAt?: Maybe<Scalars["Date"]["output"]>;
  error?: Maybe<Scalars["JSONObject"]["output"]>;
  initiatedByEmail?: Maybe<Scalars["String"]["output"]>;
  requestId?: Maybe<Scalars["String"]["output"]>;
  startAt: Scalars["Date"]["output"];
  status: ReCalTeamRatingStatusEnum;
  stoppedAt?: Maybe<Scalars["Date"]["output"]>;
  summary?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type AllTypeStoreItem = {
  __typename?: "AllTypeStoreItem";
  coins: Array<StoreCoins>;
  groupedPacks: Array<GroupedPacksDto>;
};

export type AllUser = {
  __typename?: "AllUser";
  _id: Scalars["ObjectID"]["output"];
  annualResetId?: Maybe<Scalars["ObjectID"]["output"]>;
  balance?: Maybe<Scalars["Float"]["output"]>;
  brandId?: Maybe<Scalars["String"]["output"]>;
  continuousLoginDays?: Maybe<Scalars["Int"]["output"]>;
  countryCode?: Maybe<Scalars["String"]["output"]>;
  countryName?: Maybe<Scalars["String"]["output"]>;
  currency: Scalars["String"]["output"];
  eosRewards?: Maybe<Scalars["JSONObject"]["output"]>;
  goldStars?: Maybe<Scalars["Int"]["output"]>;
  isFTU: Scalars["Boolean"]["output"];
  language: Scalars["String"]["output"];
  lastLoginDate?: Maybe<Scalars["Date"]["output"]>;
  leagueInfo?: Maybe<Scalars["JSONObject"]["output"]>;
  maxBet?: Maybe<Scalars["Float"]["output"]>;
  maxPayOut?: Maybe<Scalars["Float"]["output"]>;
  minBet?: Maybe<Scalars["Float"]["output"]>;
  operatorId: Scalars["String"]["output"];
  pbfCoin?: Maybe<Scalars["Float"]["output"]>;
  pendingDivisionResetReward?: Maybe<Scalars["String"]["output"]>;
  platformId: Scalars["String"]["output"];
  resetToL1?: Maybe<Scalars["Boolean"]["output"]>;
  rgsPlayerId: Scalars["String"]["output"];
  seasonPoints?: Maybe<Scalars["Float"]["output"]>;
  settings?: Maybe<AllUserSettings>;
  showEos?: Maybe<Scalars["Boolean"]["output"]>;
  showVoidedBetPopup?: Maybe<Scalars["String"]["output"]>;
  team?: Maybe<UserTeam>;
};

export type AllUserSettings = {
  __typename?: "AllUserSettings";
  audio: Scalars["Boolean"]["output"];
  oddsDisplay: OddsDisplayEnum;
};

export type AnnualResetInfo = {
  __typename?: "AnnualResetInfo";
  _id: Scalars["ObjectID"]["output"];
  endAt?: Maybe<Scalars["Date"]["output"]>;
  error?: Maybe<Scalars["JSONObject"]["output"]>;
  initiatedByEmail?: Maybe<Scalars["String"]["output"]>;
  startAt: Scalars["Date"]["output"];
  status: AnnualResetStatus;
  summary?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type AnnualResetInput = {
  initiatedByEmail?: InputMaybe<Scalars["String"]["input"]>;
  resetId?: InputMaybe<Scalars["String"]["input"]>;
};

export enum AnnualResetStatus {
  Completed = "COMPLETED",
  Failed = "FAILED",
  Started = "STARTED",
}

export type ApplyBoosterInput = {
  boosterId: Scalars["ObjectID"]["input"];
  /** This is the _id received in myTeam.players */
  playerCardId: Scalars["ObjectID"]["input"];
};

export type Banner = {
  __typename?: "Banner";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  bodyTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isActive: Scalars["Boolean"]["output"];
  isBodyBold?: Maybe<Scalars["Boolean"]["output"]>;
  isTitleBold?: Maybe<Scalars["Boolean"]["output"]>;
  navigationPath: NavigationPathType;
  operators?: Maybe<Array<Scalars["String"]["output"]>>;
  order?: Maybe<Scalars["Int"]["output"]>;
  territory?: Maybe<Scalars["String"]["output"]>;
  textColor: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  titleTrans?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type Bet = {
  __typename?: "Bet";
  id: Scalars["String"]["output"];
  isResolved: Scalars["Boolean"]["output"];
};

export enum BetStatus {
  AddedToSlip = "ADDED_TO_SLIP",
  CreditFailed = "CREDIT_FAILED",
  CreditStarted = "CREDIT_STARTED",
  CreditSuccess = "CREDIT_SUCCESS",
  DebitFailed = "DEBIT_FAILED",
  DebitStarted = "DEBIT_STARTED",
  DebitSuccess = "DEBIT_SUCCESS",
  RefundFailed = "REFUND_FAILED",
  RefundStarted = "REFUND_STARTED",
  RefundSuccess = "REFUND_SUCCESS",
}

export enum BettingMarketsEnum {
  Btts = "BTTS",
  CorrectScore = "CORRECT_SCORE",
  FinalResult = "FINAL_RESULT",
  FirstGoalCorrectScore = "FIRST_GOAL_CORRECT_SCORE",
  FirstLastAnyGoalScore = "FIRST_LAST_ANY_GOAL_SCORE",
  Handicaps = "HANDICAPS",
  ResultBtts = "RESULT_BTTS",
  UnderOver = "UNDER_OVER",
}

export enum BoosterRarityEnum {
  Bronze = "bronze",
  Fatigue = "fatigue",
  Gold = "gold",
  Silver = "silver",
}

export enum BoosterType {
  All = "All",
  Attack = "Attack",
  Creativity = "Creativity",
  Defence = "Defence",
  Fatigue = "Fatigue",
}

export type Boosters = {
  __typename?: "Boosters";
  _id: Scalars["ObjectID"]["output"];
  bonusPoints: Scalars["Int"]["output"];
  cost: Scalars["Int"]["output"];
  displayName?: Maybe<Scalars["String"]["output"]>;
  duration?: Maybe<Scalars["Int"]["output"]>;
  imageUrl: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  rarity?: Maybe<BoosterRarityEnum>;
  type: BoosterType;
};

export type BotGhostTeam = {
  __typename?: "BotGhostTeam";
  _id: Scalars["ObjectID"]["output"];
  attackRating: Scalars["Float"]["output"];
  badge?: Maybe<Scalars["String"]["output"]>;
  badgeUrl?: Maybe<Scalars["String"]["output"]>;
  chemistry: Scalars["Float"]["output"];
  chemistryPercentage?: Maybe<Scalars["Int"]["output"]>;
  creativityRating: Scalars["Float"]["output"];
  defenseRating: Scalars["Float"]["output"];
  formation?: Maybe<Scalars["String"]["output"]>;
  kit?: Maybe<Scalars["String"]["output"]>;
  kitColor: Scalars["String"]["output"];
  kitColorDark?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  overallRating: Scalars["Float"]["output"];
  players: Array<BotGhostTeamPlayerCard>;
};

export type BotGhostTeamPlayerCard = {
  __typename?: "BotGhostTeamPlayerCard";
  _id: Scalars["ObjectID"]["output"];
  attackRating: Scalars["Float"]["output"];
  boosterDetails?: Maybe<GhostPlayerBoosterDetails>;
  cardImg?: Maybe<Scalars["String"]["output"]>;
  cardImgSm?: Maybe<Scalars["String"]["output"]>;
  chemistry?: Maybe<Scalars["Int"]["output"]>;
  club: Scalars["String"]["output"];
  clubId: Scalars["String"]["output"];
  commonName?: Maybe<Scalars["String"]["output"]>;
  commonNameForename: Scalars["String"]["output"];
  commonNameSurname: Scalars["String"]["output"];
  creativityRating: Scalars["Float"]["output"];
  currentPosition?: Maybe<PlayerPositionEnum>;
  defenseRating: Scalars["Float"]["output"];
  detImg?: Maybe<Scalars["String"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  displayNameAbb?: Maybe<Scalars["String"]["output"]>;
  extraData?: Maybe<Scalars["JSONObject"]["output"]>;
  fullName: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isBoosterApplied?: Maybe<Scalars["Boolean"]["output"]>;
  largeImageUrl?: Maybe<Scalars["String"]["output"]>;
  league?: Maybe<Scalars["String"]["output"]>;
  miniImageUrl?: Maybe<Scalars["String"]["output"]>;
  nationality: Scalars["String"]["output"];
  nationalityImageUrl?: Maybe<Scalars["String"]["output"]>;
  overallRating: Scalars["Float"]["output"];
  playerId: Scalars["String"]["output"];
  preferredPosition: PlayerPositionEnum;
  rarity: CardRarityEnum;
  secondaryPosition1?: Maybe<PlayerPositionEnum>;
  secondaryPosition2?: Maybe<PlayerPositionEnum>;
  shirtNumber?: Maybe<Scalars["Int"]["output"]>;
};

export enum BotGhostTeamType {
  Bot = "Bot",
  Ghost = "Ghost",
}

export type BttsOdds = {
  __typename?: "BttsOdds";
  data: Array<BttsOddsData>;
  name: Scalars["String"]["output"];
  type: BettingMarketsEnum;
};

export type BttsOddsData = {
  __typename?: "BttsOddsData";
  americanOdd: Scalars["String"]["output"];
  decimalOdd: Scalars["Float"]["output"];
  fractionalOdd: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  maxBet?: Maybe<Scalars["Float"]["output"]>;
  odd: Scalars["String"]["output"];
  payoutMultiplier: Scalars["Float"]["output"];
  value: YesNoEnum;
  xpBoostPercentage: Scalars["Float"]["output"];
};

export type BulkCreateBotTeamsInput = {
  csvData: Scalars["JSONObject"]["input"];
};

export type BulkIgnorePlayerUpdateInput = {
  updateIds?: InputMaybe<Array<Scalars["ObjectID"]["input"]>>;
};

export type BulkManualPlayersAllFieldsArrayInput = {
  players: Array<BulkManualPlayersAllFieldsInput>;
};

export type BulkManualPlayersAllFieldsInput = {
  _id?: InputMaybe<Scalars["ObjectID"]["input"]>;
  attackRating: Scalars["Float"]["input"];
  club?: InputMaybe<Scalars["String"]["input"]>;
  clubId: Scalars["String"]["input"];
  clubShortCode?: InputMaybe<Scalars["String"]["input"]>;
  commonName?: InputMaybe<Scalars["String"]["input"]>;
  commonNameForename: Scalars["String"]["input"];
  commonNameSurname: Scalars["String"]["input"];
  createdAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  creativityRating: Scalars["Float"]["input"];
  customSellPrice?: InputMaybe<Scalars["Int"]["input"]>;
  defenseRating: Scalars["Float"]["input"];
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  displayNameAbb?: InputMaybe<Scalars["String"]["input"]>;
  fullName: Scalars["String"]["input"];
  gender?: InputMaybe<GenderEnum>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  nationality: Scalars["String"]["input"];
  overallRating?: InputMaybe<Scalars["Float"]["input"]>;
  playerId: Scalars["String"]["input"];
  preferredPosition: PlayerPositionEnum;
  rarity?: InputMaybe<CardRarityEnum>;
  secondaryPosition1?: InputMaybe<PlayerPositionEnum>;
  secondaryPosition2?: InputMaybe<PlayerPositionEnum>;
  shirtNumber?: InputMaybe<Scalars["Int"]["input"]>;
  template?: InputMaybe<Scalars["ObjectID"]["input"]>;
  updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type BulkOperationError = {
  __typename?: "BulkOperationError";
  error: Scalars["String"]["output"];
  playerId: Scalars["String"]["output"];
};

export type BulkOperationResult = {
  __typename?: "BulkOperationResult";
  errors?: Maybe<Array<BulkOperationError>>;
  failed: Scalars["Float"]["output"];
  matchedCount: Scalars["Float"]["output"];
  modifiedCount: Scalars["Float"]["output"];
  success: Scalars["Float"]["output"];
  upsertedCount: Scalars["Float"]["output"];
};

export type BulkPlayerCardsAllFieldsArrayInput = {
  players: Array<BulkPlayerCardsAllFieldsInput>;
};

export type BulkPlayerCardsAllFieldsInput = {
  _id?: InputMaybe<Scalars["ObjectID"]["input"]>;
  attackRating: Scalars["Float"]["input"];
  cardBgId?: InputMaybe<Scalars["ObjectID"]["input"]>;
  club?: InputMaybe<Scalars["String"]["input"]>;
  clubId: Scalars["String"]["input"];
  clubShortCode?: InputMaybe<Scalars["String"]["input"]>;
  commonName?: InputMaybe<Scalars["String"]["input"]>;
  commonNameForename: Scalars["String"]["input"];
  commonNameSurname: Scalars["String"]["input"];
  createdAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  creativityRating: Scalars["Float"]["input"];
  customSellPrice?: InputMaybe<Scalars["Int"]["input"]>;
  defenseRating: Scalars["Float"]["input"];
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  displayNameAbb?: InputMaybe<Scalars["String"]["input"]>;
  fullName: Scalars["String"]["input"];
  gender?: InputMaybe<GenderEnum>;
  isDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  nationality: Scalars["String"]["input"];
  overallRating?: InputMaybe<Scalars["Float"]["input"]>;
  playerId: Scalars["String"]["input"];
  preferredPosition: PlayerPositionEnum;
  rarity?: InputMaybe<CardRarityEnum>;
  secondaryPosition1?: InputMaybe<PlayerPositionEnum>;
  secondaryPosition2?: InputMaybe<PlayerPositionEnum>;
  shirtNumber?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  template?: InputMaybe<Scalars["ObjectID"]["input"]>;
  updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type BulkPlayerTemplatesArrayInput = {
  players: Array<BulkPlayerTemplatesInput>;
};

export type BulkPlayerTemplatesInput = {
  _id?: InputMaybe<Scalars["ObjectID"]["input"]>;
  attackRating: Scalars["Float"]["input"];
  club?: InputMaybe<Scalars["String"]["input"]>;
  clubId: Scalars["String"]["input"];
  clubShortCode?: InputMaybe<Scalars["String"]["input"]>;
  commonNameForename: Scalars["String"]["input"];
  commonNameSurname: Scalars["String"]["input"];
  createdAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  creativityRating: Scalars["Float"]["input"];
  defenseRating: Scalars["Float"]["input"];
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  displayNameAbb?: InputMaybe<Scalars["String"]["input"]>;
  fullName: Scalars["String"]["input"];
  gender?: InputMaybe<GenderEnum>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  nationality: Scalars["String"]["input"];
  overallRating?: InputMaybe<Scalars["Float"]["input"]>;
  playerId: Scalars["String"]["input"];
  preferredPosition: PlayerPositionEnum;
  secondaryPosition1?: InputMaybe<PlayerPositionEnum>;
  secondaryPosition2?: InputMaybe<PlayerPositionEnum>;
  shirtNumber?: InputMaybe<Scalars["Int"]["input"]>;
  updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type BulkPlayerUpdateInput = {
  updateIds?: InputMaybe<Array<Scalars["ObjectID"]["input"]>>;
};

export type BulkUpdateFtuePackInput = {
  workbook: Scalars["JSONObject"]["input"];
};

export type BuyStoreItemInput = {
  itemId: Scalars["String"]["input"];
  type: StoreItemTypeEnum;
};

export type BuyStoreItemResponse = {
  __typename?: "BuyStoreItemResponse";
  data: Scalars["JSONObject"]["output"];
  message: Scalars["String"]["output"];
};

export type CardBg = {
  __typename?: "CardBg";
  _id: Scalars["ObjectID"]["output"];
  cardImg?: Maybe<Scalars["String"]["output"]>;
  cardImgSm?: Maybe<Scalars["String"]["output"]>;
  detImg?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  textColor: Scalars["String"]["output"];
};

export enum CardRarityEnum {
  Bronze = "bronze",
  Gold = "gold",
  InForm = "inForm",
  Silver = "silver",
}

export type ClaimLeaderboardRewardResponse = {
  __typename?: "ClaimLeaderboardRewardResponse";
  boosters?: Maybe<Array<ClaimRewardUserBoosters>>;
  coinsFromPack?: Maybe<Scalars["Float"]["output"]>;
  packCount?: Maybe<Scalars["Int"]["output"]>;
  packId?: Maybe<Scalars["String"]["output"]>;
  packImageUrl?: Maybe<Scalars["String"]["output"]>;
  packName?: Maybe<Scalars["String"]["output"]>;
  players?: Maybe<Array<ClaimRewardPlayerCard>>;
  quickSellCoins?: Maybe<Scalars["Float"]["output"]>;
  rewardCoin?: Maybe<Scalars["Float"]["output"]>;
};

export type ClaimRewardPlayerCard = {
  __typename?: "ClaimRewardPlayerCard";
  attackRating: Scalars["Float"]["output"];
  cardImg?: Maybe<Scalars["String"]["output"]>;
  cardImgSm?: Maybe<Scalars["String"]["output"]>;
  club: Scalars["String"]["output"];
  clubId: Scalars["String"]["output"];
  coins?: Maybe<Scalars["Float"]["output"]>;
  commonName?: Maybe<Scalars["String"]["output"]>;
  commonNameForename: Scalars["String"]["output"];
  commonNameSurname: Scalars["String"]["output"];
  creativityRating: Scalars["Float"]["output"];
  defenseRating: Scalars["Float"]["output"];
  detImg?: Maybe<Scalars["String"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  displayNameAbb?: Maybe<Scalars["String"]["output"]>;
  extraData?: Maybe<Scalars["JSONObject"]["output"]>;
  fullName: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isQuickSold?: Maybe<Scalars["Boolean"]["output"]>;
  largeImageUrl?: Maybe<Scalars["String"]["output"]>;
  miniImageUrl?: Maybe<Scalars["String"]["output"]>;
  nationality: Scalars["String"]["output"];
  nationalityImageUrl?: Maybe<Scalars["String"]["output"]>;
  overallRating: Scalars["Float"]["output"];
  packIdx?: Maybe<Scalars["Int"]["output"]>;
  playerCard?: Maybe<Scalars["String"]["output"]>;
  playerId?: Maybe<Scalars["String"]["output"]>;
  preferredPosition: PlayerPositionEnum;
  rarity: CardRarityEnum;
  shirtNumber?: Maybe<Scalars["Int"]["output"]>;
  userPlayerId?: Maybe<Scalars["String"]["output"]>;
};

export type ClaimRewardResponse = {
  __typename?: "ClaimRewardResponse";
  boosters?: Maybe<Array<ClaimRewardUserBoosters>>;
  coinsFromPack: Scalars["Float"]["output"];
  packCount?: Maybe<Scalars["Int"]["output"]>;
  packId?: Maybe<Scalars["String"]["output"]>;
  packImageUrl?: Maybe<Scalars["String"]["output"]>;
  packName?: Maybe<Scalars["String"]["output"]>;
  players?: Maybe<Array<ClaimRewardPlayerCard>>;
  quickSellCoins?: Maybe<Scalars["Float"]["output"]>;
  rewardCoin: Scalars["Float"]["output"];
};

export type ClaimRewardUserBoosters = {
  __typename?: "ClaimRewardUserBoosters";
  bonusPoints: Scalars["Int"]["output"];
  duration?: Maybe<Scalars["Int"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  packIdx?: Maybe<Scalars["Int"]["output"]>;
  rarity?: Maybe<BoosterRarityEnum>;
  type: BoosterType;
};

export type ClearLocalCacheInput = {
  /** Clear all cache keys if true */
  clearAll?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Array of cache keys to clear */
  keys?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type Club = {
  __typename?: "Club";
  _id: Scalars["ObjectID"]["output"];
  abbreviation: Scalars["String"]["output"];
  backgroundColor: Scalars["String"]["output"];
  externalClubId?: Maybe<Scalars["String"]["output"]>;
  gender?: Maybe<GenderEnum>;
  isJerseyUpload?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  textColor: Scalars["String"]["output"];
};

export type CoinHistoryResponse = {
  __typename?: "CoinHistoryResponse";
  amount: Scalars["Float"]["output"];
  createdAt: Scalars["Date"]["output"];
  currency: Scalars["String"]["output"];
  price: Scalars["Float"]["output"];
  txnId: Scalars["String"]["output"];
};

export type CommonResult = {
  __typename?: "CommonResult";
  data?: Maybe<Scalars["JSONObject"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
};

export type CorrectScoreOdds = {
  __typename?: "CorrectScoreOdds";
  data: Array<CorrectScoreOddsData>;
  name: Scalars["String"]["output"];
  type: BettingMarketsEnum;
};

export type CorrectScoreOddsData = {
  __typename?: "CorrectScoreOddsData";
  values: Array<CorrectScoreOddsValues>;
  win: WinEnum;
};

export type CorrectScoreOddsValues = {
  __typename?: "CorrectScoreOddsValues";
  americanOdd: Scalars["String"]["output"];
  decimalOdd: Scalars["Float"]["output"];
  fractionalOdd: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  maxBet?: Maybe<Scalars["Float"]["output"]>;
  odd: Scalars["String"]["output"];
  payoutMultiplier: Scalars["Float"]["output"];
  price: Scalars["Float"]["output"];
  team1: Scalars["Int"]["output"];
  team2: Scalars["Int"]["output"];
  xpBoostPercentage: Scalars["Float"]["output"];
};

export type Countries = {
  __typename?: "Countries";
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isoCode: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type CountryLeaderboard = {
  __typename?: "CountryLeaderboard";
  countryLeaderboard?: Maybe<Array<LeaderboardEntry>>;
  userRanking?: Maybe<LeaderboardEntry>;
};

export type CreateBanner = {
  __typename?: "CreateBanner";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  bodyTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  fileUploadUrl: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  isBodyBold?: Maybe<Scalars["Boolean"]["output"]>;
  isTitleBold?: Maybe<Scalars["Boolean"]["output"]>;
  navigationPath: NavigationPathType;
  operators?: Maybe<Array<Scalars["String"]["output"]>>;
  order?: Maybe<Scalars["Int"]["output"]>;
  territory?: Maybe<Scalars["String"]["output"]>;
  textColor: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  titleTrans?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type CreateBannerInput = {
  body: Scalars["String"]["input"];
  bodyTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  fileType: Scalars["String"]["input"];
  isActive: Scalars["Boolean"]["input"];
  isBodyBold?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTitleBold?: InputMaybe<Scalars["Boolean"]["input"]>;
  navigationPath: NavigationPathType;
  operators?: InputMaybe<Array<Scalars["String"]["input"]>>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
  territory?: InputMaybe<Scalars["String"]["input"]>;
  textColor: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
  titleTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
};

export type CreateBoostersInput = {
  bonusPoints: Scalars["Int"]["input"];
  cost: Scalars["Int"]["input"];
  duration?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  type: BoosterType;
};

export type CreateCardBg = {
  __typename?: "CreateCardBg";
  _id: Scalars["ObjectID"]["output"];
  cardImgSmUploadUrl?: Maybe<Scalars["String"]["output"]>;
  cardImgUploadUrl?: Maybe<Scalars["String"]["output"]>;
  detImgUploadUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  textColor: Scalars["String"]["output"];
};

export type CreateCardBgInput = {
  cardImgFileType: Scalars["String"]["input"];
  cardImgSmFileType: Scalars["String"]["input"];
  detImgFileType: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  textColor: Scalars["String"]["input"];
};

export type CreateClubInput = {
  abbreviation: Scalars["String"]["input"];
  backgroundColor: Scalars["String"]["input"];
  externalClubId?: InputMaybe<Scalars["String"]["input"]>;
  gender?: InputMaybe<GenderEnum>;
  isJerseyUpload?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  textColor: Scalars["String"]["input"];
};

export type CreateDailyRewardInput = {
  awardType: DailyRewardTypeEnum;
  booster?: InputMaybe<Scalars["ObjectID"]["input"]>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  day: Scalars["Int"]["input"];
  pack?: InputMaybe<Scalars["ObjectID"]["input"]>;
  rewardHC?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CreateEosRewardConfigInput = {
  endPoints: Scalars["Int"]["input"];
  rewards: Array<TierRewardInput>;
  startPoints: Scalars["Int"]["input"];
  tier: Scalars["Int"]["input"];
};

export type CreateLanguagesInput = {
  isoCode: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type CreateLeagueConfigInput = {
  ceilValue?: InputMaybe<Scalars["Int"]["input"]>;
  endOfCycleRewardAmt?: InputMaybe<Scalars["Float"]["input"]>;
  endOfCycleRewardPack?: InputMaybe<Scalars["ObjectID"]["input"]>;
  floorValue?: InputMaybe<Scalars["Int"]["input"]>;
  k1: Scalars["Float"]["input"];
  k2: Scalars["Float"]["input"];
  kWeights?: InputMaybe<Scalars["JSONObject"]["input"]>;
  kWeightsFe?: InputMaybe<Scalars["JSONObject"]["input"]>;
  milestones: Array<CreateMilestonesInput>;
  name: Scalars["String"]["input"];
  number: Scalars["Float"]["input"];
};

export type CreateMilestonesInput = {
  descText?: InputMaybe<Scalars["String"]["input"]>;
  descTextTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  k1?: InputMaybe<Scalars["Float"]["input"]>;
  k2?: InputMaybe<Scalars["Float"]["input"]>;
  number: Scalars["Float"]["input"];
  rewardCoins?: InputMaybe<Scalars["Float"]["input"]>;
  rewardPack?: InputMaybe<Scalars["ObjectID"]["input"]>;
  rewardPackCount?: InputMaybe<Scalars["Float"]["input"]>;
  steps: Scalars["Float"]["input"];
};

export type CreateNotification = {
  __typename?: "CreateNotification";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  bodyTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  fileUploadUrl?: Maybe<Scalars["String"]["output"]>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  liveDate?: Maybe<Scalars["Date"]["output"]>;
  operators?: Maybe<Array<Scalars["String"]["output"]>>;
  territory?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  titleTrans?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type CreateNotificationInput = {
  body: Scalars["String"]["input"];
  bodyTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  fileType?: InputMaybe<Scalars["String"]["input"]>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  operators?: InputMaybe<Array<Scalars["String"]["input"]>>;
  territory?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
  titleTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
};

export type CreatePack = {
  __typename?: "CreatePack";
  _id: Scalars["ObjectID"]["output"];
  category?: Maybe<Scalars["ObjectID"]["output"]>;
  excludePlayers?: Maybe<Array<Scalars["ObjectID"]["output"]>>;
  fileUploadUrl?: Maybe<Scalars["String"]["output"]>;
  idFromExcel?: Maybe<Scalars["String"]["output"]>;
  isDisabled?: Maybe<Scalars["Boolean"]["output"]>;
  isFTUPack: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  nameTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  nationality?: Maybe<Scalars["String"]["output"]>;
  operatorPackPrice?: Maybe<Scalars["JSONObject"]["output"]>;
  operatorPacks?: Maybe<Scalars["JSONObject"]["output"]>;
  operators?: Maybe<Array<Scalars["String"]["output"]>>;
  playerDetails?: Maybe<Scalars["JSONObject"]["output"]>;
  price?: Maybe<Scalars["Float"]["output"]>;
  slots?: Maybe<Array<PackSlot>>;
  summary?: Maybe<Scalars["String"]["output"]>;
  summaryTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  teamNameExcel?: Maybe<Scalars["String"]["output"]>;
  territory?: Maybe<Scalars["String"]["output"]>;
  type: PackTypes;
};

export type CreatePackCategoryInput = {
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  nameTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CreatePackInput = {
  category?: InputMaybe<Scalars["ObjectID"]["input"]>;
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  excludePlayers?: InputMaybe<Array<Scalars["ObjectID"]["input"]>>;
  fileType?: InputMaybe<Scalars["String"]["input"]>;
  idFromExcel?: InputMaybe<Scalars["String"]["input"]>;
  isDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFTUPack?: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  nameTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  nationality?: InputMaybe<Scalars["String"]["input"]>;
  operatorPackPrice?: InputMaybe<Scalars["JSONObject"]["input"]>;
  operatorPacks?: InputMaybe<Scalars["JSONObject"]["input"]>;
  operators?: InputMaybe<Array<Scalars["String"]["input"]>>;
  packPredefinedImageType?: InputMaybe<Scalars["String"]["input"]>;
  price?: InputMaybe<Scalars["Float"]["input"]>;
  slots?: InputMaybe<Array<PackSlotInput>>;
  summary?: InputMaybe<Scalars["String"]["input"]>;
  summaryTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  teamNameExcel?: InputMaybe<Scalars["String"]["input"]>;
  territory?: InputMaybe<Scalars["String"]["input"]>;
  type: PackTypes;
};

export type CreatePlayerCard = {
  __typename?: "CreatePlayerCard";
  _id: Scalars["ObjectID"]["output"];
  age?: Maybe<Scalars["Float"]["output"]>;
  attackRating: Scalars["Float"]["output"];
  cardBgId?: Maybe<Scalars["ObjectID"]["output"]>;
  cardImg?: Maybe<Scalars["String"]["output"]>;
  cardImgSm?: Maybe<Scalars["String"]["output"]>;
  club: Scalars["String"]["output"];
  clubId: Scalars["String"]["output"];
  clubShortCode: Scalars["String"]["output"];
  commonName?: Maybe<Scalars["String"]["output"]>;
  commonNameForename: Scalars["String"]["output"];
  commonNameSurname: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  creativityRating: Scalars["Float"]["output"];
  customSellPrice?: Maybe<Scalars["Int"]["output"]>;
  /** This is only sent on single card info fetch */
  defaultAvatarUrl?: Maybe<Scalars["String"]["output"]>;
  defenseRating: Scalars["Float"]["output"];
  detImg?: Maybe<Scalars["String"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  displayNameAbb?: Maybe<Scalars["String"]["output"]>;
  extraData?: Maybe<Scalars["JSONObject"]["output"]>;
  fullName: Scalars["String"]["output"];
  gender?: Maybe<GenderEnum>;
  height?: Maybe<Scalars["Float"]["output"]>;
  imageUploadUrl?: Maybe<Scalars["String"]["output"]>;
  isDisabled?: Maybe<Scalars["Boolean"]["output"]>;
  largeImageUrl?: Maybe<Scalars["String"]["output"]>;
  league?: Maybe<Scalars["String"]["output"]>;
  miniImageUploadUrl?: Maybe<Scalars["String"]["output"]>;
  nationality: Scalars["String"]["output"];
  nationalityImageUrl?: Maybe<Scalars["String"]["output"]>;
  overallRating: Scalars["Float"]["output"];
  playerId: Scalars["String"]["output"];
  preferredPosition: PlayerPositionEnum;
  rarity: CardRarityEnum;
  ratingTextColor?: Maybe<Scalars["String"]["output"]>;
  secondaryPosition1?: Maybe<PlayerPositionEnum>;
  secondaryPosition2?: Maybe<PlayerPositionEnum>;
  shirtNumber?: Maybe<Scalars["Int"]["output"]>;
  tags?: Maybe<Array<Scalars["String"]["output"]>>;
  template: Scalars["ObjectID"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  weight?: Maybe<Scalars["Float"]["output"]>;
};

export type CreatePlayerCardInput = {
  attackRating: Scalars["Float"]["input"];
  cardBgId?: InputMaybe<Scalars["ObjectID"]["input"]>;
  club: Scalars["String"]["input"];
  clubId: Scalars["String"]["input"];
  clubShortCode: Scalars["String"]["input"];
  commonNameForename: Scalars["String"]["input"];
  commonNameSurname: Scalars["String"]["input"];
  creativityRating: Scalars["Float"]["input"];
  customSellPrice?: InputMaybe<Scalars["Int"]["input"]>;
  defenseRating: Scalars["Float"]["input"];
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  displayNameAbb?: InputMaybe<Scalars["String"]["input"]>;
  extraData?: InputMaybe<Scalars["JSONObject"]["input"]>;
  /** This means that user is trying to upload actual image. If this is not sent then no image upload url will be returned */
  imageFileType?: InputMaybe<Scalars["String"]["input"]>;
  isDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** This means user is trying to upload mini image. If this is not sent then no image upload url will be returned */
  miniImageFileType?: InputMaybe<Scalars["String"]["input"]>;
  nationality: Scalars["String"]["input"];
  preferredPosition: PlayerPositionEnum;
  rarity: CardRarityEnum;
  ratingTextColor?: InputMaybe<Scalars["String"]["input"]>;
  secondaryPosition1?: InputMaybe<PlayerPositionEnum>;
  secondaryPosition2?: InputMaybe<PlayerPositionEnum>;
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  template: Scalars["ObjectID"]["input"];
  updateId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreatePlayerTemplateInput = {
  attackRating: Scalars["Float"]["input"];
  club: Scalars["String"]["input"];
  clubId: Scalars["String"]["input"];
  clubShortCode: Scalars["String"]["input"];
  commonName?: InputMaybe<Scalars["String"]["input"]>;
  commonNameForename: Scalars["String"]["input"];
  commonNameSurname: Scalars["String"]["input"];
  createdAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  creativityRating: Scalars["Float"]["input"];
  deactivated?: InputMaybe<Scalars["Boolean"]["input"]>;
  defaultAvatarUrl?: InputMaybe<Scalars["String"]["input"]>;
  defenseRating: Scalars["Float"]["input"];
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  displayNameAbb?: InputMaybe<Scalars["String"]["input"]>;
  fullName: Scalars["String"]["input"];
  gender?: InputMaybe<GenderEnum>;
  league?: InputMaybe<Scalars["String"]["input"]>;
  nationality: Scalars["String"]["input"];
  playerId: Scalars["String"]["input"];
  preferredPosition: PlayerPositionEnum;
  rarity?: InputMaybe<CardRarityEnum>;
  secondaryPosition1?: InputMaybe<PlayerPositionEnum>;
  secondaryPosition2?: InputMaybe<PlayerPositionEnum>;
  sentDate?: InputMaybe<Scalars["Date"]["input"]>;
  shirtNumber?: InputMaybe<Scalars["Int"]["input"]>;
  updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type CreatePositionInput = {
  backgroundColor: Scalars["String"]["input"];
  code: PlayerPositionEnum;
  name?: InputMaybe<Scalars["String"]["input"]>;
  textColor: Scalars["String"]["input"];
};

export type CreateQuickBet = {
  __typename?: "CreateQuickBet";
  _id: Scalars["ObjectID"]["output"];
  bets: Array<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  territory?: Maybe<Scalars["String"]["output"]>;
};

export type CreateQuickBetInput = {
  bets: Array<Scalars["Float"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  territory?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateSplashScreen = {
  __typename?: "CreateSplashScreen";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  bodyFontSize?: Maybe<Scalars["Int"]["output"]>;
  bodyTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  fileUploadUrl: Scalars["String"]["output"];
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  isBodyBold?: Maybe<Scalars["Boolean"]["output"]>;
  isTitleBold?: Maybe<Scalars["Boolean"]["output"]>;
  navigationPath: SplashScreenNavigationPathType;
  operators?: Maybe<Array<Scalars["String"]["output"]>>;
  title: Scalars["String"]["output"];
  titleFontSize?: Maybe<Scalars["Int"]["output"]>;
  titleTrans?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type CreateSplashScreenInput = {
  body: Scalars["String"]["input"];
  bodyFontSize?: InputMaybe<Scalars["Int"]["input"]>;
  bodyTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  fileType: Scalars["String"]["input"];
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isBodyBold?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTitleBold?: InputMaybe<Scalars["Boolean"]["input"]>;
  navigationPath: SplashScreenNavigationPathType;
  operators?: InputMaybe<Array<Scalars["String"]["input"]>>;
  title: Scalars["String"]["input"];
  titleFontSize?: InputMaybe<Scalars["Int"]["input"]>;
  titleTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
};

export type CreateStoreBanner = {
  __typename?: "CreateStoreBanner";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  bodyTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  fileUploadUrl: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  isBodyBold?: Maybe<Scalars["Boolean"]["output"]>;
  isTitleBold?: Maybe<Scalars["Boolean"]["output"]>;
  order?: Maybe<Scalars["Int"]["output"]>;
  territory?: Maybe<Scalars["String"]["output"]>;
  textColor: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  titleTrans?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type CreateStoreBannerInput = {
  body: Scalars["String"]["input"];
  bodyTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  fileType: Scalars["String"]["input"];
  isActive: Scalars["Boolean"]["input"];
  isBodyBold?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTitleBold?: InputMaybe<Scalars["Boolean"]["input"]>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
  territory?: InputMaybe<Scalars["String"]["input"]>;
  textColor: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
  titleTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
};

export type CreateStoreItemInput = {
  bonus?: InputMaybe<Scalars["Int"]["input"]>;
  bonusTxt?: InputMaybe<Scalars["String"]["input"]>;
  buyCoins?: InputMaybe<Scalars["Int"]["input"]>;
  buyPrice?: InputMaybe<Scalars["JSONObject"]["input"]>;
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  isDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPopular?: InputMaybe<Scalars["Boolean"]["input"]>;
  pbfCoin?: InputMaybe<Scalars["Int"]["input"]>;
  purchaseMethod: PurchaseMethodEnum;
  type: StoreItemTypeEnum;
};

export type CreateUpdateFatigueConfigInput = {
  activeOnDiv: Scalars["Int"]["input"];
  ovrReductionConf: Array<OvrReductionConfigDto>;
  staminaReductionConf: Array<StaminaReductionConfigDto>;
};

export type CreateUpdateTranslationsInput = {
  translations: Array<TranslationsInput>;
};

export type CreateUpdateWeeklyLeaderboardConfigInput = {
  divisionMultipliers: Scalars["JSONObject"]["input"];
  leagueConfig: Array<WeeklyLeaderboardConfigItemDto>;
  matchWinXP: Scalars["Float"]["input"];
  vaultXPMultiplier: Scalars["Float"]["input"];
};

export type CreateVaultRewardConfig = {
  __typename?: "CreateVaultRewardConfig";
  _id: Scalars["ObjectID"]["output"];
  level: Scalars["Int"]["output"];
  rewards: Array<VaultRewardDto>;
};

export type CreateVaultRewardConfigInput = {
  level: Scalars["Int"]["input"];
  rewards: Array<VaultRewardInput>;
};

export type DailyReward = {
  __typename?: "DailyReward";
  _id: Scalars["ObjectID"]["output"];
  awardType: DailyRewardTypeEnum;
  booster?: Maybe<Scalars["ObjectID"]["output"]>;
  boosterType?: Maybe<Scalars["String"]["output"]>;
  count?: Maybe<Scalars["Int"]["output"]>;
  day: Scalars["Int"]["output"];
  pack?: Maybe<Scalars["ObjectID"]["output"]>;
  packName?: Maybe<Scalars["String"]["output"]>;
  rewardHC?: Maybe<Scalars["Int"]["output"]>;
};

export type DailyRewardBoosters = {
  __typename?: "DailyRewardBoosters";
  _id: Scalars["ObjectID"]["output"];
  bonusPoints: Scalars["Int"]["output"];
  cost: Scalars["Int"]["output"];
  duration: Scalars["Int"]["output"];
  imageUrl: Scalars["String"]["output"];
  rarity: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type DailyRewardDto = {
  _id: Scalars["ObjectID"]["input"];
  awardType: DailyRewardTypeEnum;
  booster?: InputMaybe<Scalars["ObjectID"]["input"]>;
  boosterType?: InputMaybe<Scalars["String"]["input"]>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  day: Scalars["Int"]["input"];
  pack?: InputMaybe<Scalars["ObjectID"]["input"]>;
  packName?: InputMaybe<Scalars["String"]["input"]>;
  rewardHC?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DailyRewardItem = {
  __typename?: "DailyRewardItem";
  _id: Scalars["ObjectID"]["output"];
  awardType: DailyRewardTypeEnum;
  booster?: Maybe<DailyRewardBoosters>;
  day: Scalars["Int"]["output"];
  isClaimable: Scalars["Boolean"]["output"];
  isClaimed: Scalars["Boolean"]["output"];
  isExpired: Scalars["Boolean"]["output"];
  pack?: Maybe<DailyRewardPacks>;
  rewardHC?: Maybe<Scalars["Int"]["output"]>;
};

export type DailyRewardPacks = {
  __typename?: "DailyRewardPacks";
  _id: Scalars["ObjectID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  price: Scalars["Float"]["output"];
};

export enum DailyRewardTypeEnum {
  Booster = "BOOSTER",
  Coins = "COINS",
  Pack = "PACK",
}

export enum DateFilterEnum {
  Last7Days = "Last7Days",
  Last30Days = "Last30Days",
  Older = "Older",
  Today = "Today",
}

export type DeleteBanner = {
  __typename?: "DeleteBanner";
  message: Scalars["String"]["output"];
};

export type DeleteCardBg = {
  __typename?: "DeleteCardBg";
  message: Scalars["String"]["output"];
};

export type DeleteEosRewardConfig = {
  __typename?: "DeleteEOSRewardConfig";
  message: Scalars["String"]["output"];
};

export type DeleteNotification = {
  __typename?: "DeleteNotification";
  message: Scalars["String"]["output"];
};

export type DeletePack = {
  __typename?: "DeletePack";
  message: Scalars["String"]["output"];
};

export type DeletePackCategory = {
  __typename?: "DeletePackCategory";
  message: Scalars["String"]["output"];
};

export type DeletePlayerCard = {
  __typename?: "DeletePlayerCard";
  message: Scalars["String"]["output"];
};

export type DeleteQuickBet = {
  __typename?: "DeleteQuickBet";
  message: Scalars["String"]["output"];
};

export type DeleteSplashScreen = {
  __typename?: "DeleteSplashScreen";
  message: Scalars["String"]["output"];
};

export type DeleteStoreBanner = {
  __typename?: "DeleteStoreBanner";
  message: Scalars["String"]["output"];
};

export type DeleteStoreItem = {
  __typename?: "DeleteStoreItem";
  message: Scalars["String"]["output"];
};

export type DeleteVaultRewardConfig = {
  __typename?: "DeleteVaultRewardConfig";
  message: Scalars["String"]["output"];
};

export type EosRewardConfig = {
  __typename?: "EOSRewardConfig";
  _id: Scalars["ObjectID"]["output"];
  endPoints: Scalars["Int"]["output"];
  rewards: Array<TierReward>;
  startPoints: Scalars["Int"]["output"];
  tier: Scalars["Int"]["output"];
};

export type EosRewards = {
  __typename?: "EosRewards";
  coins: Scalars["Float"]["output"];
  rewardDet?: Maybe<Array<EosRewardsDet>>;
  rewardId?: Maybe<Scalars["String"]["output"]>;
};

export type EosRewardsDet = {
  __typename?: "EosRewardsDet";
  packId: Scalars["String"]["output"];
  packImageUrl?: Maybe<Scalars["String"]["output"]>;
  packName: Scalars["String"]["output"];
  rewardCount: Scalars["Int"]["output"];
};

export type FtuNationality = {
  __typename?: "FTUNationality";
  imageUrl: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type FtuResponse = {
  __typename?: "FTUResponse";
  autoName: Scalars["String"]["output"];
  badge: Scalars["String"]["output"];
  badgeUrl?: Maybe<Scalars["String"]["output"]>;
  kit: Scalars["String"]["output"];
  kitColor: Scalars["String"]["output"];
  kitColorDark?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  packImageUrl?: Maybe<Scalars["String"]["output"]>;
  packName: Scalars["String"]["output"];
  packSummary?: Maybe<Scalars["String"]["output"]>;
  players: Array<UserPlayerCard>;
  quickSellCoins?: Maybe<Scalars["Int"]["output"]>;
};

export type FtuUpdateInput = {
  country: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type FatigueConfig = {
  __typename?: "FatigueConfig";
  activeOnDiv: Scalars["Int"]["output"];
  ovrReductionConf: Array<OvrReductionConfig>;
  staminaReductionConf: Array<StaminaReductionConfig>;
};

export type FatigueConfigDto = {
  activeOnDiv: Scalars["Int"]["input"];
  ovrReductionConf: Array<OvrReductionConfigDto>;
  staminaReductionConf: Array<StaminaReductionConfigDto>;
};

export type FatigueRatingReductionConfig = {
  __typename?: "FatigueRatingReductionConfig";
  colorHex: Scalars["String"]["output"];
  maxStamina: Scalars["Int"]["output"];
  minStamina: Scalars["Int"]["output"];
  ovrReduction: Scalars["Int"]["output"];
  teamMaxStamina: Scalars["Int"]["output"];
  teamMinStamina: Scalars["Int"]["output"];
};

export type FatigueRatingReductionConfigList = {
  __typename?: "FatigueRatingReductionConfigList";
  fatigueRecoveryBoosterImg: Scalars["String"]["output"];
  list: Array<Maybe<FatigueRatingReductionConfig>>;
};

export type FinalResultOdds = {
  __typename?: "FinalResultOdds";
  data: Array<FinalResultOddsData>;
  name: Scalars["String"]["output"];
  type: BettingMarketsEnum;
};

export type FinalResultOddsData = {
  __typename?: "FinalResultOddsData";
  americanOdd: Scalars["String"]["output"];
  decimalOdd: Scalars["Float"]["output"];
  fractionalOdd: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  maxBet?: Maybe<Scalars["Float"]["output"]>;
  odd: Scalars["String"]["output"];
  payoutMultiplier: Scalars["Float"]["output"];
  win: WinEnum;
  xpBoostPercentage: Scalars["Float"]["output"];
};

export type FirstGoalscorerOdd = {
  __typename?: "FirstGoalscorerOdd";
  data: Scalars["JSONObject"]["output"];
  maxGoalTeamA: Scalars["Int"]["output"];
  maxGoalTeamB: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  type: BettingMarketsEnum;
};

export enum GenderEnum {
  F = "F",
  M = "M",
}

export type GetAllUserNotifications = {
  __typename?: "GetAllUserNotifications";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isRead: Scalars["Boolean"]["output"];
  liveDate?: Maybe<Scalars["Date"]["output"]>;
  title: Scalars["String"]["output"];
};

export type GetHomeBanners = {
  __typename?: "GetHomeBanners";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isActive: Scalars["Boolean"]["output"];
  isBodyBold?: Maybe<Scalars["Boolean"]["output"]>;
  isTitleBold?: Maybe<Scalars["Boolean"]["output"]>;
  navigationPath: NavigationPathType;
  title: Scalars["String"]["output"];
};

export type GetPbfCoinSummary = {
  __typename?: "GetPbfCoinSummary";
  limit: Scalars["Int"]["output"];
  overallSummary?: Maybe<ReportSummary>;
  page: Scalars["Int"]["output"];
  reportSummary?: Maybe<Array<ReportSummary>>;
};

export type GetPlatformRtp = {
  __typename?: "GetPlatformRtp";
  BTTS?: Maybe<Scalars["String"]["output"]>;
  CORRECT_SCORE?: Maybe<Scalars["String"]["output"]>;
  FINAL_RESULT?: Maybe<Scalars["String"]["output"]>;
  FIRST_GOAL_CORRECT_SCORE?: Maybe<Scalars["String"]["output"]>;
  FIRST_LAST_ANY_GOAL_SCORE?: Maybe<Scalars["String"]["output"]>;
  HANDICAPS?: Maybe<Scalars["String"]["output"]>;
  OVER_ALL?: Maybe<Scalars["String"]["output"]>;
  RESULT_BTTS?: Maybe<Scalars["String"]["output"]>;
  UNDER_OVER?: Maybe<Scalars["String"]["output"]>;
};

export type GetQuickBets = {
  __typename?: "GetQuickBets";
  bets: Array<Scalars["Float"]["output"]>;
};

export type GetSplashScreens = {
  __typename?: "GetSplashScreens";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  bodyFontSize?: Maybe<Scalars["Int"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isBodyBold?: Maybe<Scalars["Boolean"]["output"]>;
  isTitleBold?: Maybe<Scalars["Boolean"]["output"]>;
  navigationPath: SplashScreenNavigationPathType;
  title: Scalars["String"]["output"];
  titleFontSize?: Maybe<Scalars["Int"]["output"]>;
};

export type GetStoreBanners = {
  __typename?: "GetStoreBanners";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isActive: Scalars["Boolean"]["output"];
  isBodyBold?: Maybe<Scalars["Boolean"]["output"]>;
  isTitleBold?: Maybe<Scalars["Boolean"]["output"]>;
  title: Scalars["String"]["output"];
};

export type GetUnreadNotificationCount = {
  __typename?: "GetUnreadNotificationCount";
  unreadCount: Scalars["Int"]["output"];
};

export type GhostPlayerBoosterDetails = {
  __typename?: "GhostPlayerBoosterDetails";
  bonusPoints: Scalars["Int"]["output"];
  duration: Scalars["Int"]["output"];
  durationUsed?: Maybe<Scalars["Int"]["output"]>;
  rarity: Scalars["String"]["output"];
  type: BoosterType;
};

export type GlobalLeaderboard = {
  __typename?: "GlobalLeaderboard";
  globalLeaderboard?: Maybe<Array<LeaderboardEntry>>;
  userRanking?: Maybe<LeaderboardEntry>;
};

export type GoalScorer = {
  __typename?: "GoalScorer";
  _id: Scalars["ObjectID"]["output"];
  name: Scalars["String"]["output"];
  playerCardId?: Maybe<Scalars["String"]["output"]>;
  playerId: Scalars["String"]["output"];
  time: Scalars["Int"]["output"];
};

export type GoalScorerOdds = {
  __typename?: "GoalScorerOdds";
  data: Array<GoalScorerOddsData>;
  name: Scalars["String"]["output"];
  type: BettingMarketsEnum;
};

export type GoalScorerOddsData = {
  __typename?: "GoalScorerOddsData";
  any?: Maybe<OddsValues>;
  first?: Maybe<OddsValues>;
  last?: Maybe<OddsValues>;
  playerId?: Maybe<Scalars["String"]["output"]>;
  teamId?: Maybe<TeamIdEnum>;
};

export type GoalsUnderOverOdds = {
  __typename?: "GoalsUnderOverOdds";
  data: Scalars["JSONObject"]["output"];
  name: Scalars["String"]["output"];
  type: BettingMarketsEnum;
};

export type GroupedPacksDto = {
  __typename?: "GroupedPacksDTO";
  _id: Scalars["ObjectID"]["output"];
  name: Scalars["String"]["output"];
  packs: Array<StorePacks>;
};

export type HandicapOdds = {
  __typename?: "HandicapOdds";
  data: Array<HandicapOddsData>;
  name: Scalars["String"]["output"];
  type: BettingMarketsEnum;
};

export type HandicapOddsData = {
  __typename?: "HandicapOddsData";
  values: Array<HandicapOddsValues>;
  win: WinEnum;
};

export type HandicapOddsValues = {
  __typename?: "HandicapOddsValues";
  americanOdd: Scalars["String"]["output"];
  decimalOdd: Scalars["Float"]["output"];
  fractionalOdd: Scalars["String"]["output"];
  handicap: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  maxBet?: Maybe<Scalars["Float"]["output"]>;
  odd: Scalars["String"]["output"];
  payoutMultiplier: Scalars["Float"]["output"];
  xpBoostPercentage: Scalars["Float"]["output"];
};

export type InitResponse = {
  __typename?: "InitResponse";
  _id: Scalars["ObjectID"]["output"];
  autoTeamName?: Maybe<Scalars["String"]["output"]>;
  badge?: Maybe<Scalars["String"]["output"]>;
  badgeUrl?: Maybe<Scalars["String"]["output"]>;
  balance: Scalars["Float"]["output"];
  bankingUrl?: Maybe<Scalars["String"]["output"]>;
  beToken: Scalars["JWT"]["output"];
  brandId: Scalars["String"]["output"];
  coinPurchaseAllowed: Scalars["Boolean"]["output"];
  colorLogo?: Maybe<Scalars["String"]["output"]>;
  countryCode?: Maybe<Scalars["String"]["output"]>;
  countryImgUrl?: Maybe<Scalars["String"]["output"]>;
  countryName?: Maybe<Scalars["String"]["output"]>;
  currency: Scalars["String"]["output"];
  currencyDecimals?: Maybe<Scalars["Int"]["output"]>;
  currencyLang?: Maybe<Scalars["String"]["output"]>;
  currencyUseGrouping?: Maybe<Scalars["Boolean"]["output"]>;
  eosRewards?: Maybe<EosRewards>;
  extraData?: Maybe<Scalars["JSONObject"]["output"]>;
  genericJerseyPath?: Maybe<Scalars["String"]["output"]>;
  hideResetBtn: Scalars["Boolean"]["output"];
  isFTU: Scalars["Boolean"]["output"];
  isUnderMaintenance: Scalars["Boolean"]["output"];
  kit?: Maybe<Scalars["String"]["output"]>;
  kitColor?: Maybe<Scalars["String"]["output"]>;
  kitColorDark?: Maybe<Scalars["String"]["output"]>;
  language: Scalars["String"]["output"];
  leaderboardRewards?: Maybe<WeeklyLeaderboardRewards>;
  lobbyUrl?: Maybe<Scalars["String"]["output"]>;
  maxBet?: Maybe<Scalars["Float"]["output"]>;
  maxPayOut?: Maybe<Scalars["Float"]["output"]>;
  minBet?: Maybe<Scalars["Float"]["output"]>;
  operatorId: Scalars["String"]["output"];
  pbfCoin: Scalars["Float"]["output"];
  pendingDivRwPackImg?: Maybe<Scalars["String"]["output"]>;
  pendingDivisionResetReward?: Maybe<Scalars["String"]["output"]>;
  platformId: Scalars["String"]["output"];
  quickSwapPreferences?: Maybe<QuickSwapPreferences>;
  showEos?: Maybe<Scalars["Boolean"]["output"]>;
  showInitPayTable: Scalars["Boolean"]["output"];
  showOpenCloseBalance: Scalars["Boolean"]["output"];
  showRtpGameRules: Scalars["Boolean"]["output"];
  showWalletIcon: Scalars["Boolean"]["output"];
  showWinLoss: Scalars["Boolean"]["output"];
  underMaintenanceTitle?: Maybe<Scalars["String"]["output"]>;
  useAnalytics?: Maybe<Scalars["Boolean"]["output"]>;
  useCheat?: Maybe<Scalars["Boolean"]["output"]>;
  whiteLogo?: Maybe<Scalars["String"]["output"]>;
};

export type Languages = {
  __typename?: "Languages";
  _id: Scalars["ObjectID"]["output"];
  isoCode: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type LatestPlayerTemplatesRating = {
  __typename?: "LatestPlayerTemplatesRating";
  attackRating: Scalars["Float"]["output"];
  club: Scalars["String"]["output"];
  clubId: Scalars["String"]["output"];
  clubShortCode: Scalars["String"]["output"];
  commonName?: Maybe<Scalars["String"]["output"]>;
  commonNameForename: Scalars["String"]["output"];
  commonNameSurname: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  creativityRating: Scalars["Float"]["output"];
  deactivated?: Maybe<Scalars["Boolean"]["output"]>;
  defenseRating: Scalars["Float"]["output"];
  displayName?: Maybe<Scalars["String"]["output"]>;
  displayNameAbb?: Maybe<Scalars["String"]["output"]>;
  fullName: Scalars["String"]["output"];
  gender?: Maybe<GenderEnum>;
  league?: Maybe<Scalars["String"]["output"]>;
  nationality: Scalars["String"]["output"];
  playerId: Scalars["String"]["output"];
  primaryPosition: Scalars["String"]["output"];
  secondaryPosition1?: Maybe<Scalars["String"]["output"]>;
  secondaryPosition2?: Maybe<Scalars["String"]["output"]>;
  shirtNumber?: Maybe<Scalars["Int"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type LatestTfgPlayerRatingInput = {
  type?: InputMaybe<TfgRatingEnum>;
};

export type LeaderboardEntry = {
  __typename?: "LeaderboardEntry";
  countryCode?: Maybe<Scalars["String"]["output"]>;
  goldStars?: Maybe<Scalars["Float"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  ranking?: Maybe<Scalars["Float"]["output"]>;
  team: Scalars["JSONObject"]["output"];
  userId: Scalars["ObjectID"]["output"];
};

export type LeaderboardLeagueConfig = {
  __typename?: "LeaderboardLeagueConfig";
  demotionPositions: Array<Scalars["Int"]["output"]>;
  promotionPositions: Array<Scalars["Int"]["output"]>;
  rewards: Array<LeaderboardRewardConfig>;
};

export type LeaderboardLeagueConfigDto = {
  demotionPositions: Array<Scalars["Int"]["input"]>;
  promotionPositions: Array<Scalars["Int"]["input"]>;
  rewards: Array<LeaderboardRewardConfigDto>;
};

export type LeaderboardRewardConfig = {
  __typename?: "LeaderboardRewardConfig";
  rewardPack: Scalars["String"]["output"];
  rewardPackCount: Scalars["Int"]["output"];
};

export type LeaderboardRewardConfigDto = {
  rewardPack: Scalars["String"]["input"];
  rewardPackCount: Scalars["Int"]["input"];
};

export type LeaderboardRewards = {
  __typename?: "LeaderboardRewards";
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  packName?: Maybe<Scalars["String"]["output"]>;
  rewardId: Scalars["String"]["output"];
  rewardPackCount: Scalars["Int"]["output"];
};

export type LeagueConfig = {
  __typename?: "LeagueConfig";
  _id: Scalars["ObjectID"]["output"];
  ceilValue?: Maybe<Scalars["Int"]["output"]>;
  endOfCycleRewardAmt?: Maybe<Scalars["Float"]["output"]>;
  endOfCycleRewardPack?: Maybe<Scalars["ObjectID"]["output"]>;
  floorValue?: Maybe<Scalars["Int"]["output"]>;
  k1: Scalars["Float"]["output"];
  k2: Scalars["Float"]["output"];
  kWeights?: Maybe<Scalars["JSONObject"]["output"]>;
  kWeightsFe?: Maybe<Scalars["JSONObject"]["output"]>;
  milestones: Array<Milestones>;
  name: Scalars["String"]["output"];
  number: Scalars["Float"]["output"];
};

export type LeagueConfigDto = {
  _id: Scalars["ObjectID"]["input"];
  ceilValue?: InputMaybe<Scalars["Int"]["input"]>;
  endOfCycleRewardAmt?: InputMaybe<Scalars["Float"]["input"]>;
  endOfCycleRewardPack?: InputMaybe<Scalars["ObjectID"]["input"]>;
  floorValue?: InputMaybe<Scalars["Int"]["input"]>;
  k1: Scalars["Float"]["input"];
  k2: Scalars["Float"]["input"];
  kWeights?: InputMaybe<Scalars["JSONObject"]["input"]>;
  kWeightsFe?: InputMaybe<Scalars["JSONObject"]["input"]>;
  milestones: Array<MilestonesDto>;
  name: Scalars["String"]["input"];
  number: Scalars["Float"]["input"];
};

export type LeagueDistributionDto = {
  __typename?: "LeagueDistributionDTO";
  leagueNumber: Scalars["Int"]["output"];
  milestoneDistribution: Array<MilestoneDistributionDto>;
  percentage: Scalars["Int"]["output"];
};

export type LeagueStatisticsDto = {
  __typename?: "LeagueStatisticsDTO";
  distribution: Array<LeagueDistributionDto>;
};

export type LogoUploadUrl = {
  __typename?: "LogoUploadUrl";
  colorUrl: Scalars["String"]["output"];
  whiteUrl: Scalars["String"]["output"];
};

export type LogoUrls = {
  __typename?: "LogoUrls";
  color?: Maybe<Scalars["String"]["output"]>;
  white?: Maybe<Scalars["String"]["output"]>;
};

export enum Match_Events {
  Attack = "ATTACK",
  Corner = "CORNER",
  DangerousAttack = "DANGEROUS_ATTACK",
  FreeKick = "FREE_KICK",
  Goal = "GOAL",
  Penalty = "PENALTY",
  Possession = "POSSESSION",
  ShotSaved = "SHOT_SAVED",
  ShotWide = "SHOT_WIDE",
}

export type ManagerMutation = {
  __typename?: "ManagerMutation";
  bulkCreateBotTeams: CommonResult;
  bulkCreateUpdateManualPlayers: BulkOperationResult;
  bulkCreateUpdatePlayerCards: BulkOperationResult;
  bulkCreateUpdatePlayerTemplates: BulkOperationResult;
  bulkIgnorePlayerUpdates: Scalars["JSONObject"]["output"];
  bulkReadUpdate: Scalars["JSONObject"]["output"];
  bulkUpdateFtuePacks: CommonResult;
  clearLocalCache: CommonResult;
  createBanner: CreateBanner;
  createBoosters: CommonResult;
  createCardBg: CreateCardBg;
  createClub: Club;
  createDailyReward: DailyReward;
  createDuplicatePack: CreatePack;
  createEOSRewardConfig: EosRewardConfig;
  createLanguages: Scalars["JSONObject"]["output"];
  createLeagueConfig: LeagueConfig;
  createManualPlayer: CreatePlayerCard;
  createNotification: CreateNotification;
  createPack: CreatePack;
  createPackCategory: PackCategories;
  createPlayerCard: CreatePlayerCard;
  createPlayerTemplates: CommonResult;
  createPosition: Position;
  createQuickBet: CreateQuickBet;
  createSplashScreen: CreateSplashScreen;
  createStoreBanner: CreateStoreBanner;
  createUpdateFatigueConfig: FatigueConfig;
  createUpdateMiscConfig: MiscConfig;
  createUpdateTranslations: Scalars["JSONObject"]["output"];
  createUpdateWeeklyLeaderboardConfig: WeeklyLeaderboardConfig;
  createVaultRewardConfig: CreateVaultRewardConfig;
  deleteBanner: DeleteBanner;
  deleteCardBg: DeleteCardBg;
  deleteEOSRewardConfig: DeleteEosRewardConfig;
  deleteMiscConfig: Scalars["JSONObject"]["output"];
  deleteMiscConfigOperatorMargin: Array<MiscConfig>;
  deleteNotification: DeleteNotification;
  deletePack: DeletePack;
  deletePackCategory: DeletePackCategory;
  deletePlayerCard: DeletePlayerCard;
  deleteQuickBet: DeleteQuickBet;
  deleteSplashScreen: DeleteSplashScreen;
  deleteStoreBanner: DeleteStoreBanner;
  deleteVaultRewardConfig: DeleteVaultRewardConfig;
  enableDisableUnderMaintenance: Scalars["JSONObject"]["output"];
  getLogoUploadUrls: LogoUploadUrl;
  loadKWeights: Scalars["JSONObject"]["output"];
  reCalcTeamRatings: CommonResult;
  readUpdate: Scalars["JSONObject"]["output"];
  rebuildLeaderboard: Scalars["JSONObject"]["output"];
  refreshTeamNameCache: Scalars["JSONObject"]["output"];
  removeBotGhostTeam: CommonResult;
  removeFtuePacks: CommonResult;
  stopTeamRatingsReCalculation: CommonResult;
  updateBanner: UpdateBanner;
  updateBannerStatus: UpdateBannerStatus;
  updateBasePlayers: Scalars["JSONObject"]["output"];
  updateBooster: Boosters;
  updateCardBg: UpdateCardBg;
  updateClub: UpdateClub;
  updateDailyReward: DailyReward;
  updateEOSRewardConfig: EosRewardConfig;
  updateLanguages: Languages;
  updateLeagueConfig: LeagueConfig;
  updateLiveCurrencyRates: CommonResult;
  updateManualPlayer: CreatePlayerCard;
  updateMiscConfigOvrTwoCoin: MiscConfigOvrToCoin;
  updateNotification: UpdateNotification;
  updateNotificationStatus: UpdateNotificationStatus;
  updateOperatorVaultConfig: CommonResult;
  updatePack: CreatePack;
  updatePackCategory: PackCategories;
  updatePackCategoryStatus: UpdatePackCategoryStatus;
  updatePackStatus: UpdatePackStatus;
  updatePlayerCard: CreatePlayerCard;
  updatePlayerCardStatus: UpdatePlayerCardStatus;
  updatePosition: Position;
  updateQuickBet: UpdateQuickBet;
  updateSplashScreen: UpdateSplashScreen;
  updateSplashScreenStatus: UpdateSplashScreenStatus;
  updateStoreBanner: UpdateStoreBanner;
  updateStoreBannerStatus: UpdateStoreBannerStatus;
  updateVaultRewardConfig: UpdateVaultRewardConfig;
};

export type ManagerMutationBulkCreateBotTeamsArgs = {
  input: BulkCreateBotTeamsInput;
};

export type ManagerMutationBulkCreateUpdateManualPlayersArgs = {
  input: BulkManualPlayersAllFieldsArrayInput;
};

export type ManagerMutationBulkCreateUpdatePlayerCardsArgs = {
  input: BulkPlayerCardsAllFieldsArrayInput;
};

export type ManagerMutationBulkCreateUpdatePlayerTemplatesArgs = {
  input: BulkPlayerTemplatesArrayInput;
};

export type ManagerMutationBulkIgnorePlayerUpdatesArgs = {
  input: BulkIgnorePlayerUpdateInput;
};

export type ManagerMutationBulkReadUpdateArgs = {
  input: BulkPlayerUpdateInput;
};

export type ManagerMutationBulkUpdateFtuePacksArgs = {
  input: BulkUpdateFtuePackInput;
};

export type ManagerMutationClearLocalCacheArgs = {
  input: ClearLocalCacheInput;
};

export type ManagerMutationCreateBannerArgs = {
  input: CreateBannerInput;
};

export type ManagerMutationCreateBoostersArgs = {
  input: Array<CreateBoostersInput>;
};

export type ManagerMutationCreateCardBgArgs = {
  input: CreateCardBgInput;
};

export type ManagerMutationCreateClubArgs = {
  input: CreateClubInput;
};

export type ManagerMutationCreateDailyRewardArgs = {
  input: CreateDailyRewardInput;
};

export type ManagerMutationCreateDuplicatePackArgs = {
  packId: Scalars["String"]["input"];
};

export type ManagerMutationCreateEosRewardConfigArgs = {
  input: CreateEosRewardConfigInput;
};

export type ManagerMutationCreateLanguagesArgs = {
  input: Array<CreateLanguagesInput>;
};

export type ManagerMutationCreateLeagueConfigArgs = {
  input: CreateLeagueConfigInput;
};

export type ManagerMutationCreateManualPlayerArgs = {
  input: CreatePlayerCardInput;
};

export type ManagerMutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};

export type ManagerMutationCreatePackArgs = {
  input: CreatePackInput;
};

export type ManagerMutationCreatePackCategoryArgs = {
  input: CreatePackCategoryInput;
};

export type ManagerMutationCreatePlayerCardArgs = {
  input: CreatePlayerCardInput;
};

export type ManagerMutationCreatePlayerTemplatesArgs = {
  input: Array<CreatePlayerTemplateInput>;
};

export type ManagerMutationCreatePositionArgs = {
  input: CreatePositionInput;
};

export type ManagerMutationCreateQuickBetArgs = {
  input: CreateQuickBetInput;
};

export type ManagerMutationCreateSplashScreenArgs = {
  input: CreateSplashScreenInput;
};

export type ManagerMutationCreateStoreBannerArgs = {
  input: CreateStoreBannerInput;
};

export type ManagerMutationCreateUpdateFatigueConfigArgs = {
  input: CreateUpdateFatigueConfigInput;
};

export type ManagerMutationCreateUpdateMiscConfigArgs = {
  input: MiscConfigInput;
};

export type ManagerMutationCreateUpdateTranslationsArgs = {
  input: CreateUpdateTranslationsInput;
};

export type ManagerMutationCreateUpdateWeeklyLeaderboardConfigArgs = {
  input: CreateUpdateWeeklyLeaderboardConfigInput;
};

export type ManagerMutationCreateVaultRewardConfigArgs = {
  input: CreateVaultRewardConfigInput;
};

export type ManagerMutationDeleteBannerArgs = {
  bannerId: Scalars["String"]["input"];
};

export type ManagerMutationDeleteCardBgArgs = {
  cardBgId: Scalars["String"]["input"];
};

export type ManagerMutationDeleteEosRewardConfigArgs = {
  eosRewardConfigId: Scalars["String"]["input"];
};

export type ManagerMutationDeleteMiscConfigArgs = {
  id: Scalars["ObjectID"]["input"];
};

export type ManagerMutationDeleteMiscConfigOperatorMarginArgs = {
  keyId: Scalars["String"]["input"];
};

export type ManagerMutationDeleteNotificationArgs = {
  notificationId: Scalars["String"]["input"];
};

export type ManagerMutationDeletePackArgs = {
  packId: Scalars["String"]["input"];
};

export type ManagerMutationDeletePackCategoryArgs = {
  packCategoryId: Scalars["String"]["input"];
};

export type ManagerMutationDeletePlayerCardArgs = {
  cardId: Scalars["String"]["input"];
};

export type ManagerMutationDeleteQuickBetArgs = {
  quickBetId: Scalars["String"]["input"];
};

export type ManagerMutationDeleteSplashScreenArgs = {
  splashScreenId: Scalars["String"]["input"];
};

export type ManagerMutationDeleteStoreBannerArgs = {
  storeBannerId: Scalars["String"]["input"];
};

export type ManagerMutationDeleteVaultRewardConfigArgs = {
  vaultRewardConfigId: Scalars["String"]["input"];
};

export type ManagerMutationEnableDisableUnderMaintenanceArgs = {
  input: UnderMaintenanceModeInput;
};

export type ManagerMutationLoadKWeightsArgs = {
  base64File: Scalars["String"]["input"];
};

export type ManagerMutationReCalcTeamRatingsArgs = {
  input: ReCalculateTeamRatingsInput;
};

export type ManagerMutationReadUpdateArgs = {
  updateId: Scalars["String"]["input"];
};

export type ManagerMutationRemoveBotGhostTeamArgs = {
  input: RemoveBotGhostTeamInput;
};

export type ManagerMutationStopTeamRatingsReCalculationArgs = {
  input: StopReCalculateTeamRatingsInput;
};

export type ManagerMutationUpdateBannerArgs = {
  input: UpdateBannerInput;
};

export type ManagerMutationUpdateBannerStatusArgs = {
  bannerId: Scalars["String"]["input"];
};

export type ManagerMutationUpdateBoosterArgs = {
  input: UpdateBoosterInput;
};

export type ManagerMutationUpdateCardBgArgs = {
  input: UpdateCardBgInput;
};

export type ManagerMutationUpdateClubArgs = {
  input: UpdateClubInput;
};

export type ManagerMutationUpdateDailyRewardArgs = {
  input: UpdateDailyRewardInput;
};

export type ManagerMutationUpdateEosRewardConfigArgs = {
  input: UpdateEosRewardConfigInput;
};

export type ManagerMutationUpdateLanguagesArgs = {
  input: UpdateLanguagesInput;
};

export type ManagerMutationUpdateLeagueConfigArgs = {
  input: UpdateLeagueConfigInput;
};

export type ManagerMutationUpdateManualPlayerArgs = {
  input: UpdatePlayerCardInput;
};

export type ManagerMutationUpdateMiscConfigOvrTwoCoinArgs = {
  input: MiscConfigOvrToCoinInput;
};

export type ManagerMutationUpdateNotificationArgs = {
  input: UpdateNotificationInput;
};

export type ManagerMutationUpdateNotificationStatusArgs = {
  notificationId: Scalars["String"]["input"];
};

export type ManagerMutationUpdateOperatorVaultConfigArgs = {
  input: OperatorVaultConfigUpdateInput;
};

export type ManagerMutationUpdatePackArgs = {
  input: UpdatePackInput;
};

export type ManagerMutationUpdatePackCategoryArgs = {
  input: UpdatePackCategoryInput;
};

export type ManagerMutationUpdatePackCategoryStatusArgs = {
  packCategoryId: Scalars["String"]["input"];
};

export type ManagerMutationUpdatePackStatusArgs = {
  packId: Scalars["String"]["input"];
};

export type ManagerMutationUpdatePlayerCardArgs = {
  input: UpdatePlayerCardInput;
};

export type ManagerMutationUpdatePlayerCardStatusArgs = {
  cardId: Scalars["String"]["input"];
};

export type ManagerMutationUpdatePositionArgs = {
  input: UpdatePositionInput;
};

export type ManagerMutationUpdateQuickBetArgs = {
  input: UpdateQuickBetInput;
};

export type ManagerMutationUpdateSplashScreenArgs = {
  input: UpdateSplashScreenInput;
};

export type ManagerMutationUpdateSplashScreenStatusArgs = {
  splashScreenId: Scalars["String"]["input"];
};

export type ManagerMutationUpdateStoreBannerArgs = {
  input: UpdateStoreBannerInput;
};

export type ManagerMutationUpdateStoreBannerStatusArgs = {
  storeBannerId: Scalars["String"]["input"];
};

export type ManagerMutationUpdateVaultRewardConfigArgs = {
  input: UpdateVaultRewardConfigInput;
};

export type ManagerQuery = {
  __typename?: "ManagerQuery";
  allClubs: Array<Club>;
  allCountries: Array<Countries>;
  allPosition: Array<Position>;
  allTeamRatingsReCalculations: Array<AllTeamRatingsRecalculation>;
  getAllBanners: Array<Banner>;
  getAllBoosters: Array<Boosters>;
  getAllCardBgs: Array<CardBg>;
  getAllDailyReward: Array<DailyReward>;
  getAllEOSRewardConfigs: Array<EosRewardConfig>;
  getAllLanguages: Array<Languages>;
  getAllLeagueConfig: PaginatedLeagueConfig;
  getAllLogoUrls: LogoUrls;
  getAllManualPlayers: PaginatedPlayerCard;
  getAllMiscConfig: Array<MiscConfig>;
  getAllNotifications: PaginatedNotification;
  getAllPackCategories: Array<PackCategories>;
  getAllPacks: PaginatedPack;
  getAllPlayerCards: PaginatedPlayerCard;
  getAllQuickBets: PaginatedQuickBet;
  getAllSplashScreens: PaginatedSplashScreen;
  getAllStoreBanners: Array<StoreBanner>;
  getAllUsers: PaginatedAllUsers;
  getAllVaultRewardConfigs: PaginatedVaultRewardConfig;
  getBannerInfo: Banner;
  getCardBgInfo: CardBg;
  getClubInfo: Club;
  getDailyRewardInfo: DailyReward;
  getEOSRewardConfigById: EosRewardConfig;
  getFatigueConfig: FatigueConfig;
  getLeagueConfigInfo: LeagueConfig;
  getManualPlayerInfo: PlayerCard;
  getNotificationInfo: Notification;
  getPackInfo: PackInfo;
  getPackPredefinedImages: Array<PredefinedImages>;
  getPbfCoinSummary: GetPbfCoinSummary;
  getPlayerCardInfo: PlayerCard;
  getPlayerTemplates: PaginatedPlayerTemplate;
  getPositionInfo: Position;
  getQuickBetInfo: QuickBet;
  getSingleUser: AllUser;
  getSplashScreenInfo: SplashScreen;
  getStoreBannerInfo: StoreBanner;
  getTranslations: Array<Translations>;
  getVaultRewardConfigInfo: VaultRewardConfig;
  getWeeklyLeaderboardConfig: WeeklyLeaderboardConfig;
  latestTfgPlayerRating: Array<LatestPlayerTemplatesRating>;
  miscConfigOvrTwoCoinInfo: MiscConfigOvrToCoin;
  miscConfigSpecificObjectInfo: MiscConfigSpecificObjectInfo;
  packCategoryInfo: PackCategories;
  playerCardUpdates: PaginatedPlayerCardUpdate;
  playerOvrFormulas: PlayerOvrFormulas;
};

export type ManagerQueryGetAllBoostersArgs = {
  type?: InputMaybe<BoosterType>;
};

export type ManagerQueryGetAllLeagueConfigArgs = {
  limit?: Scalars["Int"]["input"];
  pageNo?: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ManagerQueryGetAllManualPlayersArgs = {
  club?: InputMaybe<Scalars["String"]["input"]>;
  excludeNew?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["String"]["input"]>>;
  limit?: Scalars["Int"]["input"];
  nationality?: InputMaybe<Scalars["String"]["input"]>;
  pageNo?: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ManagerQueryGetAllNotificationsArgs = {
  limit?: Scalars["Int"]["input"];
  pageNo?: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ManagerQueryGetAllPacksArgs = {
  limit?: Scalars["Int"]["input"];
  pageNo?: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ManagerQueryGetAllPlayerCardsArgs = {
  club?: InputMaybe<Scalars["String"]["input"]>;
  excludeNew?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["String"]["input"]>>;
  limit?: Scalars["Int"]["input"];
  nationality?: InputMaybe<Scalars["String"]["input"]>;
  pageNo?: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ManagerQueryGetAllQuickBetsArgs = {
  limit?: Scalars["Int"]["input"];
  pageNo?: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ManagerQueryGetAllSplashScreensArgs = {
  limit?: Scalars["Int"]["input"];
  pageNo?: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ManagerQueryGetAllUsersArgs = {
  limit?: Scalars["Int"]["input"];
  pageNo?: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  searchBy?: InputMaybe<UsersSearchBy>;
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ManagerQueryGetAllVaultRewardConfigsArgs = {
  level?: InputMaybe<Scalars["Float"]["input"]>;
  limit?: Scalars["Int"]["input"];
  pageNo?: Scalars["Int"]["input"];
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ManagerQueryGetBannerInfoArgs = {
  bannerId: Scalars["String"]["input"];
};

export type ManagerQueryGetCardBgInfoArgs = {
  cardBgId: Scalars["String"]["input"];
};

export type ManagerQueryGetClubInfoArgs = {
  clubId: Scalars["String"]["input"];
};

export type ManagerQueryGetDailyRewardInfoArgs = {
  dailyRewardId: Scalars["String"]["input"];
};

export type ManagerQueryGetEosRewardConfigByIdArgs = {
  eosRewardConfigId: Scalars["String"]["input"];
};

export type ManagerQueryGetLeagueConfigInfoArgs = {
  leagueConfigId: Scalars["String"]["input"];
};

export type ManagerQueryGetManualPlayerInfoArgs = {
  cardId: Scalars["String"]["input"];
};

export type ManagerQueryGetNotificationInfoArgs = {
  notificationId: Scalars["String"]["input"];
};

export type ManagerQueryGetPackInfoArgs = {
  packId: Scalars["String"]["input"];
};

export type ManagerQueryGetPbfCoinSummaryArgs = {
  endTime?: InputMaybe<Scalars["String"]["input"]>;
  groupByPlayerId?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: Scalars["Int"]["input"];
  pageNo?: Scalars["Int"]["input"];
  skipOverallSummary?: InputMaybe<Scalars["Boolean"]["input"]>;
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  skipReportSummary?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
  startTime?: InputMaybe<Scalars["String"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ManagerQueryGetPlayerCardInfoArgs = {
  cardId: Scalars["String"]["input"];
};

export type ManagerQueryGetPlayerTemplatesArgs = {
  club?: InputMaybe<Scalars["String"]["input"]>;
  limit?: Scalars["Int"]["input"];
  nationality?: InputMaybe<Scalars["String"]["input"]>;
  pageNo?: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ManagerQueryGetPositionInfoArgs = {
  positionId: Scalars["String"]["input"];
};

export type ManagerQueryGetQuickBetInfoArgs = {
  quickBetId: Scalars["String"]["input"];
};

export type ManagerQueryGetSingleUserArgs = {
  userId: Scalars["String"]["input"];
};

export type ManagerQueryGetSplashScreenInfoArgs = {
  splashScreenId: Scalars["String"]["input"];
};

export type ManagerQueryGetStoreBannerInfoArgs = {
  storeBannerId: Scalars["String"]["input"];
};

export type ManagerQueryGetTranslationsArgs = {
  isoCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type ManagerQueryGetVaultRewardConfigInfoArgs = {
  vaultRewardConfigId: Scalars["String"]["input"];
};

export type ManagerQueryLatestTfgPlayerRatingArgs = {
  args: LatestTfgPlayerRatingInput;
};

export type ManagerQueryMiscConfigSpecificObjectInfoArgs = {
  type: MiscConfigType;
};

export type ManagerQueryPackCategoryInfoArgs = {
  packCategoryId: Scalars["String"]["input"];
};

export type ManagerQueryPlayerCardUpdatesArgs = {
  club?: InputMaybe<Scalars["String"]["input"]>;
  excludeNew?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["String"]["input"]>>;
  limit?: Scalars["Int"]["input"];
  nationality?: InputMaybe<Scalars["String"]["input"]>;
  pageNo?: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type MarkNotificationsAsRead = {
  __typename?: "MarkNotificationsAsRead";
  message: Scalars["String"]["output"];
};

export type MarkNotificationsAsRemoved = {
  __typename?: "MarkNotificationsAsRemoved";
  message: Scalars["String"]["output"];
};

export type MarkSplashScreenAsRead = {
  __typename?: "MarkSplashScreenAsRead";
  message: Scalars["String"]["output"];
};

export type MatchCommonResult = {
  __typename?: "MatchCommonResult";
  data?: Maybe<Scalars["JSONObject"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
};

export type MatchDetails = {
  __typename?: "MatchDetails";
  matchId: Scalars["String"]["output"];
  matchStatus: MatchStatus;
  myTeam: MatchTeam;
  opponentTeam: BotGhostTeam;
};

export type MatchEvent = {
  __typename?: "MatchEvent";
  players: Array<Scalars["String"]["output"]>;
  team: TeamIdEnum;
  type: Match_Events;
};

export type MatchMiniPlayer = {
  __typename?: "MatchMiniPlayer";
  _id: Scalars["ObjectID"]["output"];
  attackRating: Scalars["Float"]["output"];
  currentPosition: PlayerPositionEnum;
  name: Scalars["String"]["output"];
  playerCardId?: Maybe<Scalars["String"]["output"]>;
  playerId: Scalars["String"]["output"];
  preferredPosition: PlayerPositionEnum;
  rarity: CardRarityEnum;
  teamId: TeamIdEnum;
};

export type MatchMutation = {
  __typename?: "MatchMutation";
  endMatch: MatchCommonResult;
  searchOpponent: SearchOpponent;
  startMatch: StartMatchResponse;
};

export type MatchQueries = {
  __typename?: "MatchQueries";
  lastMatchDetails?: Maybe<MatchDetails>;
  matchDetailsAdmin: MatchResult;
  matchDetailsByPlatformTxnId: MatchResult;
  matchResult: MatchResult;
};

export type MatchQueriesMatchDetailsAdminArgs = {
  matchId: Scalars["String"]["input"];
};

export type MatchQueriesMatchDetailsByPlatformTxnIdArgs = {
  platformTxnId: Scalars["String"]["input"];
};

export type MatchQueriesMatchResultArgs = {
  matchId: Scalars["String"]["input"];
};

export type MatchResult = {
  __typename?: "MatchResult";
  allPlayers: Array<MatchMiniPlayer>;
  bets: Array<MatchUserBets>;
  currentLeague?: Maybe<Scalars["Int"]["output"]>;
  currentMilestone?: Maybe<Scalars["Int"]["output"]>;
  currentStep?: Maybe<Scalars["Int"]["output"]>;
  endDate?: Maybe<Scalars["Date"]["output"]>;
  extraData?: Maybe<Scalars["JSONObject"]["output"]>;
  lastLeague?: Maybe<Scalars["Int"]["output"]>;
  lastMilestone?: Maybe<Scalars["Int"]["output"]>;
  lastStep?: Maybe<Scalars["Int"]["output"]>;
  leagueInfo?: Maybe<Scalars["JSONObject"]["output"]>;
  matchId: Scalars["String"]["output"];
  matchStatus?: Maybe<MatchStatus>;
  myTeam: MatchTeamMeta;
  myTeamGoalScorers?: Maybe<Array<GoalScorer>>;
  myTeamScore?: Maybe<Scalars["Int"]["output"]>;
  oppTeamGoalScorers?: Maybe<Array<GoalScorer>>;
  oppTeamScore?: Maybe<Scalars["Int"]["output"]>;
  opponentTeam: MatchTeamMeta;
  scorePickRNG?: Maybe<Scalars["Float"]["output"]>;
  startDate?: Maybe<Scalars["Date"]["output"]>;
  weeklyLeaderboardXP?: Maybe<Scalars["Float"]["output"]>;
};

export enum MatchStatus {
  MatchCompleted = "MATCH_COMPLETED",
  MatchDiscarded = "MATCH_DISCARDED",
  MatchStarted = "MATCH_STARTED",
  SelectingOdds = "SELECTING_ODDS",
}

export type MatchTeam = {
  __typename?: "MatchTeam";
  _id?: Maybe<Scalars["ObjectID"]["output"]>;
  attackRating?: Maybe<Scalars["Float"]["output"]>;
  autoName?: Maybe<Scalars["String"]["output"]>;
  badge: Scalars["String"]["output"];
  badgeUrl?: Maybe<Scalars["String"]["output"]>;
  chemistry?: Maybe<Scalars["Int"]["output"]>;
  creativityRating?: Maybe<Scalars["Float"]["output"]>;
  defenseRating?: Maybe<Scalars["Float"]["output"]>;
  isBot?: Maybe<Scalars["Boolean"]["output"]>;
  kit: Scalars["String"]["output"];
  kitColor: Scalars["String"]["output"];
  kitColorDark?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  overallRating?: Maybe<Scalars["Float"]["output"]>;
  players?: Maybe<Array<MatchTeamPlayer>>;
  user?: Maybe<Scalars["ObjectID"]["output"]>;
};

export type MatchTeamMeta = {
  __typename?: "MatchTeamMeta";
  _id?: Maybe<Scalars["ObjectID"]["output"]>;
  attackRating?: Maybe<Scalars["Float"]["output"]>;
  autoName?: Maybe<Scalars["String"]["output"]>;
  badge: Scalars["String"]["output"];
  badgeUrl?: Maybe<Scalars["String"]["output"]>;
  chemistry?: Maybe<Scalars["Int"]["output"]>;
  creativityRating?: Maybe<Scalars["Float"]["output"]>;
  defenseRating?: Maybe<Scalars["Float"]["output"]>;
  isBot?: Maybe<Scalars["Boolean"]["output"]>;
  kit: Scalars["String"]["output"];
  kitColor: Scalars["String"]["output"];
  kitColorDark?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  overallRating?: Maybe<Scalars["Float"]["output"]>;
  user?: Maybe<Scalars["ObjectID"]["output"]>;
};

export type MatchTeamPlayer = {
  __typename?: "MatchTeamPlayer";
  _id: Scalars["ObjectID"]["output"];
  attackRating: Scalars["Float"]["output"];
  cardImg?: Maybe<Scalars["String"]["output"]>;
  cardImgSm?: Maybe<Scalars["String"]["output"]>;
  club: Scalars["String"]["output"];
  clubId: Scalars["String"]["output"];
  commonName?: Maybe<Scalars["String"]["output"]>;
  commonNameForename: Scalars["String"]["output"];
  commonNameSurname: Scalars["String"]["output"];
  creativityRating: Scalars["Float"]["output"];
  currentPosition: PlayerPositionEnum;
  defenseRating: Scalars["Float"]["output"];
  detImg?: Maybe<Scalars["String"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  displayNameAbb?: Maybe<Scalars["String"]["output"]>;
  extraData?: Maybe<Scalars["JSONObject"]["output"]>;
  fullName: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  largeImageUrl?: Maybe<Scalars["String"]["output"]>;
  miniImageUrl?: Maybe<Scalars["String"]["output"]>;
  nationality: Scalars["String"]["output"];
  nationalityImageUrl?: Maybe<Scalars["String"]["output"]>;
  overallRating: Scalars["Float"]["output"];
  playerId: Scalars["String"]["output"];
  preferredPosition: PlayerPositionEnum;
  rarity: CardRarityEnum;
  shirtNumber?: Maybe<Scalars["Int"]["output"]>;
};

export type MatchUserBetOddDetails = {
  __typename?: "MatchUserBetOddDetails";
  goals?: Maybe<Scalars["Float"]["output"]>;
  handicap?: Maybe<Scalars["Float"]["output"]>;
  playerId?: Maybe<Scalars["BigInt"]["output"]>;
  team1?: Maybe<Scalars["Int"]["output"]>;
  team2?: Maybe<Scalars["Int"]["output"]>;
  teamId?: Maybe<TeamIdEnum>;
  type?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<YesNoEnum>;
  win?: Maybe<WinEnum>;
  xpBoostPercentage: Scalars["Float"]["output"];
};

export type MatchUserBets = {
  __typename?: "MatchUserBets";
  americanOdd: Scalars["String"]["output"];
  betAmount?: Maybe<Scalars["Float"]["output"]>;
  betId: Scalars["String"]["output"];
  betPlacedAt?: Maybe<Scalars["Date"]["output"]>;
  betStatus: BetStatus;
  createdAt: Scalars["Date"]["output"];
  currency?: Maybe<Scalars["String"]["output"]>;
  decimalOdd: Scalars["Float"]["output"];
  fractionalOdd: Scalars["String"]["output"];
  isResolved: Scalars["Boolean"]["output"];
  marketName: Scalars["String"]["output"];
  marketType: BettingMarketsEnum;
  odd: Scalars["String"]["output"];
  oddId: Scalars["String"]["output"];
  oddsDetails: MatchUserBetOddDetails;
  payoutMultiplier?: Maybe<Scalars["Float"]["output"]>;
  platformTransactionId?: Maybe<Scalars["String"]["output"]>;
  toReturn?: Maybe<Scalars["Float"]["output"]>;
  winAmount?: Maybe<Scalars["Float"]["output"]>;
  xp: Scalars["Float"]["output"];
  xpBoostPercentage: Scalars["Float"]["output"];
};

export type MilestoneDistributionDto = {
  __typename?: "MilestoneDistributionDTO";
  milestoneNumber: Scalars["Int"]["output"];
  percentage: Scalars["Int"]["output"];
};

export type Milestones = {
  __typename?: "Milestones";
  _id: Scalars["ObjectID"]["output"];
  descText?: Maybe<Scalars["String"]["output"]>;
  descTextTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  k1?: Maybe<Scalars["Float"]["output"]>;
  k2?: Maybe<Scalars["Float"]["output"]>;
  number: Scalars["Float"]["output"];
  rewardCoins?: Maybe<Scalars["Float"]["output"]>;
  rewardPack?: Maybe<Scalars["ObjectID"]["output"]>;
  rewardPackCount?: Maybe<Scalars["Float"]["output"]>;
  steps: Scalars["Float"]["output"];
};

export type MilestonesDto = {
  _id: Scalars["ObjectID"]["input"];
  descText?: InputMaybe<Scalars["String"]["input"]>;
  descTextTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  k1?: InputMaybe<Scalars["Float"]["input"]>;
  k2?: InputMaybe<Scalars["Float"]["input"]>;
  number: Scalars["Float"]["input"];
  rewardCoins?: InputMaybe<Scalars["Float"]["input"]>;
  rewardPack?: InputMaybe<Scalars["ObjectID"]["input"]>;
  rewardPackCount?: InputMaybe<Scalars["Float"]["input"]>;
  steps: Scalars["Float"]["input"];
};

export type MiniPlayer = {
  __typename?: "MiniPlayer";
  _id: Scalars["ObjectID"]["output"];
  attackRating: Scalars["Float"]["output"];
  currentPosition: PlayerPositionEnum;
  name: Scalars["String"]["output"];
  playerCardId?: Maybe<Scalars["String"]["output"]>;
  playerId: Scalars["String"]["output"];
  preferredPosition: PlayerPositionEnum;
  rarity: CardRarityEnum;
  teamId: TeamIdEnum;
};

export type MiscConfig = {
  __typename?: "MiscConfig";
  _id: Scalars["ObjectID"]["output"];
  data: Scalars["JSONObject"]["output"];
  type: MiscConfigType;
};

export type MiscConfigInput = {
  data: Scalars["JSONObject"]["input"];
  specificKey?: InputMaybe<Scalars["String"]["input"]>;
  type: MiscConfigType;
};

export type MiscConfigOvrToCoin = {
  __typename?: "MiscConfigOvrToCoin";
  ovrTwoCoinValues: Scalars["JSONObject"]["output"];
};

export type MiscConfigOvrToCoinInput = {
  ovrTwoCoinValues: Scalars["JSONObject"]["input"];
};

export type MiscConfigSpecificObjectInfo = {
  __typename?: "MiscConfigSpecificObjectInfo";
  data: Scalars["JSONObject"]["output"];
};

export enum MiscConfigType {
  CheatConfig = "CHEAT_CONFIG",
  ClubColors = "CLUB_COLORS",
  DefaultOddDisplayFormats = "DEFAULT_ODD_DISPLAY_FORMATS",
  DefaultQuickBets = "DEFAULT_QUICK_BETS",
  DefaultXpPerStakeUnit = "DEFAULT_XP_PER_STAKE_UNIT",
  ExternalDataProviders = "EXTERNAL_DATA_PROVIDERS",
  FatigueConfig = "FATIGUE_CONFIG",
  FtueMatchOvrDiff = "FTUE_MATCH_OVR_DIFF",
  FtuNationality = "FTU_NATIONALITY",
  HideResetBtn = "HIDE_RESET_BTN",
  IsCurrTmPlyrSell = "IS_CURR_TM_PLYR_SELL",
  MaxBoosterApplyLimit = "MAX_BOOSTER_APPLY_LIMIT",
  MmGhostTeamDays = "MM_GHOST_TEAM_DAYS",
  OpeningClosingBalance = "OPENING_CLOSING_BALANCE",
  OperatorMargins = "OPERATOR_MARGINS",
  OperatorRtp = "OPERATOR_RTP",
  Ovr_2Coins = "OVR_2_COINS",
  PackPredefinedImages = "PACK_PREDEFINED_IMAGES",
  PositionColors = "POSITION_COLORS",
  QuickSwapConfig = "QUICK_SWAP_CONFIG",
  SeasonPointConfig = "SEASON_POINT_CONFIG",
  ShowInitialPaytable = "SHOW_INITIAL_PAYTABLE",
  UnderMaintenance = "UNDER_MAINTENANCE",
  UseGoogleAnalytics = "USE_GOOGLE_ANALYTICS",
  VaultConfiguration = "VAULT_CONFIGURATION",
  VoidCheckDelayTime = "VOID_CHECK_DELAY_TIME",
  WeeklyLeaderboardConfig = "WEEKLY_LEADERBOARD_CONFIG",
}

export type Mutation = {
  __typename?: "Mutation";
  manager: ManagerMutation;
  match: MatchMutation;
  players: PlayerMutation;
  teamManager: TeamManagerMutation;
};

export type MyBetsResponse = {
  __typename?: "MyBetsResponse";
  allPlayers: Array<MiniPlayer>;
  bets: Array<UserBets>;
  closingBalance?: Maybe<Scalars["Float"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  matchId: Scalars["String"]["output"];
  matchStatus: MatchStatus;
  myTeamName: Scalars["String"]["output"];
  myTeamScore: Scalars["Int"]["output"];
  openingBalance?: Maybe<Scalars["Float"]["output"]>;
  oppTeamScore: Scalars["Int"]["output"];
  opponentTeamName: Scalars["String"]["output"];
};

export type MyTeam = {
  __typename?: "MyTeam";
  attackRating?: Maybe<Scalars["Float"]["output"]>;
  badge: Scalars["String"]["output"];
  badgeUrl?: Maybe<Scalars["String"]["output"]>;
  chemistry?: Maybe<Scalars["Int"]["output"]>;
  chemistryPercentage?: Maybe<Scalars["Int"]["output"]>;
  creativityRating?: Maybe<Scalars["Float"]["output"]>;
  defenseRating?: Maybe<Scalars["Float"]["output"]>;
  formation?: Maybe<Scalars["String"]["output"]>;
  kit: Scalars["String"]["output"];
  kitColor: Scalars["String"]["output"];
  kitColorDark?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  overallRating?: Maybe<Scalars["Float"]["output"]>;
  players?: Maybe<Array<Maybe<UserPlayerCard>>>;
  stamina?: Maybe<Scalars["Int"]["output"]>;
};

export enum NavigationPathType {
  Store = "STORE",
}

export type Notification = {
  __typename?: "Notification";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  bodyTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  liveDate?: Maybe<Scalars["Date"]["output"]>;
  operators?: Maybe<Array<Scalars["String"]["output"]>>;
  territory?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  titleTrans?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type OvrReductionConfig = {
  __typename?: "OVRReductionConfig";
  colorHex: Scalars["String"]["output"];
  maxStamina: Scalars["Int"]["output"];
  minStamina: Scalars["Int"]["output"];
  ovrReduction: Scalars["Int"]["output"];
  teamMaxStamina: Scalars["Int"]["output"];
  teamMinStamina: Scalars["Int"]["output"];
};

export type OvrReductionConfigDto = {
  colorHex: Scalars["String"]["input"];
  maxStamina: Scalars["Int"]["input"];
  minStamina: Scalars["Int"]["input"];
  ovrReduction: Scalars["Int"]["input"];
  teamMaxStamina: Scalars["Int"]["input"];
  teamMinStamina: Scalars["Int"]["input"];
};

export type Odds = {
  __typename?: "Odds";
  _id: Scalars["ObjectID"]["output"];
  allPlayers: Array<MiniPlayer>;
  btts: BttsOdds;
  correctScore: CorrectScoreOdds;
  finalResult: FinalResultOdds;
  firstGoalscorer?: Maybe<FirstGoalscorerOdd>;
  goalsUnderOver: GoalsUnderOverOdds;
  goalscorerOdds: GoalScorerOdds;
  handicaps: HandicapOdds;
  matchId: Scalars["String"]["output"];
  resultBtts: ResultBttsOdds;
  teamA: PlayersTeamMeta;
  teamB: PlayersTeamMeta;
  xpToAward: Scalars["Float"]["output"];
};

export enum OddsDisplayEnum {
  American = "American",
  Decimal = "Decimal",
  Fractional = "Fractional",
}

export type OddsValues = {
  __typename?: "OddsValues";
  americanOdd: Scalars["String"]["output"];
  decimalOdd: Scalars["Float"]["output"];
  fractionalOdd: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  maxBet?: Maybe<Scalars["Float"]["output"]>;
  odd: Scalars["String"]["output"];
  payoutMultiplier: Scalars["Float"]["output"];
  xpBoostPercentage: Scalars["Float"]["output"];
};

export type OperatorVaultConfigUpdateInput = {
  baseXP?: InputMaybe<Scalars["Int"]["input"]>;
  growthRate?: InputMaybe<Scalars["Float"]["input"]>;
  operatorId: Scalars["String"]["input"];
};

export type OptedOutQuickSwapAction = {
  __typename?: "OptedOutQuickSwapAction";
  message: Scalars["String"]["output"];
};

export enum Play_Category {
  CornerKick = "CORNER_KICK",
  Counterattack = "COUNTERATTACK",
  DangerousTurnover = "DANGEROUS_TURNOVER",
  FreeKick = "FREE_KICK",
  PenaltyKick = "PENALTY_KICK",
  TraditionalBuildUp = "TRADITIONAL_BUILD_UP",
}

export type Pack = {
  __typename?: "Pack";
  _id: Scalars["ObjectID"]["output"];
  category?: Maybe<Scalars["ObjectID"]["output"]>;
  excludePlayers?: Maybe<Array<Scalars["ObjectID"]["output"]>>;
  idFromExcel?: Maybe<Scalars["String"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isDisabled?: Maybe<Scalars["Boolean"]["output"]>;
  isFTUPack: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  nameTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  nationality?: Maybe<Scalars["String"]["output"]>;
  operatorPackPrice?: Maybe<Scalars["JSONObject"]["output"]>;
  operatorPacks?: Maybe<Scalars["JSONObject"]["output"]>;
  operators?: Maybe<Array<Scalars["String"]["output"]>>;
  price?: Maybe<Scalars["Float"]["output"]>;
  slots?: Maybe<Array<PackSlot>>;
  summary?: Maybe<Scalars["String"]["output"]>;
  summaryTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  teamNameExcel?: Maybe<Scalars["String"]["output"]>;
  territory?: Maybe<Scalars["String"]["output"]>;
  type: PackTypes;
};

export type PackCategories = {
  __typename?: "PackCategories";
  _id: Scalars["ObjectID"]["output"];
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  nameTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  order?: Maybe<Scalars["Int"]["output"]>;
};

export type PackInfo = {
  __typename?: "PackInfo";
  _id: Scalars["ObjectID"]["output"];
  category?: Maybe<Scalars["ObjectID"]["output"]>;
  excludePlayers?: Maybe<Array<Scalars["ObjectID"]["output"]>>;
  idFromExcel?: Maybe<Scalars["String"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isDisabled?: Maybe<Scalars["Boolean"]["output"]>;
  isFTUPack: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  nameTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  nationality?: Maybe<Scalars["String"]["output"]>;
  operatorPackPrice?: Maybe<Scalars["JSONObject"]["output"]>;
  operatorPacks?: Maybe<Scalars["JSONObject"]["output"]>;
  operators?: Maybe<Array<Scalars["String"]["output"]>>;
  playerDetails?: Maybe<Scalars["JSONObject"]["output"]>;
  price?: Maybe<Scalars["Float"]["output"]>;
  slots?: Maybe<Array<PackSlot>>;
  summary?: Maybe<Scalars["String"]["output"]>;
  summaryTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  teamNameExcel?: Maybe<Scalars["String"]["output"]>;
  territory?: Maybe<Scalars["String"]["output"]>;
  type: PackTypes;
};

export type PackSlot = {
  __typename?: "PackSlot";
  amount?: Maybe<Scalars["Float"]["output"]>;
  boosterProbabilities?: Maybe<Array<SlotBoosterProbability>>;
  dropProbabilities?: Maybe<Array<SlotDropProbability>>;
  playerCard?: Maybe<Scalars["ObjectID"]["output"]>;
  playerPool?: Maybe<Array<PlayerPoolDropProbability>>;
  playerPosition?: Maybe<Array<PlayerPositionEnum>>;
  tags?: Maybe<Array<Scalars["String"]["output"]>>;
  type: PackSlotTypes;
};

export type PackSlotInput = {
  amount?: InputMaybe<Scalars["Float"]["input"]>;
  boosterProbabilities?: InputMaybe<Array<SlotBoosterProbabilityInput>>;
  dropProbabilities?: InputMaybe<Array<SlotDropProbabilityInput>>;
  playerCard?: InputMaybe<Scalars["ObjectID"]["input"]>;
  playerPool?: InputMaybe<Array<PlayerPoolDropProbabilityInput>>;
  playerPosition?: InputMaybe<Array<PlayerPositionEnum>>;
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  type: PackSlotTypes;
};

export enum PackSlotTypes {
  Booster = "Booster",
  Currency = "Currency",
  NamedPlayer = "NamedPlayer",
  Player = "Player",
  PlayerMixed = "PlayerMixed",
  PlayerPool = "PlayerPool",
}

export enum PackTypes {
  Reward = "Reward",
  Store = "Store",
}

export type PaginatedAllUsers = {
  __typename?: "PaginatedAllUsers";
  items: Array<AllUser>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PaginatedCoinHistoryResponse = {
  __typename?: "PaginatedCoinHistoryResponse";
  items: Array<CoinHistoryResponse>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PaginatedLeagueConfig = {
  __typename?: "PaginatedLeagueConfig";
  items: Array<LeagueConfig>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PaginatedMyBetResponse = {
  __typename?: "PaginatedMyBetResponse";
  items: Array<MyBetsResponse>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PaginatedNotification = {
  __typename?: "PaginatedNotification";
  items: Array<Notification>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PaginatedPack = {
  __typename?: "PaginatedPack";
  items: Array<Pack>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PaginatedPlayerCard = {
  __typename?: "PaginatedPlayerCard";
  items: Array<PlayerCard>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PaginatedPlayerCardUpdate = {
  __typename?: "PaginatedPlayerCardUpdate";
  items: Array<PlayerCardUpdate>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PaginatedPlayerTemplate = {
  __typename?: "PaginatedPlayerTemplate";
  items: Array<PlayerTemplate>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PaginatedQuickBet = {
  __typename?: "PaginatedQuickBet";
  items: Array<QuickBet>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PaginatedSplashScreen = {
  __typename?: "PaginatedSplashScreen";
  items: Array<SplashScreen>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PaginatedStoreItem = {
  __typename?: "PaginatedStoreItem";
  items: Array<StoreItem>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PaginatedUserPlayerCard = {
  __typename?: "PaginatedUserPlayerCard";
  items: Array<UserPlayerCard>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PaginatedVaultRewardConfig = {
  __typename?: "PaginatedVaultRewardConfig";
  items: Array<VaultRewardConfig>;
  morePages?: Maybe<Scalars["Boolean"]["output"]>;
  totalItems?: Maybe<Scalars["BigInt"]["output"]>;
  totalPages?: Maybe<Scalars["BigInt"]["output"]>;
};

export type PlaceBetResponse = {
  __typename?: "PlaceBetResponse";
  availableSpins: Scalars["Float"]["output"];
  bets: Array<UserBets>;
  currentVaultLevel: Scalars["Float"]["output"];
  currentXP: Scalars["Float"]["output"];
  isNewVault?: Maybe<Scalars["Boolean"]["output"]>;
  lastCurrentXP: Scalars["Float"]["output"];
  lastVaultLevel: Scalars["Float"]["output"];
  progressUpdates: Array<VaultProgressUpdate>;
  spinDetails: Array<SpinDetails>;
  totalXp: Scalars["Float"]["output"];
  xpNeededForLevel: Scalars["Float"]["output"];
  xpToNextLevel: Scalars["Float"]["output"];
};

export type PlayerCard = {
  __typename?: "PlayerCard";
  _id: Scalars["ObjectID"]["output"];
  age?: Maybe<Scalars["Float"]["output"]>;
  attackRating: Scalars["Float"]["output"];
  cardBgId?: Maybe<Scalars["ObjectID"]["output"]>;
  cardImg?: Maybe<Scalars["String"]["output"]>;
  cardImgSm?: Maybe<Scalars["String"]["output"]>;
  club: Scalars["String"]["output"];
  clubId: Scalars["String"]["output"];
  clubShortCode: Scalars["String"]["output"];
  commonName?: Maybe<Scalars["String"]["output"]>;
  commonNameForename: Scalars["String"]["output"];
  commonNameSurname: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  creativityRating: Scalars["Float"]["output"];
  customSellPrice?: Maybe<Scalars["Int"]["output"]>;
  /** This is only sent on single card info fetch */
  defaultAvatarUrl?: Maybe<Scalars["String"]["output"]>;
  defenseRating: Scalars["Float"]["output"];
  detImg?: Maybe<Scalars["String"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  displayNameAbb?: Maybe<Scalars["String"]["output"]>;
  extraData?: Maybe<Scalars["JSONObject"]["output"]>;
  fullName: Scalars["String"]["output"];
  gender?: Maybe<GenderEnum>;
  height?: Maybe<Scalars["Float"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isDisabled?: Maybe<Scalars["Boolean"]["output"]>;
  largeImageUrl?: Maybe<Scalars["String"]["output"]>;
  league?: Maybe<Scalars["String"]["output"]>;
  miniImageUrl?: Maybe<Scalars["String"]["output"]>;
  nationality: Scalars["String"]["output"];
  nationalityImageUrl?: Maybe<Scalars["String"]["output"]>;
  overallRating: Scalars["Float"]["output"];
  playerId: Scalars["String"]["output"];
  preferredPosition: PlayerPositionEnum;
  rarity: CardRarityEnum;
  ratingTextColor?: Maybe<Scalars["String"]["output"]>;
  secondaryPosition1?: Maybe<PlayerPositionEnum>;
  secondaryPosition2?: Maybe<PlayerPositionEnum>;
  shirtNumber?: Maybe<Scalars["Int"]["output"]>;
  tags?: Maybe<Array<Scalars["String"]["output"]>>;
  template: Scalars["ObjectID"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  weight?: Maybe<Scalars["Float"]["output"]>;
};

export type PlayerCardInfo = {
  __typename?: "PlayerCardInfo";
  _id: Scalars["ObjectID"]["output"];
  attackRating: Scalars["Float"]["output"];
  cardImg?: Maybe<Scalars["String"]["output"]>;
  cardImgSm?: Maybe<Scalars["String"]["output"]>;
  club: Scalars["String"]["output"];
  clubId: Scalars["String"]["output"];
  commonName?: Maybe<Scalars["String"]["output"]>;
  commonNameForename: Scalars["String"]["output"];
  commonNameSurname: Scalars["String"]["output"];
  creativityRating: Scalars["Float"]["output"];
  currentPosition: PlayerPositionEnum;
  defenseRating: Scalars["Float"]["output"];
  detImg?: Maybe<Scalars["String"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  displayNameAbb?: Maybe<Scalars["String"]["output"]>;
  extraData?: Maybe<Scalars["JSONObject"]["output"]>;
  fullName: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  largeImageUrl?: Maybe<Scalars["String"]["output"]>;
  miniImageUrl?: Maybe<Scalars["String"]["output"]>;
  nationality: Scalars["String"]["output"];
  nationalityImageUrl?: Maybe<Scalars["String"]["output"]>;
  overallRating: Scalars["Float"]["output"];
  playerId: Scalars["String"]["output"];
  preferredPosition: PlayerPositionEnum;
  rarity: CardRarityEnum;
  shirtNumber?: Maybe<Scalars["Int"]["output"]>;
};

export type PlayerCardUpdate = {
  __typename?: "PlayerCardUpdate";
  _id: Scalars["ObjectID"]["output"];
  attackRating: Scalars["Float"]["output"];
  club: Scalars["String"]["output"];
  clubId: Scalars["String"]["output"];
  clubShortCode: Scalars["String"]["output"];
  commonNameForename: Scalars["String"]["output"];
  commonNameSurname: Scalars["String"]["output"];
  creativityRating: Scalars["Float"]["output"];
  defenseRating: Scalars["Float"]["output"];
  diff?: Maybe<Scalars["JSONObject"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  displayNameAbb?: Maybe<Scalars["String"]["output"]>;
  extraData?: Maybe<Scalars["JSONObject"]["output"]>;
  fullName: Scalars["String"]["output"];
  gender: GenderEnum;
  isNewRec?: Maybe<Scalars["Boolean"]["output"]>;
  isRemoved?: Maybe<Scalars["Boolean"]["output"]>;
  league?: Maybe<Scalars["String"]["output"]>;
  nationality: Scalars["String"]["output"];
  overallRating: Scalars["Float"]["output"];
  playerId: Scalars["String"]["output"];
  preferredPosition: PlayerPositionEnum;
  ratingsDelta?: Maybe<Scalars["JSONObject"]["output"]>;
  secondaryPosition1?: Maybe<PlayerPositionEnum>;
  secondaryPosition2?: Maybe<PlayerPositionEnum>;
  shirtNumber?: Maybe<Scalars["Int"]["output"]>;
};

export type PlayerMutation = {
  __typename?: "PlayerMutation";
  addCycle: PlayersCommonResult;
  addLeagueResetReward: PlayersCommonResult;
  addSeason: PlayersCommonResult;
  addUpdateBet: UserBets;
  annualReset?: Maybe<PlayersCommonResult>;
  annualResetForAnUser: PlayersCommonResult;
  buyStoreItem: BuyStoreItemResponse;
  claimDailyReward: ClaimRewardResponse;
  claimEosReward: Array<ClaimRewardResponse>;
  claimLeaderboardReward: Array<ClaimLeaderboardRewardResponse>;
  claimReward: ClaimRewardResponse;
  createStoreItem: StoreItem;
  deleteStoreItem: DeleteStoreItem;
  finalizeWeeklyLeaderboards: PlayersCommonResult;
  init: InitResponse;
  placeBet: PlaceBetResponse;
  removeAllBetsFromSlip: PlayersCommonResult;
  removeBetFromSlip: PlayersCommonResult;
  spinVault: SpinVaultWheelResponse;
  startNewWeeklyLeaderboards: PlayersCommonResult;
  takeUserToAnyDivision: PlayersCommonResult;
  triggerLeagueStatsCalc: PlayersCommonResult;
  updateBalance: PlayersCommonResult;
  updateLeaguePostMatch?: Maybe<Scalars["JSONObject"]["output"]>;
  updateLocalCurrencyRates: PlayersCommonResult;
  updateStoreItem: StoreItem;
  updateStoreStatus: UpdateStoreStatus;
  updateUserExtraData: User;
  updateUserSettings: User;
  updateVoidedBetPopupShown?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type PlayerMutationAddLeagueResetRewardArgs = {
  userIds: Scalars["String"]["input"];
};

export type PlayerMutationAddSeasonArgs = {
  seasonNumber: Scalars["Int"]["input"];
};

export type PlayerMutationAddUpdateBetArgs = {
  input: AddUpdateBetInput;
};

export type PlayerMutationAnnualResetArgs = {
  input: AnnualResetInput;
};

export type PlayerMutationAnnualResetForAnUserArgs = {
  coins: Scalars["Int"]["input"];
  rewardId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type PlayerMutationBuyStoreItemArgs = {
  input: BuyStoreItemInput;
};

export type PlayerMutationClaimRewardArgs = {
  rewardId: Scalars["String"]["input"];
};

export type PlayerMutationCreateStoreItemArgs = {
  input: CreateStoreItemInput;
};

export type PlayerMutationDeleteStoreItemArgs = {
  storeItemId: Scalars["String"]["input"];
};

export type PlayerMutationInitArgs = {
  currency?: InputMaybe<Scalars["String"]["input"]>;
  isDebugBuild?: InputMaybe<Scalars["Boolean"]["input"]>;
  language?: InputMaybe<Scalars["String"]["input"]>;
  token: Scalars["String"]["input"];
};

export type PlayerMutationRemoveAllBetsFromSlipArgs = {
  input?: InputMaybe<RemoveAllBetsFromSlipInput>;
};

export type PlayerMutationRemoveBetFromSlipArgs = {
  betId: Scalars["String"]["input"];
};

export type PlayerMutationTakeUserToAnyDivisionArgs = {
  currentStep: Scalars["Int"]["input"];
  division: Scalars["Int"]["input"];
  milestone: Scalars["Int"]["input"];
  userId: Scalars["String"]["input"];
};

export type PlayerMutationTriggerLeagueStatsCalcArgs = {
  scope?: InputMaybe<Scalars["String"]["input"]>;
};

export type PlayerMutationUpdateBalanceArgs = {
  balance: Scalars["Float"]["input"];
};

export type PlayerMutationUpdateLeaguePostMatchArgs = {
  input: UpdateLeaguePostMatchInput;
};

export type PlayerMutationUpdateStoreItemArgs = {
  input: StoreItemDto;
};

export type PlayerMutationUpdateStoreStatusArgs = {
  storeItemId: Scalars["String"]["input"];
};

export type PlayerMutationUpdateUserExtraDataArgs = {
  extraData: Scalars["JSONObject"]["input"];
};

export type PlayerMutationUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};

export type PlayerOvrFormulas = {
  __typename?: "PlayerOVRFormulas";
  formulas: Scalars["JSONObject"]["output"];
};

export type PlayerPoolDropProbability = {
  __typename?: "PlayerPoolDropProbability";
  playerCard: Scalars["ObjectID"]["output"];
  probability: Scalars["Float"]["output"];
};

export type PlayerPoolDropProbabilityInput = {
  playerCard: Scalars["ObjectID"]["input"];
  probability: Scalars["Float"]["input"];
};

export enum PlayerPositionEnum {
  Cam = "CAM",
  Cb = "CB",
  Cdm = "CDM",
  Cm = "CM",
  Gk = "GK",
  Lb = "LB",
  Lm = "LM",
  Lw = "LW",
  Rb = "RB",
  Rm = "RM",
  Rw = "RW",
  St = "ST",
}

export type PlayerQueries = {
  __typename?: "PlayerQueries";
  allAnnualResetInfo: Array<AnnualResetInfo>;
  allLeagueDetails?: Maybe<UserLeagueInfo>;
  coinHistory: PaginatedCoinHistoryResponse;
  currentBetSlip: Array<UserBets>;
  getAllDetailedDailyRewards: AllDetailedDailyReward;
  getAllStoreItem: PaginatedStoreItem;
  getAllTypeStoreItems: AllTypeStoreItem;
  getAllUserNotifications: Array<GetAllUserNotifications>;
  getCountryLeaderboard: CountryLeaderboard;
  getGlobalLeaderboard: GlobalLeaderboard;
  getHomeBanners: Array<GetHomeBanners>;
  getLeagueStatistics: LeagueStatisticsDto;
  getPlatformRtp: GetPlatformRtp;
  getQuickBets: GetQuickBets;
  getSplashScreen?: Maybe<GetSplashScreens>;
  getStoreBanners: Array<GetStoreBanners>;
  getStoreItemInfo: StoreItem;
  getUnreadNotificationCount: GetUnreadNotificationCount;
  getVaultPrizes: VaultRewardConfigResponse;
  getVaultStatus: UserVault;
  getWeeklyLeaderboard: WeeklyLeaderboard;
  getWeeklyLeaderboardMultipliers: WeeklyLeaderboardMultipliers;
  markNotificationsAsRead: MarkNotificationsAsRead;
  markNotificationsAsRemoved: MarkNotificationsAsRemoved;
  markSplashScreenAsRead: MarkSplashScreenAsRead;
  me: User;
  myBets: PaginatedMyBetResponse;
  odds: Odds;
  profanityCheck: Profanity;
  userCurrentLeagueDetails?: Maybe<UserCurrentLeague>;
};

export type PlayerQueriesCoinHistoryArgs = {
  dateFilter?: InputMaybe<DateFilterEnum>;
  limit?: Scalars["Int"]["input"];
  pageNo?: Scalars["Int"]["input"];
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type PlayerQueriesGetAllStoreItemArgs = {
  limit?: Scalars["Int"]["input"];
  pageNo?: Scalars["Int"]["input"];
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type PlayerQueriesGetLeagueStatisticsArgs = {
  scope?: InputMaybe<Scalars["String"]["input"]>;
};

export type PlayerQueriesGetStoreItemInfoArgs = {
  storeItemId: Scalars["String"]["input"];
};

export type PlayerQueriesMarkNotificationsAsReadArgs = {
  notificationsId?: InputMaybe<Array<Scalars["ObjectID"]["input"]>>;
};

export type PlayerQueriesMarkNotificationsAsRemovedArgs = {
  notificationsId?: InputMaybe<Array<Scalars["ObjectID"]["input"]>>;
};

export type PlayerQueriesMarkSplashScreenAsReadArgs = {
  splashScreenId: Scalars["ObjectID"]["input"];
};

export type PlayerQueriesMyBetsArgs = {
  betStatus?: InputMaybe<BetStatus>;
  dateFilter?: InputMaybe<DateFilterEnum>;
  limit?: Scalars["Int"]["input"];
  matchId?: InputMaybe<Scalars["String"]["input"]>;
  matchStatus?: InputMaybe<MatchStatus>;
  pageNo?: Scalars["Int"]["input"];
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type PlayerQueriesProfanityCheckArgs = {
  text: Scalars["String"]["input"];
};

export type PlayerTemplate = {
  __typename?: "PlayerTemplate";
  _id: Scalars["ObjectID"]["output"];
  attackRating: Scalars["Float"]["output"];
  club: Scalars["String"]["output"];
  clubId: Scalars["String"]["output"];
  clubShortCode: Scalars["String"]["output"];
  commonName?: Maybe<Scalars["String"]["output"]>;
  commonNameForename: Scalars["String"]["output"];
  commonNameSurname: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  creativityRating: Scalars["Float"]["output"];
  deactivated?: Maybe<Scalars["Boolean"]["output"]>;
  defaultAvatarUrl?: Maybe<Scalars["String"]["output"]>;
  defenseRating: Scalars["Float"]["output"];
  displayName?: Maybe<Scalars["String"]["output"]>;
  displayNameAbb?: Maybe<Scalars["String"]["output"]>;
  fullName: Scalars["String"]["output"];
  gender?: Maybe<GenderEnum>;
  imageUrl: Scalars["String"]["output"];
  league?: Maybe<Scalars["String"]["output"]>;
  nationality: Scalars["String"]["output"];
  nationalityImageUrl?: Maybe<Scalars["String"]["output"]>;
  overallRating: Scalars["Float"]["output"];
  playerId: Scalars["String"]["output"];
  preferredPosition: PlayerPositionEnum;
  rarity?: Maybe<CardRarityEnum>;
  secondaryPosition1?: Maybe<PlayerPositionEnum>;
  secondaryPosition2?: Maybe<PlayerPositionEnum>;
  sentDate?: Maybe<Scalars["Date"]["output"]>;
  shirtNumber?: Maybe<Scalars["Int"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type PlayersCommonResult = {
  __typename?: "PlayersCommonResult";
  data?: Maybe<Scalars["JSONObject"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
};

export type PlayersTeamMeta = {
  __typename?: "PlayersTeamMeta";
  _id?: Maybe<Scalars["ObjectID"]["output"]>;
  attackRating?: Maybe<Scalars["Float"]["output"]>;
  autoName?: Maybe<Scalars["String"]["output"]>;
  badge: Scalars["String"]["output"];
  badgeUrl?: Maybe<Scalars["String"]["output"]>;
  chemistry?: Maybe<Scalars["Int"]["output"]>;
  creativityRating?: Maybe<Scalars["Float"]["output"]>;
  defenseRating?: Maybe<Scalars["Float"]["output"]>;
  isBot?: Maybe<Scalars["Boolean"]["output"]>;
  kit: Scalars["String"]["output"];
  kitColor: Scalars["String"]["output"];
  kitColorDark?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  overallRating?: Maybe<Scalars["Float"]["output"]>;
  user?: Maybe<Scalars["ObjectID"]["output"]>;
};

export type Position = {
  __typename?: "Position";
  _id: Scalars["ObjectID"]["output"];
  backgroundColor: Scalars["String"]["output"];
  code: PlayerPositionEnum;
  name?: Maybe<Scalars["String"]["output"]>;
  textColor: Scalars["String"]["output"];
};

export type PredefinedImages = {
  __typename?: "PredefinedImages";
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
};

export type Profanity = {
  __typename?: "Profanity";
  isValid: Scalars["Boolean"]["output"];
};

export enum PurchaseMethodEnum {
  Coins = "COINS",
  RealCash = "REAL_CASH",
}

export type Query = {
  __typename?: "Query";
  manager: ManagerQuery;
  match: MatchQueries;
  players: PlayerQueries;
  teamManager: TeamManagerQueries;
};

export type QuickBet = {
  __typename?: "QuickBet";
  _id: Scalars["ObjectID"]["output"];
  bets: Array<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  territory?: Maybe<Scalars["String"]["output"]>;
};

export type QuickSwapPopup = {
  __typename?: "QuickSwapPopup";
  shouldShow: Scalars["Boolean"]["output"];
  suggestion?: Maybe<QuickSwapSuggestion>;
};

export type QuickSwapPreferences = {
  __typename?: "QuickSwapPreferences";
  isOptedOut?: Maybe<Scalars["Boolean"]["output"]>;
  matchFrequency?: Maybe<Scalars["Int"]["output"]>;
};

export type QuickSwapSuggestion = {
  __typename?: "QuickSwapSuggestion";
  chemistryImpact?: Maybe<Scalars["Int"]["output"]>;
  currentPlayer: UserPlayerCard;
  ovrDifference: Scalars["Int"]["output"];
  position: Scalars["String"]["output"];
  suggestedPlayer: UserPlayerCard;
};

export enum ReCalTeamRatingStatusEnum {
  Completed = "COMPLETED",
  Failed = "FAILED",
  Started = "STARTED",
  Stopped = "STOPPED",
}

export type ReCalculateTeamRatingsInput = {
  initiatedByEmail?: InputMaybe<Scalars["String"]["input"]>;
  reCalcId?: InputMaybe<Scalars["String"]["input"]>;
};

export type RemoveAllBetsFromSlipInput = {
  betStatus?: InputMaybe<Array<BetStatus>>;
};

export type RemoveBoosterInput = {
  boosterId: Scalars["ObjectID"]["input"];
};

export type RemoveBotGhostTeamInput = {
  age?: InputMaybe<Scalars["Int"]["input"]>;
  type: BotGhostTeamType;
};

export type ReportSummary = {
  __typename?: "ReportSummary";
  date?: Maybe<Scalars["String"]["output"]>;
  playerId?: Maybe<Scalars["String"]["output"]>;
  rgsPlayerId?: Maybe<Scalars["String"]["output"]>;
  totalCoins: Scalars["Int"]["output"];
  totalCoinsAvailable: Scalars["Int"]["output"];
  totalCoinsPurchased: Scalars["Int"]["output"];
  totalCoinsReceived: Scalars["Int"]["output"];
  totalCoinsUtilized: Scalars["Int"]["output"];
};

export type ResultBttsOdds = {
  __typename?: "ResultBttsOdds";
  data: Array<ResultBttsOddsData>;
  name: Scalars["String"]["output"];
  type: BettingMarketsEnum;
};

export type ResultBttsOddsData = {
  __typename?: "ResultBttsOddsData";
  values: Array<ResultBttsOddsValues>;
  win: WinEnum;
};

export type ResultBttsOddsValues = {
  __typename?: "ResultBttsOddsValues";
  americanOdd: Scalars["String"]["output"];
  decimalOdd: Scalars["Float"]["output"];
  fractionalOdd: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  maxBet?: Maybe<Scalars["Float"]["output"]>;
  odd: Scalars["String"]["output"];
  payoutMultiplier: Scalars["Float"]["output"];
  value: YesNoEnum;
  xpBoostPercentage: Scalars["Float"]["output"];
};

export type SearchOpponent = {
  __typename?: "SearchOpponent";
  matchId: Scalars["String"]["output"];
  opponent: BotGhostTeam;
};

export type Slot = {
  __typename?: "Slot";
  betIds?: Maybe<Array<Bet>>;
  events: Array<MatchEvent>;
  matchHalf: Scalars["Int"]["output"];
  myTeamScore: Scalars["Int"]["output"];
  oppTeamScore: Scalars["Int"]["output"];
  playCategory: Play_Category;
  time: Scalars["Int"]["output"];
};

export type SlotBoosterProbability = {
  __typename?: "SlotBoosterProbability";
  boosterId: Scalars["ObjectID"]["output"];
  probability: Scalars["Float"]["output"];
};

export type SlotBoosterProbabilityInput = {
  boosterId: Scalars["ObjectID"]["input"];
  probability: Scalars["Float"]["input"];
};

export type SlotDropProbability = {
  __typename?: "SlotDropProbability";
  ovrMax: Scalars["Float"]["output"];
  ovrMin: Scalars["Float"]["output"];
  probability: Scalars["Float"]["output"];
};

export type SlotDropProbabilityInput = {
  ovrMax: Scalars["Float"]["input"];
  ovrMin: Scalars["Float"]["input"];
  probability: Scalars["Float"]["input"];
};

export enum SortDir {
  Asc = "ASC",
  Desc = "DESC",
}

export type SpinDetails = {
  __typename?: "SpinDetails";
  _id: Scalars["ObjectID"]["output"];
  isRedeemed: Scalars["Boolean"]["output"];
  isRedeemedAt?: Maybe<Scalars["Date"]["output"]>;
  level: Scalars["Int"]["output"];
  rewardMetadata?: Maybe<Scalars["JSONObject"]["output"]>;
  xpRequired: Scalars["Float"]["output"];
};

export type SpinVaultWheelResponse = {
  __typename?: "SpinVaultWheelResponse";
  booster?: Maybe<ClaimRewardUserBoosters>;
  coins?: Maybe<Scalars["Int"]["output"]>;
  isPlayerCardQuickSold?: Maybe<Scalars["Boolean"]["output"]>;
  newRewards: Array<VaultRewardResponse>;
  playerCard?: Maybe<PlayerCardInfo>;
  quickSellCoin?: Maybe<Scalars["Float"]["output"]>;
  slotIndex: Scalars["Int"]["output"];
  slotType: VaultSlotTypes;
  updatedVaultStatus: UserVault;
};

export type SplashScreen = {
  __typename?: "SplashScreen";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  bodyFontSize?: Maybe<Scalars["Int"]["output"]>;
  bodyTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  isBodyBold?: Maybe<Scalars["Boolean"]["output"]>;
  isTitleBold?: Maybe<Scalars["Boolean"]["output"]>;
  navigationPath: SplashScreenNavigationPathType;
  operators?: Maybe<Array<Scalars["String"]["output"]>>;
  title: Scalars["String"]["output"];
  titleFontSize?: Maybe<Scalars["Int"]["output"]>;
  titleTrans?: Maybe<Scalars["JSONObject"]["output"]>;
};

export enum SplashScreenNavigationPathType {
  Divisions = "DIVISIONS",
  Leaderboard = "LEADERBOARD",
  Leaderboard_2 = "LEADERBOARD_2",
  MyTeam = "MY_TEAM",
  Store = "STORE",
  Vault = "VAULT",
}

export type StaminaReductionConfig = {
  __typename?: "StaminaReductionConfig";
  maxOvr: Scalars["Int"]["output"];
  minOvr: Scalars["Int"]["output"];
  staminaLossMax: Scalars["Int"]["output"];
  staminaLossMin: Scalars["Int"]["output"];
};

export type StaminaReductionConfigDto = {
  maxOvr: Scalars["Int"]["input"];
  minOvr: Scalars["Int"]["input"];
  staminaLossMax: Scalars["Int"]["input"];
  staminaLossMin: Scalars["Int"]["input"];
};

export type StartMatchResponse = {
  __typename?: "StartMatchResponse";
  matchId: Scalars["String"]["output"];
  myTeamScore: Scalars["Int"]["output"];
  oppTeamScore: Scalars["Int"]["output"];
  slots: Array<Slot>;
};

export type StopReCalculateTeamRatingsInput = {
  reCalcId?: InputMaybe<Scalars["String"]["input"]>;
  stoppedByEmail?: InputMaybe<Scalars["String"]["input"]>;
};

export type StoreBanner = {
  __typename?: "StoreBanner";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  bodyTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isActive: Scalars["Boolean"]["output"];
  isBodyBold?: Maybe<Scalars["Boolean"]["output"]>;
  isTitleBold?: Maybe<Scalars["Boolean"]["output"]>;
  order?: Maybe<Scalars["Int"]["output"]>;
  territory?: Maybe<Scalars["String"]["output"]>;
  textColor: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  titleTrans?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type StoreCoins = {
  __typename?: "StoreCoins";
  _id: Scalars["ObjectID"]["output"];
  bonus?: Maybe<Scalars["Int"]["output"]>;
  bonusTxt?: Maybe<Scalars["String"]["output"]>;
  buyPrice?: Maybe<Scalars["Float"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isDisabled?: Maybe<Scalars["Boolean"]["output"]>;
  isPopular?: Maybe<Scalars["Boolean"]["output"]>;
  pbfCoin?: Maybe<Scalars["Int"]["output"]>;
  type: StoreItemTypeEnum;
};

export type StoreItem = {
  __typename?: "StoreItem";
  _id: Scalars["ObjectID"]["output"];
  bonus?: Maybe<Scalars["Int"]["output"]>;
  bonusTxt?: Maybe<Scalars["String"]["output"]>;
  buyCoins?: Maybe<Scalars["Int"]["output"]>;
  buyPrice?: Maybe<Scalars["JSONObject"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isDisabled?: Maybe<Scalars["Boolean"]["output"]>;
  isPopular?: Maybe<Scalars["Boolean"]["output"]>;
  pbfCoin?: Maybe<Scalars["Int"]["output"]>;
  purchaseMethod: PurchaseMethodEnum;
  type: StoreItemTypeEnum;
};

export type StoreItemDto = {
  _id: Scalars["ObjectID"]["input"];
  bonus?: InputMaybe<Scalars["Int"]["input"]>;
  bonusTxt?: InputMaybe<Scalars["String"]["input"]>;
  buyCoins?: InputMaybe<Scalars["Int"]["input"]>;
  buyPrice?: InputMaybe<Scalars["JSONObject"]["input"]>;
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  isDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPopular?: InputMaybe<Scalars["Boolean"]["input"]>;
  pbfCoin?: InputMaybe<Scalars["Int"]["input"]>;
  purchaseMethod: PurchaseMethodEnum;
  type: StoreItemTypeEnum;
};

export enum StoreItemTypeEnum {
  Coins = "COINS",
  Pack = "PACK",
}

export type StorePacks = {
  __typename?: "StorePacks";
  _id: Scalars["ObjectID"]["output"];
  imageUrl: Scalars["String"]["output"];
  isSinglePlayer?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  price: Scalars["Float"]["output"];
  summary?: Maybe<Scalars["String"]["output"]>;
};

export type SwapPlayerInput = {
  /** This is the 0 based index from myTeam.players. */
  playerCardIdx: Scalars["Int"]["input"];
  /** This is the _id received in getAllCards.items */
  swapWithPlayerId: Scalars["ObjectID"]["input"];
};

export type TeamBadge = {
  __typename?: "TeamBadge";
  name: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export enum TeamIdEnum {
  A = "A",
  B = "B",
}

export type TeamManagerCommonResult = {
  __typename?: "TeamManagerCommonResult";
  message?: Maybe<Scalars["String"]["output"]>;
};

export type TeamManagerMutation = {
  __typename?: "TeamManagerMutation";
  applyBooster: UserPlayerCard;
  assignBoosters?: Maybe<Scalars["String"]["output"]>;
  assignPlayerCard: UserPlayerCard;
  changeFormation: MyTeam;
  ftuUpdate: FtuResponse;
  handleOptedOutQuickSwapAction: OptedOutQuickSwapAction;
  randomlyChooseTeam?: Maybe<Scalars["String"]["output"]>;
  reloadFtuPacksCache: TeamManagerCommonResult;
  removeAllBoosters: TeamManagerCommonResult;
  removeBooster: UserPlayerCard;
  restoreTeam: MyTeam;
  sellPlayer: TeamManagerCommonResult;
  swapPlayer: MyTeam;
  updatePlayerPosition: MyTeam;
  updateTeamMetadata: MyTeam;
};

export type TeamManagerMutationApplyBoosterArgs = {
  input: ApplyBoosterInput;
};

export type TeamManagerMutationAssignPlayerCardArgs = {
  playerCardId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type TeamManagerMutationChangeFormationArgs = {
  formation: Scalars["String"]["input"];
};

export type TeamManagerMutationFtuUpdateArgs = {
  input: FtuUpdateInput;
};

export type TeamManagerMutationReloadFtuPacksCacheArgs = {
  country?: InputMaybe<Scalars["String"]["input"]>;
};

export type TeamManagerMutationRemoveBoosterArgs = {
  input: RemoveBoosterInput;
};

export type TeamManagerMutationSellPlayerArgs = {
  userPlayerIds: Array<Scalars["String"]["input"]>;
};

export type TeamManagerMutationSwapPlayerArgs = {
  input: SwapPlayerInput;
};

export type TeamManagerMutationUpdatePlayerPositionArgs = {
  input: UpdatePlayerPositionInput;
};

export type TeamManagerMutationUpdateTeamMetadataArgs = {
  input: UpdateTeamMetadataInput;
};

export type TeamManagerQueries = {
  __typename?: "TeamManagerQueries";
  allBadges: Array<TeamBadge>;
  fatigueRatingReductionConf: FatigueRatingReductionConfigList;
  ftuNationality: Array<FtuNationality>;
  getAllCards: PaginatedUserPlayerCard;
  isQuickSwapAvailable: QuickSwapPopup;
  myBoosters?: Maybe<Array<UserBoosters>>;
  myTeam?: Maybe<MyTeam>;
};

export type TeamManagerQueriesGetAllCardsArgs = {
  excludeTeamPlayers?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeSecondaryPos?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: Scalars["Int"]["input"];
  pageNo?: Scalars["Int"]["input"];
  preferredPositions?: InputMaybe<Array<PlayerPositionEnum>>;
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type TeamManagerQueriesMyBoostersArgs = {
  type?: InputMaybe<BoosterType>;
};

export enum TfgRatingEnum {
  Base = "BASE",
  Form = "FORM",
}

export type TierReward = {
  __typename?: "TierReward";
  _id: Scalars["ObjectID"]["output"];
  rewardPack: Scalars["ObjectID"]["output"];
  rewardPackCount: Scalars["Int"]["output"];
};

export type TierRewardInput = {
  rewardPack: Scalars["ObjectID"]["input"];
  rewardPackCount: Scalars["Int"]["input"];
};

export type Translations = {
  __typename?: "Translations";
  _id: Scalars["ObjectID"]["output"];
  isoCode: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type TranslationsInput = {
  isoCode: Scalars["String"]["input"];
  key: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type UnderMaintenanceModeInput = {
  operatorId: Scalars["String"]["input"];
  value: Scalars["Boolean"]["input"];
};

export type UpdateBanner = {
  __typename?: "UpdateBanner";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  bodyTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  fileUploadUrl?: Maybe<Scalars["String"]["output"]>;
  isActive: Scalars["Boolean"]["output"];
  isBodyBold?: Maybe<Scalars["Boolean"]["output"]>;
  isTitleBold?: Maybe<Scalars["Boolean"]["output"]>;
  navigationPath: NavigationPathType;
  operators?: Maybe<Array<Scalars["String"]["output"]>>;
  order?: Maybe<Scalars["Int"]["output"]>;
  territory?: Maybe<Scalars["String"]["output"]>;
  textColor: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  titleTrans?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type UpdateBannerInput = {
  _id: Scalars["ObjectID"]["input"];
  body: Scalars["String"]["input"];
  bodyTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  fileType?: InputMaybe<Scalars["String"]["input"]>;
  isActive: Scalars["Boolean"]["input"];
  isBodyBold?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTitleBold?: InputMaybe<Scalars["Boolean"]["input"]>;
  navigationPath: NavigationPathType;
  operators?: InputMaybe<Array<Scalars["String"]["input"]>>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
  territory?: InputMaybe<Scalars["String"]["input"]>;
  textColor: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
  titleTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
};

export type UpdateBannerStatus = {
  __typename?: "UpdateBannerStatus";
  message: Scalars["String"]["output"];
};

export type UpdateBoosterInput = {
  _id: Scalars["ObjectID"]["input"];
  bonusPoints?: InputMaybe<Scalars["Int"]["input"]>;
  cost?: InputMaybe<Scalars["Int"]["input"]>;
  duration?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<BoosterType>;
};

export type UpdateCardBg = {
  __typename?: "UpdateCardBg";
  _id: Scalars["ObjectID"]["output"];
  cardImgSmUploadUrl?: Maybe<Scalars["String"]["output"]>;
  cardImgUploadUrl?: Maybe<Scalars["String"]["output"]>;
  detImgUploadUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  textColor: Scalars["String"]["output"];
};

export type UpdateCardBgInput = {
  _id: Scalars["ObjectID"]["input"];
  cardImgFileType?: InputMaybe<Scalars["String"]["input"]>;
  cardImgSmFileType?: InputMaybe<Scalars["String"]["input"]>;
  detImgFileType?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  textColor: Scalars["String"]["input"];
};

export type UpdateClub = {
  __typename?: "UpdateClub";
  _id: Scalars["ObjectID"]["output"];
  abbreviation: Scalars["String"]["output"];
  backgroundColor: Scalars["String"]["output"];
  externalClubId?: Maybe<Scalars["String"]["output"]>;
  gender?: Maybe<GenderEnum>;
  isJerseyUpload?: Maybe<Scalars["Boolean"]["output"]>;
  isUpdatedExternalId?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  oldExternalId?: Maybe<Scalars["String"]["output"]>;
  textColor: Scalars["String"]["output"];
};

export type UpdateClubInput = {
  _id: Scalars["ObjectID"]["input"];
  abbreviation?: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor?: InputMaybe<Scalars["String"]["input"]>;
  externalClubId?: InputMaybe<Scalars["String"]["input"]>;
  gender?: InputMaybe<GenderEnum>;
  isJerseyUpload?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  textColor?: InputMaybe<Scalars["String"]["input"]>;
  updateAllPlayerRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateDailyRewardInput = {
  _id: Scalars["ObjectID"]["input"];
  awardType: DailyRewardTypeEnum;
  booster?: InputMaybe<Scalars["ObjectID"]["input"]>;
  count?: InputMaybe<Scalars["Int"]["input"]>;
  day: Scalars["Int"]["input"];
  pack?: InputMaybe<Scalars["ObjectID"]["input"]>;
  rewardHC?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateEosRewardConfigInput = {
  _id: Scalars["ObjectID"]["input"];
  endPoints?: InputMaybe<Scalars["Int"]["input"]>;
  rewards?: InputMaybe<Array<TierRewardInput>>;
  startPoints?: InputMaybe<Scalars["Int"]["input"]>;
  tier?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateLanguagesInput = {
  id: Scalars["ObjectID"]["input"];
  isoCode: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type UpdateLeagueConfigInput = {
  _id: Scalars["ObjectID"]["input"];
  ceilValue?: InputMaybe<Scalars["Int"]["input"]>;
  endOfCycleRewardAmt?: InputMaybe<Scalars["Float"]["input"]>;
  endOfCycleRewardPack?: InputMaybe<Scalars["ObjectID"]["input"]>;
  floorValue?: InputMaybe<Scalars["Int"]["input"]>;
  k1: Scalars["Float"]["input"];
  k2: Scalars["Float"]["input"];
  kWeights?: InputMaybe<Scalars["JSONObject"]["input"]>;
  kWeightsFe?: InputMaybe<Scalars["JSONObject"]["input"]>;
  milestones: Array<UpdateMilestonesInput>;
  name: Scalars["String"]["input"];
  number: Scalars["Float"]["input"];
};

export type UpdateLeaguePostMatchInput = {
  matchId?: InputMaybe<Scalars["String"]["input"]>;
  myTeamScore: Scalars["Int"]["input"];
  operatorId: Scalars["String"]["input"];
  oppTeamScore: Scalars["Int"]["input"];
  rgsPlayerId: Scalars["String"]["input"];
};

export type UpdateMilestonesInput = {
  _id?: InputMaybe<Scalars["ObjectID"]["input"]>;
  descText?: InputMaybe<Scalars["String"]["input"]>;
  descTextTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  k1?: InputMaybe<Scalars["Float"]["input"]>;
  k2?: InputMaybe<Scalars["Float"]["input"]>;
  number: Scalars["Float"]["input"];
  rewardCoins?: InputMaybe<Scalars["Float"]["input"]>;
  rewardPack?: InputMaybe<Scalars["ObjectID"]["input"]>;
  rewardPackCount?: InputMaybe<Scalars["Float"]["input"]>;
  steps: Scalars["Float"]["input"];
};

export type UpdateNotification = {
  __typename?: "UpdateNotification";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  bodyTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  fileUploadUrl?: Maybe<Scalars["String"]["output"]>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  liveDate?: Maybe<Scalars["Date"]["output"]>;
  operators?: Maybe<Array<Scalars["String"]["output"]>>;
  territory?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  titleTrans?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type UpdateNotificationInput = {
  _id: Scalars["ObjectID"]["input"];
  body: Scalars["String"]["input"];
  bodyTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  fileType?: InputMaybe<Scalars["String"]["input"]>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  operators?: InputMaybe<Array<Scalars["String"]["input"]>>;
  territory?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
  titleTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
};

export type UpdateNotificationStatus = {
  __typename?: "UpdateNotificationStatus";
  message: Scalars["String"]["output"];
};

export type UpdatePackCategoryInput = {
  id: Scalars["String"]["input"];
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  nameTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdatePackCategoryStatus = {
  __typename?: "UpdatePackCategoryStatus";
  message: Scalars["String"]["output"];
};

export type UpdatePackInput = {
  _id: Scalars["ObjectID"]["input"];
  category?: InputMaybe<Scalars["ObjectID"]["input"]>;
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  excludePlayers?: InputMaybe<Array<Scalars["ObjectID"]["input"]>>;
  fileType?: InputMaybe<Scalars["String"]["input"]>;
  idFromExcel?: InputMaybe<Scalars["String"]["input"]>;
  isDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFTUPack?: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  nameTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  nationality?: InputMaybe<Scalars["String"]["input"]>;
  operatorPackPrice?: InputMaybe<Scalars["JSONObject"]["input"]>;
  operatorPacks?: InputMaybe<Scalars["JSONObject"]["input"]>;
  operators?: InputMaybe<Array<Scalars["String"]["input"]>>;
  packPredefinedImageType?: InputMaybe<Scalars["String"]["input"]>;
  price?: InputMaybe<Scalars["Float"]["input"]>;
  slots?: InputMaybe<Array<PackSlotInput>>;
  summary?: InputMaybe<Scalars["String"]["input"]>;
  summaryTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  teamNameExcel?: InputMaybe<Scalars["String"]["input"]>;
  territory?: InputMaybe<Scalars["String"]["input"]>;
  type: PackTypes;
};

export type UpdatePackStatus = {
  __typename?: "UpdatePackStatus";
  message: Scalars["String"]["output"];
};

export type UpdatePlayerCardInput = {
  _id: Scalars["ObjectID"]["input"];
  attackRating: Scalars["Float"]["input"];
  cardBgId?: InputMaybe<Scalars["ObjectID"]["input"]>;
  club: Scalars["String"]["input"];
  clubId: Scalars["String"]["input"];
  clubShortCode: Scalars["String"]["input"];
  commonNameForename: Scalars["String"]["input"];
  commonNameSurname: Scalars["String"]["input"];
  creativityRating: Scalars["Float"]["input"];
  customSellPrice?: InputMaybe<Scalars["Int"]["input"]>;
  defenseRating: Scalars["Float"]["input"];
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  displayNameAbb?: InputMaybe<Scalars["String"]["input"]>;
  extraData?: InputMaybe<Scalars["JSONObject"]["input"]>;
  /** This means that user is trying to upload actual image. If this is not sent then no image upload url will be returned */
  imageFileType?: InputMaybe<Scalars["String"]["input"]>;
  isDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** This means user is trying to upload mini image. If this is not sent then no image upload url will be returned */
  miniImageFileType?: InputMaybe<Scalars["String"]["input"]>;
  nationality: Scalars["String"]["input"];
  preferredPosition: PlayerPositionEnum;
  rarity: CardRarityEnum;
  ratingTextColor?: InputMaybe<Scalars["String"]["input"]>;
  secondaryPosition1?: InputMaybe<PlayerPositionEnum>;
  secondaryPosition2?: InputMaybe<PlayerPositionEnum>;
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  updateId?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePlayerCardStatus = {
  __typename?: "UpdatePlayerCardStatus";
  message: Scalars["String"]["output"];
};

export type UpdatePlayerPositionInput = {
  /** This is the _id received in myTeam.players */
  draggedPlayerId: Scalars["ObjectID"]["input"];
  /** New position of the card */
  draggedPosition: PlayerPositionEnum;
  /** This is the _id of the card over which it is dropped */
  droppedPlayerId: Scalars["ObjectID"]["input"];
  /** Initial position of the card */
  droppedPosition: PlayerPositionEnum;
};

export type UpdatePositionInput = {
  _id: Scalars["ObjectID"]["input"];
  backgroundColor: Scalars["String"]["input"];
  code: PlayerPositionEnum;
  name?: InputMaybe<Scalars["String"]["input"]>;
  textColor: Scalars["String"]["input"];
  updateAllPlayerRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateQuickBet = {
  __typename?: "UpdateQuickBet";
  _id: Scalars["ObjectID"]["output"];
  bets: Array<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  territory?: Maybe<Scalars["String"]["output"]>;
};

export type UpdateQuickBetInput = {
  _id: Scalars["ObjectID"]["input"];
  bets: Array<Scalars["Float"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  territory?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateSplashScreen = {
  __typename?: "UpdateSplashScreen";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  bodyFontSize?: Maybe<Scalars["Int"]["output"]>;
  bodyTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  fileUploadUrl?: Maybe<Scalars["String"]["output"]>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  isBodyBold?: Maybe<Scalars["Boolean"]["output"]>;
  isTitleBold?: Maybe<Scalars["Boolean"]["output"]>;
  navigationPath: SplashScreenNavigationPathType;
  operators?: Maybe<Array<Scalars["String"]["output"]>>;
  title: Scalars["String"]["output"];
  titleFontSize?: Maybe<Scalars["Int"]["output"]>;
  titleTrans?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type UpdateSplashScreenInput = {
  _id: Scalars["ObjectID"]["input"];
  body: Scalars["String"]["input"];
  bodyFontSize?: InputMaybe<Scalars["Int"]["input"]>;
  bodyTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  fileType?: InputMaybe<Scalars["String"]["input"]>;
  isBodyBold?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTitleBold?: InputMaybe<Scalars["Boolean"]["input"]>;
  navigationPath: SplashScreenNavigationPathType;
  operators?: InputMaybe<Array<Scalars["String"]["input"]>>;
  title: Scalars["String"]["input"];
  titleFontSize?: InputMaybe<Scalars["Int"]["input"]>;
  titleTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
};

export type UpdateSplashScreenStatus = {
  __typename?: "UpdateSplashScreenStatus";
  message: Scalars["String"]["output"];
};

export type UpdateStoreBanner = {
  __typename?: "UpdateStoreBanner";
  _id: Scalars["ObjectID"]["output"];
  body: Scalars["String"]["output"];
  bodyTrans?: Maybe<Scalars["JSONObject"]["output"]>;
  fileUploadUrl?: Maybe<Scalars["String"]["output"]>;
  isActive: Scalars["Boolean"]["output"];
  isBodyBold?: Maybe<Scalars["Boolean"]["output"]>;
  isTitleBold?: Maybe<Scalars["Boolean"]["output"]>;
  order?: Maybe<Scalars["Int"]["output"]>;
  territory?: Maybe<Scalars["String"]["output"]>;
  textColor: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  titleTrans?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type UpdateStoreBannerInput = {
  _id: Scalars["ObjectID"]["input"];
  body: Scalars["String"]["input"];
  bodyTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
  fileType?: InputMaybe<Scalars["String"]["input"]>;
  isActive: Scalars["Boolean"]["input"];
  isBodyBold?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTitleBold?: InputMaybe<Scalars["Boolean"]["input"]>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
  territory?: InputMaybe<Scalars["String"]["input"]>;
  textColor: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
  titleTrans?: InputMaybe<Scalars["JSONObject"]["input"]>;
};

export type UpdateStoreBannerStatus = {
  __typename?: "UpdateStoreBannerStatus";
  message: Scalars["String"]["output"];
};

export type UpdateStoreStatus = {
  __typename?: "UpdateStoreStatus";
  message: Scalars["String"]["output"];
};

export type UpdateTeamMetadataInput = {
  badge?: InputMaybe<Scalars["String"]["input"]>;
  kit?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateUserSettingsInput = {
  audio: Scalars["Boolean"]["input"];
  oddsDisplay: OddsDisplayEnum;
};

export type UpdateVaultRewardConfig = {
  __typename?: "UpdateVaultRewardConfig";
  _id: Scalars["ObjectID"]["output"];
  level: Scalars["Int"]["output"];
  rewards: Array<VaultRewardDto>;
};

export type UpdateVaultRewardConfigInput = {
  _id: Scalars["ObjectID"]["input"];
  level: Scalars["Int"]["input"];
  rewards: Array<VaultRewardInput>;
};

export type User = {
  __typename?: "User";
  _id: Scalars["ObjectID"]["output"];
  balance: Scalars["Float"]["output"];
  extraData?: Maybe<Scalars["JSONObject"]["output"]>;
  goldStars?: Maybe<Scalars["Int"]["output"]>;
  isFTU: Scalars["Boolean"]["output"];
  operatorId: Scalars["String"]["output"];
  pbfCoin: Scalars["Float"]["output"];
  rgsPlayerId: Scalars["String"]["output"];
  settings: UserSettings;
};

export type UserBetOddDetails = {
  __typename?: "UserBetOddDetails";
  goals?: Maybe<Scalars["Float"]["output"]>;
  handicap?: Maybe<Scalars["Float"]["output"]>;
  playerId?: Maybe<Scalars["BigInt"]["output"]>;
  team1?: Maybe<Scalars["Int"]["output"]>;
  team2?: Maybe<Scalars["Int"]["output"]>;
  teamId?: Maybe<TeamIdEnum>;
  type?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<YesNoEnum>;
  win?: Maybe<WinEnum>;
  xpBoostPercentage: Scalars["Float"]["output"];
};

export type UserBets = {
  __typename?: "UserBets";
  americanOdd: Scalars["String"]["output"];
  betAmount?: Maybe<Scalars["Float"]["output"]>;
  betId: Scalars["String"]["output"];
  betPlacedAt?: Maybe<Scalars["Date"]["output"]>;
  betStatus: BetStatus;
  createdAt: Scalars["Date"]["output"];
  currency?: Maybe<Scalars["String"]["output"]>;
  decimalOdd: Scalars["Float"]["output"];
  fractionalOdd: Scalars["String"]["output"];
  isResolved: Scalars["Boolean"]["output"];
  marketName: Scalars["String"]["output"];
  marketType: BettingMarketsEnum;
  odd: Scalars["String"]["output"];
  oddId: Scalars["String"]["output"];
  oddsDetails: UserBetOddDetails;
  payoutMultiplier?: Maybe<Scalars["Float"]["output"]>;
  platformTransactionId?: Maybe<Scalars["String"]["output"]>;
  toReturn?: Maybe<Scalars["Float"]["output"]>;
  winAmount?: Maybe<Scalars["Float"]["output"]>;
  xp: Scalars["Float"]["output"];
  xpBoostPercentage: Scalars["Float"]["output"];
};

export type UserBoosters = {
  __typename?: "UserBoosters";
  _id: Scalars["ObjectID"]["output"];
  appliedOnPlayer?: Maybe<UserPlayerCard>;
  bonusPoints: Scalars["Int"]["output"];
  cost?: Maybe<Scalars["Int"]["output"]>;
  duration?: Maybe<Scalars["Int"]["output"]>;
  durationUsed?: Maybe<Scalars["Int"]["output"]>;
  imageUrl: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  rarity?: Maybe<BoosterRarityEnum>;
  type: BoosterType;
};

export type UserCurrentLeague = {
  __typename?: "UserCurrentLeague";
  /** Current league number (1-10) */
  currentLeague: Scalars["Int"]["output"];
  /** Current milestone within the league */
  currentMilestone: Scalars["Int"]["output"];
  /** Current step in the milestone */
  currentStep: Scalars["Int"]["output"];
  cycleEndAt: Scalars["Date"]["output"];
  goldStars?: Maybe<Scalars["Int"]["output"]>;
  isAnyUnclaimedReward?: Maybe<Scalars["Boolean"]["output"]>;
  league: UserLeague;
};

export type UserLeague = {
  __typename?: "UserLeague";
  milestones: Array<UserMilestone>;
  number: Scalars["Float"]["output"];
  userPercent?: Maybe<Scalars["Float"]["output"]>;
};

export type UserLeagueInfo = {
  __typename?: "UserLeagueInfo";
  cycleEndAt: Scalars["Date"]["output"];
  leagues: Array<UserLeague>;
};

export type UserMilestone = {
  __typename?: "UserMilestone";
  descText?: Maybe<Scalars["String"]["output"]>;
  isMilestoneCompleted: Scalars["Boolean"]["output"];
  isRewardClaimed?: Maybe<Scalars["Boolean"]["output"]>;
  number: Scalars["Float"]["output"];
  rewardCoins: Scalars["Float"]["output"];
  rewardId?: Maybe<Scalars["ObjectID"]["output"]>;
  rewardPackCount: Scalars["Float"]["output"];
  steps: Array<UserMilestoneSteps>;
};

export type UserMilestoneSteps = {
  __typename?: "UserMilestoneSteps";
  isCleared: Scalars["Boolean"]["output"];
  number: Scalars["Float"]["output"];
};

export type UserPack = {
  __typename?: "UserPack";
  _id: Scalars["ObjectID"]["output"];
  idFromExcel?: Maybe<Scalars["String"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  teamNameExcel?: Maybe<Scalars["String"]["output"]>;
};

export type UserPlayerCard = {
  __typename?: "UserPlayerCard";
  _id: Scalars["ObjectID"]["output"];
  age?: Maybe<Scalars["Float"]["output"]>;
  attackRating: Scalars["Float"]["output"];
  booster?: Maybe<Scalars["ObjectID"]["output"]>;
  boosterDetails?: Maybe<UserBoosters>;
  cardImg?: Maybe<Scalars["String"]["output"]>;
  cardImgSm?: Maybe<Scalars["String"]["output"]>;
  chemistry?: Maybe<Scalars["Int"]["output"]>;
  chemistryPercentage?: Maybe<Scalars["Int"]["output"]>;
  club: Scalars["String"]["output"];
  clubId: Scalars["String"]["output"];
  coins?: Maybe<Scalars["Int"]["output"]>;
  commonName?: Maybe<Scalars["String"]["output"]>;
  commonNameForename: Scalars["String"]["output"];
  commonNameSurname: Scalars["String"]["output"];
  creativityRating: Scalars["Float"]["output"];
  currentPosition: PlayerPositionEnum;
  defenseRating: Scalars["Float"]["output"];
  detImg?: Maybe<Scalars["String"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  displayNameAbb?: Maybe<Scalars["String"]["output"]>;
  extraData?: Maybe<Scalars["JSONObject"]["output"]>;
  fullName: Scalars["String"]["output"];
  goalsScored?: Maybe<Scalars["Int"]["output"]>;
  height?: Maybe<Scalars["Float"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isBoosterApplied?: Maybe<Scalars["Boolean"]["output"]>;
  isQuickSold?: Maybe<Scalars["Boolean"]["output"]>;
  largeImageUrl?: Maybe<Scalars["String"]["output"]>;
  league?: Maybe<Scalars["String"]["output"]>;
  matchesPlayed?: Maybe<Scalars["Int"]["output"]>;
  miniImageUrl?: Maybe<Scalars["String"]["output"]>;
  nationality: Scalars["String"]["output"];
  nationalityImageUrl?: Maybe<Scalars["String"]["output"]>;
  originalRatings?: Maybe<Scalars["JSONObject"]["output"]>;
  overallRating: Scalars["Float"]["output"];
  playerCard: Scalars["String"]["output"];
  playerId: Scalars["String"]["output"];
  preferredPosition: PlayerPositionEnum;
  rarity: CardRarityEnum;
  secondaryPosition1?: Maybe<PlayerPositionEnum>;
  secondaryPosition2?: Maybe<PlayerPositionEnum>;
  sellingPrice?: Maybe<Scalars["Int"]["output"]>;
  shirtNumber?: Maybe<Scalars["Int"]["output"]>;
  stamina?: Maybe<Scalars["Int"]["output"]>;
  weight?: Maybe<Scalars["Float"]["output"]>;
};

export type UserPlayerCardUsers = {
  __typename?: "UserPlayerCardUsers";
  _id: Scalars["ObjectID"]["output"];
  age?: Maybe<Scalars["Float"]["output"]>;
  attackRating: Scalars["Float"]["output"];
  booster?: Maybe<Scalars["ObjectID"]["output"]>;
  cardImg?: Maybe<Scalars["String"]["output"]>;
  cardImgSm?: Maybe<Scalars["String"]["output"]>;
  chemistry?: Maybe<Scalars["Int"]["output"]>;
  chemistryPercentage?: Maybe<Scalars["Int"]["output"]>;
  club: Scalars["String"]["output"];
  clubId: Scalars["String"]["output"];
  coins?: Maybe<Scalars["Int"]["output"]>;
  commonName?: Maybe<Scalars["String"]["output"]>;
  commonNameForename: Scalars["String"]["output"];
  commonNameSurname: Scalars["String"]["output"];
  creativityRating: Scalars["Float"]["output"];
  currentPosition: PlayerPositionEnum;
  defenseRating: Scalars["Float"]["output"];
  detImg?: Maybe<Scalars["String"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  displayNameAbb?: Maybe<Scalars["String"]["output"]>;
  extraData?: Maybe<Scalars["JSONObject"]["output"]>;
  fullName: Scalars["String"]["output"];
  goalsScored?: Maybe<Scalars["Int"]["output"]>;
  height?: Maybe<Scalars["Float"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  isBoosterApplied?: Maybe<Scalars["Boolean"]["output"]>;
  largeImageUrl?: Maybe<Scalars["String"]["output"]>;
  league?: Maybe<Scalars["String"]["output"]>;
  matchesPlayed?: Maybe<Scalars["Int"]["output"]>;
  miniImageUrl?: Maybe<Scalars["String"]["output"]>;
  nationality: Scalars["String"]["output"];
  nationalityImageUrl?: Maybe<Scalars["String"]["output"]>;
  originalRatings?: Maybe<Scalars["JSONObject"]["output"]>;
  overallRating: Scalars["Float"]["output"];
  playerCard: Scalars["String"]["output"];
  playerId: Scalars["String"]["output"];
  preferredPosition: PlayerPositionEnum;
  rarity: CardRarityEnum;
  secondaryPosition1?: Maybe<PlayerPositionEnum>;
  secondaryPosition2?: Maybe<PlayerPositionEnum>;
  shirtNumber?: Maybe<Scalars["Int"]["output"]>;
  stamina?: Maybe<Scalars["Int"]["output"]>;
  staminaHis?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  weight?: Maybe<Scalars["Float"]["output"]>;
};

export type UserSettings = {
  __typename?: "UserSettings";
  audio: Scalars["Boolean"]["output"];
  oddsDisplay: OddsDisplayEnum;
};

export type UserTeam = {
  __typename?: "UserTeam";
  attackRating?: Maybe<Scalars["Int"]["output"]>;
  autoName: Scalars["String"]["output"];
  badge: Scalars["String"]["output"];
  chemistry?: Maybe<Scalars["Int"]["output"]>;
  chemistryPercentage?: Maybe<Scalars["Float"]["output"]>;
  creativityRating?: Maybe<Scalars["Int"]["output"]>;
  defenseRating?: Maybe<Scalars["Int"]["output"]>;
  formation?: Maybe<Scalars["String"]["output"]>;
  kit: Scalars["String"]["output"];
  kitColor: Scalars["String"]["output"];
  kitColorDark?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  originalRatings?: Maybe<Scalars["JSONObject"]["output"]>;
  overallRating?: Maybe<Scalars["Int"]["output"]>;
  players?: Maybe<Array<Maybe<UserPlayerCardUsers>>>;
  selectedWelcomePack?: Maybe<UserPack>;
  totalTeamChemistry?: Maybe<Scalars["Int"]["output"]>;
  welcomePackNationality?: Maybe<Scalars["String"]["output"]>;
};

export type UserVault = {
  __typename?: "UserVault";
  _id: Scalars["ObjectID"]["output"];
  availableSpins: Scalars["Float"]["output"];
  currentVaultLevel: Scalars["Float"]["output"];
  currentXP: Scalars["Float"]["output"];
  isNewVault?: Maybe<Scalars["Boolean"]["output"]>;
  spinDetails: Array<SpinDetails>;
  userId: Scalars["ObjectID"]["output"];
  xpNeededForLevel: Scalars["Float"]["output"];
  xpToNextLevel: Scalars["Float"]["output"];
};

export enum UsersSearchBy {
  AutoTeamName = "AUTO_TEAM_NAME",
  CountryCode = "COUNTRY_CODE",
  OperatorId = "OPERATOR_ID",
  RgsPlayerId = "RGS_PLAYER_ID",
  UserId = "USER_ID",
}

export type VaultProgressUpdate = {
  __typename?: "VaultProgressUpdate";
  level: Scalars["Int"]["output"];
  spin?: Maybe<Scalars["Int"]["output"]>;
  xpFrom: Scalars["Int"]["output"];
  xpRequired: Scalars["Int"]["output"];
  xpTo: Scalars["Int"]["output"];
};

export type VaultRewardConfig = {
  __typename?: "VaultRewardConfig";
  _id: Scalars["ObjectID"]["output"];
  level: Scalars["Int"]["output"];
  rewards: Array<VaultRewardDto>;
};

export type VaultRewardConfigResponse = {
  __typename?: "VaultRewardConfigResponse";
  rewards: Array<VaultRewardResponse>;
};

export type VaultRewardDto = {
  __typename?: "VaultRewardDTO";
  booster?: Maybe<Scalars["ObjectID"]["output"]>;
  coins?: Maybe<Scalars["Int"]["output"]>;
  playerOvr?: Maybe<Scalars["Int"]["output"]>;
  probability: Scalars["Float"]["output"];
  slotType: VaultSlotTypes;
};

export type VaultRewardInput = {
  booster?: InputMaybe<Scalars["ObjectID"]["input"]>;
  coins?: InputMaybe<Scalars["Int"]["input"]>;
  playerOvr?: InputMaybe<Scalars["Int"]["input"]>;
  probability: Scalars["Float"]["input"];
  slotType: VaultSlotTypes;
};

export type VaultRewardResponse = {
  __typename?: "VaultRewardResponse";
  booster?: Maybe<ClaimRewardUserBoosters>;
  coins?: Maybe<Scalars["Int"]["output"]>;
  playerCard?: Maybe<PlayerCardInfo>;
  slotType: VaultSlotTypes;
};

export enum VaultSlotTypes {
  Booster = "Booster",
  Coins = "Coins",
  Player = "Player",
}

export type WeeklyLeaderboard = {
  __typename?: "WeeklyLeaderboard";
  entries: Array<WeeklyLeaderboardEntry>;
  isWeeklyLeaderboardActive: Scalars["Boolean"]["output"];
  leaderboardInfo: WeeklyLeaderboardInfo;
};

export type WeeklyLeaderboardConfig = {
  __typename?: "WeeklyLeaderboardConfig";
  divisionMultipliers: Scalars["JSONObject"]["output"];
  leagueConfig: Array<WeeklyLeaderboardConfigItem>;
  matchWinXP: Scalars["Float"]["output"];
  vaultXPMultiplier: Scalars["Float"]["output"];
};

export type WeeklyLeaderboardConfigDto = {
  divisionMultipliers: Scalars["JSONObject"]["input"];
  leagueConfig: Array<WeeklyLeaderboardConfigItemDto>;
  matchWinXP: Scalars["Float"]["input"];
  vaultXPMultiplier: Scalars["Float"]["input"];
};

export type WeeklyLeaderboardConfigItem = {
  __typename?: "WeeklyLeaderboardConfigItem";
  leagueConfig: LeaderboardLeagueConfig;
  name: Scalars["String"]["output"];
  order: Scalars["Int"]["output"];
};

export type WeeklyLeaderboardConfigItemDto = {
  leagueConfig: LeaderboardLeagueConfigDto;
  name: Scalars["String"]["input"];
  order: Scalars["Int"]["input"];
};

export type WeeklyLeaderboardEntry = {
  __typename?: "WeeklyLeaderboardEntry";
  badgeUrl?: Maybe<Scalars["String"]["output"]>;
  countryCode?: Maybe<Scalars["String"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  position: Scalars["Int"]["output"];
  teamName: Scalars["String"]["output"];
  totalXP: Scalars["Float"]["output"];
  userId: Scalars["ObjectID"]["output"];
};

export type WeeklyLeaderboardInfo = {
  __typename?: "WeeklyLeaderboardInfo";
  currentLeague: WeeklyLeagueType;
  demotionPositions: Array<Scalars["Int"]["output"]>;
  poolId: Scalars["String"]["output"];
  promotionPositions: Array<Scalars["Int"]["output"]>;
  weekEndDate: Scalars["DateTime"]["output"];
  weekStartDate: Scalars["DateTime"]["output"];
};

export type WeeklyLeaderboardMultipliers = {
  __typename?: "WeeklyLeaderboardMultipliers";
  divisionMultipliers: Scalars["JSONObject"]["output"];
  matchWinXP: Scalars["Float"]["output"];
  vaultXPMultiplier: Scalars["Float"]["output"];
};

export type WeeklyLeaderboardRewards = {
  __typename?: "WeeklyLeaderboardRewards";
  league?: Maybe<Scalars["String"]["output"]>;
  rewards?: Maybe<Array<LeaderboardRewards>>;
};

export enum WeeklyLeagueType {
  Bronze = "BRONZE",
  BronzeIi = "BRONZE_II",
  Diamond = "DIAMOND",
  DiamondIi = "DIAMOND_II",
  Gold = "GOLD",
  GoldIi = "GOLD_II",
  Platinum = "PLATINUM",
  Silver = "SILVER",
  SilverIi = "SILVER_II",
  Starter = "STARTER",
}

/** Represents the possible outcomes: A, B, or draw */
export enum WinEnum {
  A = "A",
  B = "B",
  Draw = "draw",
}

export enum YesNoEnum {
  No = "No",
  Yes = "Yes",
  Draw = "draw",
}

export type GetCountryLeaderboardQueryVariables = Exact<{ [key: string]: never }>;

export type GetCountryLeaderboardQuery = {
  __typename?: "Query";
  players: {
    __typename?: "PlayerQueries";
    getCountryLeaderboard: {
      __typename?: "CountryLeaderboard";
      countryLeaderboard?: Array<{
        __typename?: "LeaderboardEntry";
        userId: any;
        team: any;
        ranking?: number | null;
        goldStars?: number | null;
        countryCode?: string | null;
        imageUrl?: string | null;
      }> | null;
      userRanking?: {
        __typename?: "LeaderboardEntry";
        userId: any;
        team: any;
        ranking?: number | null;
        goldStars?: number | null;
        countryCode?: string | null;
        imageUrl?: string | null;
      } | null;
    };
  };
};

export type GetGlobalLeaderboardQueryVariables = Exact<{ [key: string]: never }>;

export type GetGlobalLeaderboardQuery = {
  __typename?: "Query";
  players: {
    __typename?: "PlayerQueries";
    getGlobalLeaderboard: {
      __typename?: "GlobalLeaderboard";
      globalLeaderboard?: Array<{
        __typename?: "LeaderboardEntry";
        userId: any;
        team: any;
        ranking?: number | null;
        goldStars?: number | null;
        countryCode?: string | null;
        imageUrl?: string | null;
      }> | null;
      userRanking?: {
        __typename?: "LeaderboardEntry";
        userId: any;
        team: any;
        ranking?: number | null;
        goldStars?: number | null;
        countryCode?: string | null;
        imageUrl?: string | null;
      } | null;
    };
  };
};

export type GetWeeklyLeaderboardMultipliersQueryVariables = Exact<{ [key: string]: never }>;

export type GetWeeklyLeaderboardMultipliersQuery = {
  __typename?: "Query";
  players: {
    __typename?: "PlayerQueries";
    getWeeklyLeaderboardMultipliers: {
      __typename?: "WeeklyLeaderboardMultipliers";
      divisionMultipliers: any;
      matchWinXP: number;
      vaultXPMultiplier: number;
    };
  };
};

export type GetPlatformRtpQueryVariables = Exact<{ [key: string]: never }>;

export type GetPlatformRtpQuery = {
  __typename?: "Query";
  players: {
    __typename?: "PlayerQueries";
    getPlatformRtp: {
      __typename?: "GetPlatformRtp";
      FINAL_RESULT?: string | null;
      UNDER_OVER?: string | null;
      BTTS?: string | null;
      RESULT_BTTS?: string | null;
      CORRECT_SCORE?: string | null;
      FIRST_LAST_ANY_GOAL_SCORE?: string | null;
      HANDICAPS?: string | null;
      FIRST_GOAL_CORRECT_SCORE?: string | null;
      OVER_ALL?: string | null;
    };
  };
};

export type GetWeeklyLeaderboardQueryVariables = Exact<{ [key: string]: never }>;

export type GetWeeklyLeaderboardQuery = {
  __typename?: "Query";
  players: {
    __typename?: "PlayerQueries";
    getWeeklyLeaderboard: {
      __typename?: "WeeklyLeaderboard";
      isWeeklyLeaderboardActive: boolean;
      leaderboardInfo: {
        __typename?: "WeeklyLeaderboardInfo";
        currentLeague: WeeklyLeagueType;
        poolId: string;
        promotionPositions: Array<number>;
        demotionPositions: Array<number>;
        weekStartDate: any;
        weekEndDate: any;
      };
      entries: Array<{
        __typename?: "WeeklyLeaderboardEntry";
        userId: any;
        teamName: string;
        badgeUrl?: string | null;
        countryCode?: string | null;
        position: number;
        totalXP: number;
        imageUrl?: string | null;
      }>;
    };
  };
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  __typename?: "Query";
  players: {
    __typename?: "PlayerQueries";
    me: {
      __typename?: "User";
      _id: any;
      rgsPlayerId: string;
      operatorId: string;
      balance: number;
      pbfCoin: number;
      isFTU: boolean;
      extraData?: any | null;
      settings: { __typename?: "UserSettings"; oddsDisplay: OddsDisplayEnum; audio: boolean };
    };
  };
};

export type UpdateTeamMetadataMutationVariables = Exact<{
  input: UpdateTeamMetadataInput;
}>;

export type UpdateTeamMetadataMutation = {
  __typename?: "Mutation";
  teamManager: {
    __typename?: "TeamManagerMutation";
    updateTeamMetadata: {
      __typename?: "MyTeam";
      name?: string | null;
      badge: string;
      badgeUrl?: string | null;
      kit: string;
      kitColor: string;
      kitColorDark?: string | null;
      attackRating?: number | null;
      defenseRating?: number | null;
      creativityRating?: number | null;
      overallRating?: number | null;
      chemistry?: number | null;
      chemistryPercentage?: number | null;
      formation?: string | null;
      players?: Array<{
        __typename?: "UserPlayerCard";
        _id: any;
        booster?: any | null;
        chemistry?: number | null;
        sellingPrice?: number | null;
        fullName: string;
        commonNameForename: string;
        commonNameSurname: string;
        clubId: string;
        commonName?: string | null;
        displayName?: string | null;
        displayNameAbb?: string | null;
        club: string;
        league?: string | null;
        currentPosition: PlayerPositionEnum;
        preferredPosition: PlayerPositionEnum;
        secondaryPosition1?: PlayerPositionEnum | null;
        secondaryPosition2?: PlayerPositionEnum | null;
        nationality: string;
        nationalityImageUrl?: string | null;
        attackRating: number;
        defenseRating: number;
        creativityRating: number;
        overallRating: number;
        age?: number | null;
        weight?: number | null;
        height?: number | null;
        rarity: CardRarityEnum;
        imageUrl?: string | null;
        miniImageUrl?: string | null;
        extraData?: any | null;
        originalRatings?: any | null;
        shirtNumber?: number | null;
        chemistryPercentage?: number | null;
        isBoosterApplied?: boolean | null;
        cardImg?: string | null;
        cardImgSm?: string | null;
        detImg?: string | null;
        boosterDetails?: {
          __typename?: "UserBoosters";
          _id: any;
          type: BoosterType;
          bonusPoints: number;
          duration?: number | null;
          cost?: number | null;
          name?: string | null;
          rarity?: BoosterRarityEnum | null;
          imageUrl: string;
          appliedOnPlayer?: {
            __typename?: "UserPlayerCard";
            _id: any;
            booster?: any | null;
            chemistry?: number | null;
            sellingPrice?: number | null;
            fullName: string;
            commonNameForename: string;
            commonNameSurname: string;
            clubId: string;
            commonName?: string | null;
            displayName?: string | null;
            displayNameAbb?: string | null;
            club: string;
            league?: string | null;
            currentPosition: PlayerPositionEnum;
            preferredPosition: PlayerPositionEnum;
            secondaryPosition1?: PlayerPositionEnum | null;
            secondaryPosition2?: PlayerPositionEnum | null;
            nationality: string;
            nationalityImageUrl?: string | null;
            attackRating: number;
            defenseRating: number;
            creativityRating: number;
            overallRating: number;
            age?: number | null;
            weight?: number | null;
            height?: number | null;
            rarity: CardRarityEnum;
            imageUrl?: string | null;
            miniImageUrl?: string | null;
            extraData?: any | null;
            originalRatings?: any | null;
            shirtNumber?: number | null;
            chemistryPercentage?: number | null;
            isBoosterApplied?: boolean | null;
            cardImg?: string | null;
            cardImgSm?: string | null;
            detImg?: string | null;
          } | null;
        } | null;
      } | null> | null;
    };
  };
};

export type UpdateBalanceMutationVariables = Exact<{
  balance: Scalars["Float"]["input"];
}>;

export type UpdateBalanceMutation = {
  __typename?: "Mutation";
  players: {
    __typename?: "PlayerMutation";
    updateBalance: { __typename?: "PlayersCommonResult"; message?: string | null; data?: any | null };
  };
};

export type UpdateUserExtraDataMutationVariables = Exact<{
  extraData: Scalars["JSONObject"]["input"];
}>;

export type UpdateUserExtraDataMutation = {
  __typename?: "Mutation";
  players: {
    __typename?: "PlayerMutation";
    updateUserExtraData: {
      __typename?: "User";
      _id: any;
      rgsPlayerId: string;
      operatorId: string;
      balance: number;
      pbfCoin: number;
      isFTU: boolean;
      extraData?: any | null;
      goldStars?: number | null;
      settings: { __typename?: "UserSettings"; oddsDisplay: OddsDisplayEnum; audio: boolean };
    };
  };
};

export type MyBetsQueryVariables = Exact<{
  pageNo: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
  matchId?: InputMaybe<Scalars["String"]["input"]>;
  matchStatus?: InputMaybe<MatchStatus>;
  betStatus?: InputMaybe<BetStatus>;
  dateFilter?: InputMaybe<DateFilterEnum>;
}>;

export type MyBetsQuery = {
  __typename?: "Query";
  players: {
    __typename?: "PlayerQueries";
    myBets: {
      __typename?: "PaginatedMyBetResponse";
      totalItems?: any | null;
      totalPages?: any | null;
      morePages?: boolean | null;
      items: Array<{
        __typename?: "MyBetsResponse";
        matchId: string;
        myTeamName: string;
        opponentTeamName: string;
        matchStatus: MatchStatus;
        createdAt: any;
        myTeamScore: number;
        oppTeamScore: number;
        openingBalance?: number | null;
        closingBalance?: number | null;
        allPlayers: Array<{
          __typename?: "MiniPlayer";
          _id: any;
          playerId: string;
          playerCardId?: string | null;
          teamId: TeamIdEnum;
          attackRating: number;
          rarity: CardRarityEnum;
          name: string;
          currentPosition: PlayerPositionEnum;
          preferredPosition: PlayerPositionEnum;
        }>;
        bets: Array<{
          __typename?: "UserBets";
          betId: string;
          oddId: string;
          betAmount?: number | null;
          winAmount?: number | null;
          toReturn?: number | null;
          payoutMultiplier?: number | null;
          marketType: BettingMarketsEnum;
          marketName: string;
          xp: number;
          xpBoostPercentage: number;
          odd: string;
          decimalOdd: number;
          fractionalOdd: string;
          americanOdd: string;
          isResolved: boolean;
          betStatus: BetStatus;
          createdAt: any;
          currency?: string | null;
          platformTransactionId?: string | null;
          betPlacedAt?: any | null;
          oddsDetails: {
            __typename?: "UserBetOddDetails";
            win?: WinEnum | null;
            goals?: number | null;
            type?: string | null;
            value?: YesNoEnum | null;
            team1?: number | null;
            team2?: number | null;
            playerId?: any | null;
            teamId?: TeamIdEnum | null;
            handicap?: number | null;
            xpBoostPercentage: number;
          };
        }>;
      }>;
    };
  };
};

export type CoinHistoryQueryVariables = Exact<{
  dateFilter?: InputMaybe<DateFilterEnum>;
  pageNo: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
  skipPagination?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortKey?: InputMaybe<Scalars["String"]["input"]>;
  sortDir?: InputMaybe<SortDir>;
}>;

export type CoinHistoryQuery = {
  __typename?: "Query";
  players: {
    __typename?: "PlayerQueries";
    coinHistory: {
      __typename?: "PaginatedCoinHistoryResponse";
      totalItems?: any | null;
      totalPages?: any | null;
      morePages?: boolean | null;
      items: Array<{
        __typename?: "CoinHistoryResponse";
        txnId: string;
        createdAt: any;
        amount: number;
        price: number;
        currency: string;
      }>;
    };
  };
};

export type InitMutationVariables = Exact<{
  token: Scalars["String"]["input"];
  currency: Scalars["String"]["input"];
}>;

export type InitMutation = {
  __typename?: "Mutation";
  players: {
    __typename?: "PlayerMutation";
    init: {
      __typename?: "InitResponse";
      _id: any;
      balance: number;
      pbfCoin: number;
      beToken: any;
      operatorId: string;
      isFTU: boolean;
      badge?: string | null;
      kit?: string | null;
      kitColor?: string | null;
      kitColorDark?: string | null;
      extraData?: any | null;
    };
  };
};

export type MyTeamQueryVariables = Exact<{ [key: string]: never }>;

export type MyTeamQuery = {
  __typename?: "Query";
  teamManager: {
    __typename?: "TeamManagerQueries";
    myTeam?: {
      __typename?: "MyTeam";
      name?: string | null;
      badge: string;
      kit: string;
      kitColor: string;
      kitColorDark?: string | null;
      attackRating?: number | null;
      defenseRating?: number | null;
      creativityRating?: number | null;
      overallRating?: number | null;
      chemistry?: number | null;
      players?: Array<{
        __typename?: "UserPlayerCard";
        _id: any;
        booster?: any | null;
        chemistry?: number | null;
        sellingPrice?: number | null;
        fullName: string;
        commonName?: string | null;
        displayName?: string | null;
        displayNameAbb?: string | null;
        club: string;
        league?: string | null;
        currentPosition: PlayerPositionEnum;
        preferredPosition: PlayerPositionEnum;
        secondaryPosition1?: PlayerPositionEnum | null;
        secondaryPosition2?: PlayerPositionEnum | null;
        nationality: string;
        nationalityImageUrl?: string | null;
        attackRating: number;
        defenseRating: number;
        creativityRating: number;
        overallRating: number;
        age?: number | null;
        weight?: number | null;
        height?: number | null;
        rarity: CardRarityEnum;
        imageUrl?: string | null;
        miniImageUrl?: string | null;
        extraData?: any | null;
      } | null> | null;
    } | null;
  };
};

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;

export type UpdateUserSettingsMutation = {
  __typename?: "Mutation";
  players: {
    __typename?: "PlayerMutation";
    updateUserSettings: {
      __typename?: "User";
      _id: any;
      rgsPlayerId: string;
      operatorId: string;
      balance: number;
      pbfCoin: number;
      isFTU: boolean;
      settings: { __typename?: "UserSettings"; oddsDisplay: OddsDisplayEnum; audio: boolean };
    };
  };
};

export type AllBadgesQueryVariables = Exact<{ [key: string]: never }>;

export type AllBadgesQuery = {
  __typename?: "Query";
  teamManager: {
    __typename?: "TeamManagerQueries";
    allBadges: Array<{ __typename?: "TeamBadge"; name: string; url: string }>;
  };
};

export type FtuNationalityQueryVariables = Exact<{ [key: string]: never }>;

export type FtuNationalityQuery = {
  __typename?: "Query";
  teamManager: {
    __typename?: "TeamManagerQueries";
    ftuNationality: Array<{ __typename?: "FTUNationality"; name: string; imageUrl: string }>;
  };
};

export type FtuUpdateMutationVariables = Exact<{
  input: FtuUpdateInput;
}>;

export type FtuUpdateMutation = {
  __typename?: "Mutation";
  teamManager: {
    __typename?: "TeamManagerMutation";
    ftuUpdate: {
      __typename?: "FTUResponse";
      packName: string;
      packImageUrl?: string | null;
      badge: string;
      kit: string;
      kitColor: string;
      kitColorDark?: string | null;
      packSummary?: string | null;
      name: string;
      players: Array<{
        __typename?: "UserPlayerCard";
        _id: any;
        booster?: any | null;
        chemistry?: number | null;
        sellingPrice?: number | null;
        fullName: string;
        commonName?: string | null;
        displayName?: string | null;
        displayNameAbb?: string | null;
        club: string;
        league?: string | null;
        currentPosition: PlayerPositionEnum;
        preferredPosition: PlayerPositionEnum;
        secondaryPosition1?: PlayerPositionEnum | null;
        secondaryPosition2?: PlayerPositionEnum | null;
        nationality: string;
        nationalityImageUrl?: string | null;
        attackRating: number;
        defenseRating: number;
        creativityRating: number;
        overallRating: number;
        age?: number | null;
        weight?: number | null;
        height?: number | null;
        rarity: CardRarityEnum;
        imageUrl?: string | null;
        miniImageUrl?: string | null;
        extraData?: any | null;
      }>;
    };
  };
};

export type MatchDetailsByPlatformTxnIdQueryVariables = Exact<{
  platformTxnId: Scalars["String"]["input"];
}>;

export type MatchDetailsByPlatformTxnIdQuery = {
  __typename?: "Query";
  match: {
    __typename?: "MatchQueries";
    matchDetailsByPlatformTxnId: {
      __typename?: "MatchResult";
      matchId: string;
      myTeamScore?: number | null;
      oppTeamScore?: number | null;
      currentStep?: number | null;
      lastStep?: number | null;
      currentMilestone?: number | null;
      lastMilestone?: number | null;
      currentLeague?: number | null;
      lastLeague?: number | null;
      startDate?: any | null;
      endDate?: any | null;
      bets: Array<{
        __typename?: "MatchUserBets";
        betId: string;
        oddId: string;
        betAmount?: number | null;
        winAmount?: number | null;
        toReturn?: number | null;
        payoutMultiplier?: number | null;
        marketType: BettingMarketsEnum;
        marketName: string;
        xp: number;
        xpBoostPercentage: number;
        odd: string;
        decimalOdd: number;
        fractionalOdd: string;
        americanOdd: string;
        isResolved: boolean;
        betStatus: BetStatus;
        createdAt: any;
        currency?: string | null;
        oddsDetails: {
          __typename?: "MatchUserBetOddDetails";
          win?: WinEnum | null;
          goals?: number | null;
          type?: string | null;
          value?: YesNoEnum | null;
          team1?: number | null;
          team2?: number | null;
          playerId?: any | null;
          teamId?: TeamIdEnum | null;
          handicap?: number | null;
          xpBoostPercentage: number;
        };
      }>;
      myTeam: {
        __typename?: "MatchTeamMeta";
        name?: string | null;
        badge: string;
        badgeUrl?: string | null;
        kit: string;
        kitColor: string;
        kitColorDark?: string | null;
        attackRating?: number | null;
        defenseRating?: number | null;
        creativityRating?: number | null;
        overallRating?: number | null;
        chemistry?: number | null;
      };
      opponentTeam: {
        __typename?: "MatchTeamMeta";
        name?: string | null;
        badge: string;
        badgeUrl?: string | null;
        kit: string;
        kitColor: string;
        kitColorDark?: string | null;
        attackRating?: number | null;
        defenseRating?: number | null;
        creativityRating?: number | null;
        overallRating?: number | null;
        chemistry?: number | null;
      };
      allPlayers: Array<{
        __typename?: "MatchMiniPlayer";
        _id: any;
        playerId: string;
        teamId: TeamIdEnum;
        attackRating: number;
        rarity: CardRarityEnum;
        name: string;
        currentPosition: PlayerPositionEnum;
        preferredPosition: PlayerPositionEnum;
      }>;
      myTeamGoalScorers?: Array<{
        __typename?: "GoalScorer";
        _id: any;
        playerId: string;
        name: string;
        time: number;
      }> | null;
      oppTeamGoalScorers?: Array<{
        __typename?: "GoalScorer";
        _id: any;
        playerId: string;
        name: string;
        time: number;
      }> | null;
    };
  };
};

export type ProfanityCheckQueryVariables = Exact<{
  text: Scalars["String"]["input"];
}>;

export type ProfanityCheckQuery = {
  __typename?: "Query";
  players: { __typename?: "PlayerQueries"; profanityCheck: { __typename?: "Profanity"; isValid: boolean } };
};

export type AddUpdateBetMutationVariables = Exact<{
  input: AddUpdateBetInput;
}>;

export type AddUpdateBetMutation = {
  __typename?: "Mutation";
  players: {
    __typename?: "PlayerMutation";
    addUpdateBet: {
      __typename?: "UserBets";
      betId: string;
      oddId: string;
      betAmount?: number | null;
      winAmount?: number | null;
      toReturn?: number | null;
      marketType: BettingMarketsEnum;
      marketName: string;
      xp: number;
      xpBoostPercentage: number;
      odd: string;
      decimalOdd: number;
      isResolved: boolean;
      betStatus: BetStatus;
      createdAt: any;
      fractionalOdd: string;
      americanOdd: string;
      payoutMultiplier?: number | null;
      oddsDetails: {
        __typename?: "UserBetOddDetails";
        win?: WinEnum | null;
        goals?: number | null;
        type?: string | null;
        value?: YesNoEnum | null;
        team1?: number | null;
        team2?: number | null;
        playerId?: any | null;
        teamId?: TeamIdEnum | null;
        handicap?: number | null;
        xpBoostPercentage: number;
      };
    };
  };
};

export type CurrentBetSlipQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentBetSlipQuery = {
  __typename?: "Query";
  players: {
    __typename?: "PlayerQueries";
    currentBetSlip: Array<{
      __typename?: "UserBets";
      betId: string;
      oddId: string;
      betAmount?: number | null;
      winAmount?: number | null;
      toReturn?: number | null;
      marketType: BettingMarketsEnum;
      marketName: string;
      xp: number;
      xpBoostPercentage: number;
      odd: string;
      decimalOdd: number;
      fractionalOdd: string;
      americanOdd: string;
      isResolved: boolean;
      betStatus: BetStatus;
      createdAt: any;
      payoutMultiplier?: number | null;
      oddsDetails: {
        __typename?: "UserBetOddDetails";
        win?: WinEnum | null;
        goals?: number | null;
        type?: string | null;
        value?: YesNoEnum | null;
        team1?: number | null;
        team2?: number | null;
        playerId?: any | null;
        teamId?: TeamIdEnum | null;
        handicap?: number | null;
        xpBoostPercentage: number;
      };
    }>;
  };
};

export type GetQuickBetsQueryVariables = Exact<{ [key: string]: never }>;

export type GetQuickBetsQuery = {
  __typename?: "Query";
  players: { __typename?: "PlayerQueries"; getQuickBets: { __typename?: "GetQuickBets"; bets: Array<number> } };
};

export type PlaceBetMutationVariables = Exact<{ [key: string]: never }>;

export type PlaceBetMutation = {
  __typename?: "Mutation";
  players: {
    __typename?: "PlayerMutation";
    placeBet: {
      __typename?: "PlaceBetResponse";
      currentXP: number;
      currentVaultLevel: number;
      availableSpins: number;
      xpNeededForLevel: number;
      xpToNextLevel: number;
      totalXp: number;
      lastCurrentXP: number;
      lastVaultLevel: number;
      spinDetails: Array<{
        __typename?: "SpinDetails";
        _id: any;
        level: number;
        xpRequired: number;
        isRedeemed: boolean;
      }>;
      bets: Array<{
        __typename?: "UserBets";
        betId: string;
        oddId: string;
        betAmount?: number | null;
        winAmount?: number | null;
        toReturn?: number | null;
        marketType: BettingMarketsEnum;
        marketName: string;
        xp: number;
        xpBoostPercentage: number;
        odd: string;
        decimalOdd: number;
        payoutMultiplier?: number | null;
        isResolved: boolean;
        betStatus: BetStatus;
        createdAt: any;
        currency?: string | null;
        oddsDetails: {
          __typename?: "UserBetOddDetails";
          win?: WinEnum | null;
          goals?: number | null;
          type?: string | null;
          value?: YesNoEnum | null;
          team1?: number | null;
          team2?: number | null;
          playerId?: any | null;
          teamId?: TeamIdEnum | null;
          handicap?: number | null;
          xpBoostPercentage: number;
        };
      }>;
      progressUpdates: Array<{
        __typename?: "VaultProgressUpdate";
        level: number;
        xpFrom: number;
        xpTo: number;
        xpRequired: number;
        spin?: number | null;
      }>;
    };
  };
};

export type RemoveBetFromSlipMutationVariables = Exact<{
  betId: Scalars["String"]["input"];
}>;

export type RemoveBetFromSlipMutation = {
  __typename?: "Mutation";
  players: {
    __typename?: "PlayerMutation";
    removeBetFromSlip: { __typename?: "PlayersCommonResult"; message?: string | null };
  };
};

export type OddsQueryVariables = Exact<{ [key: string]: never }>;

export type OddsQuery = {
  __typename?: "Query";
  players: {
    __typename?: "PlayerQueries";
    odds: {
      __typename?: "Odds";
      _id: any;
      matchId: string;
      xpToAward: number;
      teamA: {
        __typename?: "PlayersTeamMeta";
        name?: string | null;
        badge: string;
        badgeUrl?: string | null;
        kit: string;
        kitColor: string;
        kitColorDark?: string | null;
        attackRating?: number | null;
        defenseRating?: number | null;
        creativityRating?: number | null;
        overallRating?: number | null;
        chemistry?: number | null;
      };
      teamB: {
        __typename?: "PlayersTeamMeta";
        name?: string | null;
        badge: string;
        badgeUrl?: string | null;
        kit: string;
        kitColor: string;
        kitColorDark?: string | null;
        attackRating?: number | null;
        defenseRating?: number | null;
        creativityRating?: number | null;
        overallRating?: number | null;
        chemistry?: number | null;
      };
      allPlayers: Array<{
        __typename?: "MiniPlayer";
        _id: any;
        playerId: string;
        teamId: TeamIdEnum;
        attackRating: number;
        rarity: CardRarityEnum;
        name: string;
        currentPosition: PlayerPositionEnum;
        preferredPosition: PlayerPositionEnum;
      }>;
      finalResult: {
        __typename?: "FinalResultOdds";
        name: string;
        type: BettingMarketsEnum;
        data: Array<{
          __typename?: "FinalResultOddsData";
          id: string;
          win: WinEnum;
          odd: string;
          decimalOdd: number;
          fractionalOdd: string;
          americanOdd: string;
          xpBoostPercentage: number;
          maxBet?: number | null;
          payoutMultiplier: number;
        }>;
      };
      goalsUnderOver: { __typename?: "GoalsUnderOverOdds"; name: string; type: BettingMarketsEnum; data: any };
      btts: {
        __typename?: "BttsOdds";
        name: string;
        type: BettingMarketsEnum;
        data: Array<{
          __typename?: "BttsOddsData";
          id: string;
          value: YesNoEnum;
          odd: string;
          fractionalOdd: string;
          americanOdd: string;
          decimalOdd: number;
          xpBoostPercentage: number;
          maxBet?: number | null;
          payoutMultiplier: number;
        }>;
      };
      resultBtts: {
        __typename?: "ResultBttsOdds";
        name: string;
        type: BettingMarketsEnum;
        data: Array<{
          __typename?: "ResultBttsOddsData";
          win: WinEnum;
          values: Array<{
            __typename?: "ResultBttsOddsValues";
            id: string;
            value: YesNoEnum;
            odd: string;
            decimalOdd: number;
            fractionalOdd: string;
            americanOdd: string;
            xpBoostPercentage: number;
            maxBet?: number | null;
            payoutMultiplier: number;
          }>;
        }>;
      };
      correctScore: {
        __typename?: "CorrectScoreOdds";
        name: string;
        type: BettingMarketsEnum;
        data: Array<{
          __typename?: "CorrectScoreOddsData";
          win: WinEnum;
          values: Array<{
            __typename?: "CorrectScoreOddsValues";
            id: string;
            team1: number;
            team2: number;
            odd: string;
            decimalOdd: number;
            fractionalOdd: string;
            americanOdd: string;
            xpBoostPercentage: number;
            maxBet?: number | null;
            payoutMultiplier: number;
            price: number;
          }>;
        }>;
      };
      goalscorerOdds: {
        __typename?: "GoalScorerOdds";
        name: string;
        type: BettingMarketsEnum;
        data: Array<{
          __typename?: "GoalScorerOddsData";
          playerId?: string | null;
          teamId?: TeamIdEnum | null;
          first?: {
            __typename?: "OddsValues";
            id: string;
            odd: string;
            decimalOdd: number;
            fractionalOdd: string;
            americanOdd: string;
            xpBoostPercentage: number;
            maxBet?: number | null;
            payoutMultiplier: number;
          } | null;
          last?: {
            __typename?: "OddsValues";
            id: string;
            odd: string;
            decimalOdd: number;
            fractionalOdd: string;
            americanOdd: string;
            xpBoostPercentage: number;
            maxBet?: number | null;
            payoutMultiplier: number;
          } | null;
          any?: {
            __typename?: "OddsValues";
            id: string;
            odd: string;
            decimalOdd: number;
            fractionalOdd: string;
            americanOdd: string;
            xpBoostPercentage: number;
            maxBet?: number | null;
            payoutMultiplier: number;
          } | null;
        }>;
      };
      handicaps: {
        __typename?: "HandicapOdds";
        name: string;
        type: BettingMarketsEnum;
        data: Array<{
          __typename?: "HandicapOddsData";
          win: WinEnum;
          values: Array<{
            __typename?: "HandicapOddsValues";
            id: string;
            handicap: number;
            odd: string;
            decimalOdd: number;
            fractionalOdd: string;
            americanOdd: string;
            xpBoostPercentage: number;
            maxBet?: number | null;
            payoutMultiplier: number;
          }>;
        }>;
      };
    };
  };
};

export type StartMatchMutationVariables = Exact<{ [key: string]: never }>;

export type StartMatchMutation = {
  __typename?: "Mutation";
  match: {
    __typename?: "MatchMutation";
    startMatch: {
      __typename?: "StartMatchResponse";
      matchId: string;
      myTeamScore: number;
      oppTeamScore: number;
      slots: Array<{
        __typename?: "Slot";
        matchHalf: number;
        myTeamScore: number;
        oppTeamScore: number;
        time: number;
        betIds?: Array<{ __typename?: "Bet"; id: string; isResolved: boolean }> | null;
        events: Array<{ __typename?: "MatchEvent"; team: TeamIdEnum; players: Array<string>; type: Match_Events }>;
      }>;
    };
  };
};

export const GetCountryLeaderboardDocument = gql`
  query GetCountryLeaderboard {
    players {
      getCountryLeaderboard {
        countryLeaderboard {
          userId
          team
          ranking
          goldStars
          countryCode
          imageUrl
        }
        userRanking {
          userId
          team
          ranking
          goldStars
          countryCode
          imageUrl
        }
      }
    }
  }
`;

/**
 * __useGetCountryLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetCountryLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryLeaderboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryLeaderboardQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCountryLeaderboardQuery, GetCountryLeaderboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCountryLeaderboardQuery, GetCountryLeaderboardQueryVariables>(
    GetCountryLeaderboardDocument,
    options,
  );
}
export function useGetCountryLeaderboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCountryLeaderboardQuery, GetCountryLeaderboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCountryLeaderboardQuery, GetCountryLeaderboardQueryVariables>(
    GetCountryLeaderboardDocument,
    options,
  );
}
export function useGetCountryLeaderboardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCountryLeaderboardQuery, GetCountryLeaderboardQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCountryLeaderboardQuery, GetCountryLeaderboardQueryVariables>(
    GetCountryLeaderboardDocument,
    options,
  );
}
export type GetCountryLeaderboardQueryHookResult = ReturnType<typeof useGetCountryLeaderboardQuery>;
export type GetCountryLeaderboardLazyQueryHookResult = ReturnType<typeof useGetCountryLeaderboardLazyQuery>;
export type GetCountryLeaderboardSuspenseQueryHookResult = ReturnType<typeof useGetCountryLeaderboardSuspenseQuery>;
export type GetCountryLeaderboardQueryResult = Apollo.QueryResult<
  GetCountryLeaderboardQuery,
  GetCountryLeaderboardQueryVariables
>;
export const GetGlobalLeaderboardDocument = gql`
  query GetGlobalLeaderboard {
    players {
      getGlobalLeaderboard {
        globalLeaderboard {
          userId
          team
          ranking
          goldStars
          countryCode
          imageUrl
        }
        userRanking {
          userId
          team
          ranking
          goldStars
          countryCode
          imageUrl
        }
      }
    }
  }
`;

/**
 * __useGetGlobalLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetGlobalLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalLeaderboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGlobalLeaderboardQuery(
  baseOptions?: Apollo.QueryHookOptions<GetGlobalLeaderboardQuery, GetGlobalLeaderboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGlobalLeaderboardQuery, GetGlobalLeaderboardQueryVariables>(
    GetGlobalLeaderboardDocument,
    options,
  );
}
export function useGetGlobalLeaderboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalLeaderboardQuery, GetGlobalLeaderboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGlobalLeaderboardQuery, GetGlobalLeaderboardQueryVariables>(
    GetGlobalLeaderboardDocument,
    options,
  );
}
export function useGetGlobalLeaderboardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetGlobalLeaderboardQuery, GetGlobalLeaderboardQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetGlobalLeaderboardQuery, GetGlobalLeaderboardQueryVariables>(
    GetGlobalLeaderboardDocument,
    options,
  );
}
export type GetGlobalLeaderboardQueryHookResult = ReturnType<typeof useGetGlobalLeaderboardQuery>;
export type GetGlobalLeaderboardLazyQueryHookResult = ReturnType<typeof useGetGlobalLeaderboardLazyQuery>;
export type GetGlobalLeaderboardSuspenseQueryHookResult = ReturnType<typeof useGetGlobalLeaderboardSuspenseQuery>;
export type GetGlobalLeaderboardQueryResult = Apollo.QueryResult<
  GetGlobalLeaderboardQuery,
  GetGlobalLeaderboardQueryVariables
>;
export const GetWeeklyLeaderboardMultipliersDocument = gql`
  query GetWeeklyLeaderboardMultipliers {
    players {
      getWeeklyLeaderboardMultipliers {
        divisionMultipliers
        matchWinXP
        vaultXPMultiplier
      }
    }
  }
`;

/**
 * __useGetWeeklyLeaderboardMultipliersQuery__
 *
 * To run a query within a React component, call `useGetWeeklyLeaderboardMultipliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyLeaderboardMultipliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyLeaderboardMultipliersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWeeklyLeaderboardMultipliersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWeeklyLeaderboardMultipliersQuery,
    GetWeeklyLeaderboardMultipliersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWeeklyLeaderboardMultipliersQuery, GetWeeklyLeaderboardMultipliersQueryVariables>(
    GetWeeklyLeaderboardMultipliersDocument,
    options,
  );
}
export function useGetWeeklyLeaderboardMultipliersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWeeklyLeaderboardMultipliersQuery,
    GetWeeklyLeaderboardMultipliersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWeeklyLeaderboardMultipliersQuery, GetWeeklyLeaderboardMultipliersQueryVariables>(
    GetWeeklyLeaderboardMultipliersDocument,
    options,
  );
}
export function useGetWeeklyLeaderboardMultipliersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWeeklyLeaderboardMultipliersQuery,
        GetWeeklyLeaderboardMultipliersQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWeeklyLeaderboardMultipliersQuery, GetWeeklyLeaderboardMultipliersQueryVariables>(
    GetWeeklyLeaderboardMultipliersDocument,
    options,
  );
}
export type GetWeeklyLeaderboardMultipliersQueryHookResult = ReturnType<typeof useGetWeeklyLeaderboardMultipliersQuery>;
export type GetWeeklyLeaderboardMultipliersLazyQueryHookResult = ReturnType<
  typeof useGetWeeklyLeaderboardMultipliersLazyQuery
>;
export type GetWeeklyLeaderboardMultipliersSuspenseQueryHookResult = ReturnType<
  typeof useGetWeeklyLeaderboardMultipliersSuspenseQuery
>;
export type GetWeeklyLeaderboardMultipliersQueryResult = Apollo.QueryResult<
  GetWeeklyLeaderboardMultipliersQuery,
  GetWeeklyLeaderboardMultipliersQueryVariables
>;
export const GetPlatformRtpDocument = gql`
  query GetPlatformRtp {
    players {
      getPlatformRtp {
        FINAL_RESULT
        UNDER_OVER
        BTTS
        RESULT_BTTS
        CORRECT_SCORE
        FIRST_LAST_ANY_GOAL_SCORE
        HANDICAPS
        FIRST_GOAL_CORRECT_SCORE
        OVER_ALL
      }
    }
  }
`;

/**
 * __useGetPlatformRtpQuery__
 *
 * To run a query within a React component, call `useGetPlatformRtpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformRtpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformRtpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlatformRtpQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPlatformRtpQuery, GetPlatformRtpQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPlatformRtpQuery, GetPlatformRtpQueryVariables>(GetPlatformRtpDocument, options);
}
export function useGetPlatformRtpLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformRtpQuery, GetPlatformRtpQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPlatformRtpQuery, GetPlatformRtpQueryVariables>(GetPlatformRtpDocument, options);
}
export function useGetPlatformRtpSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformRtpQuery, GetPlatformRtpQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPlatformRtpQuery, GetPlatformRtpQueryVariables>(GetPlatformRtpDocument, options);
}
export type GetPlatformRtpQueryHookResult = ReturnType<typeof useGetPlatformRtpQuery>;
export type GetPlatformRtpLazyQueryHookResult = ReturnType<typeof useGetPlatformRtpLazyQuery>;
export type GetPlatformRtpSuspenseQueryHookResult = ReturnType<typeof useGetPlatformRtpSuspenseQuery>;
export type GetPlatformRtpQueryResult = Apollo.QueryResult<GetPlatformRtpQuery, GetPlatformRtpQueryVariables>;
export const GetWeeklyLeaderboardDocument = gql`
  query GetWeeklyLeaderboard {
    players {
      getWeeklyLeaderboard {
        leaderboardInfo {
          currentLeague
          poolId
          promotionPositions
          demotionPositions
          weekStartDate
          weekEndDate
        }
        entries {
          userId
          teamName
          badgeUrl
          countryCode
          position
          totalXP
          imageUrl
        }
        isWeeklyLeaderboardActive
      }
    }
  }
`;

/**
 * __useGetWeeklyLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetWeeklyLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyLeaderboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWeeklyLeaderboardQuery(
  baseOptions?: Apollo.QueryHookOptions<GetWeeklyLeaderboardQuery, GetWeeklyLeaderboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWeeklyLeaderboardQuery, GetWeeklyLeaderboardQueryVariables>(
    GetWeeklyLeaderboardDocument,
    options,
  );
}
export function useGetWeeklyLeaderboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWeeklyLeaderboardQuery, GetWeeklyLeaderboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWeeklyLeaderboardQuery, GetWeeklyLeaderboardQueryVariables>(
    GetWeeklyLeaderboardDocument,
    options,
  );
}
export function useGetWeeklyLeaderboardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWeeklyLeaderboardQuery, GetWeeklyLeaderboardQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWeeklyLeaderboardQuery, GetWeeklyLeaderboardQueryVariables>(
    GetWeeklyLeaderboardDocument,
    options,
  );
}
export type GetWeeklyLeaderboardQueryHookResult = ReturnType<typeof useGetWeeklyLeaderboardQuery>;
export type GetWeeklyLeaderboardLazyQueryHookResult = ReturnType<typeof useGetWeeklyLeaderboardLazyQuery>;
export type GetWeeklyLeaderboardSuspenseQueryHookResult = ReturnType<typeof useGetWeeklyLeaderboardSuspenseQuery>;
export type GetWeeklyLeaderboardQueryResult = Apollo.QueryResult<
  GetWeeklyLeaderboardQuery,
  GetWeeklyLeaderboardQueryVariables
>;
export const MeDocument = gql`
  query Me {
    players {
      me {
        _id
        rgsPlayerId
        operatorId
        balance
        pbfCoin
        isFTU
        settings {
          oddsDisplay
          audio
        }
        extraData
      }
    }
  }
`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export function useMeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UpdateTeamMetadataDocument = gql`
  mutation UpdateTeamMetadata($input: UpdateTeamMetadataInput!) {
    teamManager {
      updateTeamMetadata(input: $input) {
        name
        badge
        badgeUrl
        kit
        kitColor
        kitColorDark
        attackRating
        defenseRating
        creativityRating
        overallRating
        chemistry
        chemistryPercentage
        players {
          _id
          booster
          chemistry
          sellingPrice
          fullName
          commonNameForename
          commonNameSurname
          clubId
          commonName
          displayName
          displayNameAbb
          club
          league
          currentPosition
          preferredPosition
          secondaryPosition1
          secondaryPosition2
          nationality
          nationalityImageUrl
          attackRating
          defenseRating
          creativityRating
          overallRating
          age
          weight
          height
          rarity
          imageUrl
          miniImageUrl
          extraData
          originalRatings
          shirtNumber
          chemistryPercentage
          isBoosterApplied
          cardImg
          cardImgSm
          detImg
          boosterDetails {
            _id
            type
            bonusPoints
            duration
            cost
            name
            rarity
            imageUrl
            appliedOnPlayer {
              _id
              booster
              chemistry
              sellingPrice
              fullName
              commonNameForename
              commonNameSurname
              clubId
              commonName
              displayName
              displayNameAbb
              club
              league
              currentPosition
              preferredPosition
              secondaryPosition1
              secondaryPosition2
              nationality
              nationalityImageUrl
              attackRating
              defenseRating
              creativityRating
              overallRating
              age
              weight
              height
              rarity
              imageUrl
              miniImageUrl
              extraData
              originalRatings
              shirtNumber
              chemistryPercentage
              isBoosterApplied
              cardImg
              cardImgSm
              detImg
            }
          }
        }
        formation
        badgeUrl
      }
    }
  }
`;
export type UpdateTeamMetadataMutationFn = Apollo.MutationFunction<
  UpdateTeamMetadataMutation,
  UpdateTeamMetadataMutationVariables
>;

/**
 * __useUpdateTeamMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMetadataMutation, { data, loading, error }] = useUpdateTeamMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMetadataMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTeamMetadataMutation, UpdateTeamMetadataMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTeamMetadataMutation, UpdateTeamMetadataMutationVariables>(
    UpdateTeamMetadataDocument,
    options,
  );
}
export type UpdateTeamMetadataMutationHookResult = ReturnType<typeof useUpdateTeamMetadataMutation>;
export type UpdateTeamMetadataMutationResult = Apollo.MutationResult<UpdateTeamMetadataMutation>;
export type UpdateTeamMetadataMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeamMetadataMutation,
  UpdateTeamMetadataMutationVariables
>;
export const UpdateBalanceDocument = gql`
  mutation UpdateBalance($balance: Float!) {
    players {
      updateBalance(balance: $balance) {
        message
        data
      }
    }
  }
`;
export type UpdateBalanceMutationFn = Apollo.MutationFunction<UpdateBalanceMutation, UpdateBalanceMutationVariables>;

/**
 * __useUpdateBalanceMutation__
 *
 * To run a mutation, you first call `useUpdateBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBalanceMutation, { data, loading, error }] = useUpdateBalanceMutation({
 *   variables: {
 *      balance: // value for 'balance'
 *   },
 * });
 */
export function useUpdateBalanceMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateBalanceMutation, UpdateBalanceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateBalanceMutation, UpdateBalanceMutationVariables>(UpdateBalanceDocument, options);
}
export type UpdateBalanceMutationHookResult = ReturnType<typeof useUpdateBalanceMutation>;
export type UpdateBalanceMutationResult = Apollo.MutationResult<UpdateBalanceMutation>;
export type UpdateBalanceMutationOptions = Apollo.BaseMutationOptions<
  UpdateBalanceMutation,
  UpdateBalanceMutationVariables
>;
export const UpdateUserExtraDataDocument = gql`
  mutation UpdateUserExtraData($extraData: JSONObject!) {
    players {
      updateUserExtraData(extraData: $extraData) {
        _id
        rgsPlayerId
        operatorId
        balance
        pbfCoin
        isFTU
        settings {
          oddsDisplay
          audio
        }
        extraData
        goldStars
      }
    }
  }
`;
export type UpdateUserExtraDataMutationFn = Apollo.MutationFunction<
  UpdateUserExtraDataMutation,
  UpdateUserExtraDataMutationVariables
>;

/**
 * __useUpdateUserExtraDataMutation__
 *
 * To run a mutation, you first call `useUpdateUserExtraDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserExtraDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserExtraDataMutation, { data, loading, error }] = useUpdateUserExtraDataMutation({
 *   variables: {
 *      extraData: // value for 'extraData'
 *   },
 * });
 */
export function useUpdateUserExtraDataMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserExtraDataMutation, UpdateUserExtraDataMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserExtraDataMutation, UpdateUserExtraDataMutationVariables>(
    UpdateUserExtraDataDocument,
    options,
  );
}
export type UpdateUserExtraDataMutationHookResult = ReturnType<typeof useUpdateUserExtraDataMutation>;
export type UpdateUserExtraDataMutationResult = Apollo.MutationResult<UpdateUserExtraDataMutation>;
export type UpdateUserExtraDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserExtraDataMutation,
  UpdateUserExtraDataMutationVariables
>;
export const MyBetsDocument = gql`
  query MyBets(
    $pageNo: Int!
    $limit: Int!
    $skipPagination: Boolean
    $sortKey: String
    $sortDir: SortDir
    $matchId: String
    $matchStatus: MatchStatus
    $betStatus: BetStatus
    $dateFilter: DateFilterEnum
  ) {
    players {
      myBets(
        pageNo: $pageNo
        limit: $limit
        skipPagination: $skipPagination
        sortKey: $sortKey
        sortDir: $sortDir
        matchId: $matchId
        matchStatus: $matchStatus
        betStatus: $betStatus
        dateFilter: $dateFilter
      ) {
        totalItems
        items {
          matchId
          myTeamName
          opponentTeamName
          matchStatus
          createdAt
          myTeamScore
          oppTeamScore
          allPlayers {
            _id
            playerId
            playerCardId
            teamId
            attackRating
            rarity
            name
            currentPosition
            preferredPosition
          }
          bets {
            betId
            oddId
            betAmount
            winAmount
            toReturn
            payoutMultiplier
            marketType
            marketName
            xp
            xpBoostPercentage
            odd
            decimalOdd
            fractionalOdd
            americanOdd
            isResolved
            betStatus
            createdAt
            oddsDetails {
              win
              goals
              type
              value
              team1
              team2
              playerId
              teamId
              handicap
              xpBoostPercentage
            }
            currency
            platformTransactionId
            betPlacedAt
          }
          openingBalance
          closingBalance
        }
        totalPages
        morePages
      }
    }
  }
`;

/**
 * __useMyBetsQuery__
 *
 * To run a query within a React component, call `useMyBetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBetsQuery({
 *   variables: {
 *      pageNo: // value for 'pageNo'
 *      limit: // value for 'limit'
 *      skipPagination: // value for 'skipPagination'
 *      sortKey: // value for 'sortKey'
 *      sortDir: // value for 'sortDir'
 *      matchId: // value for 'matchId'
 *      matchStatus: // value for 'matchStatus'
 *      betStatus: // value for 'betStatus'
 *      dateFilter: // value for 'dateFilter'
 *   },
 * });
 */
export function useMyBetsQuery(
  baseOptions: Apollo.QueryHookOptions<MyBetsQuery, MyBetsQueryVariables> &
    ({ variables: MyBetsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyBetsQuery, MyBetsQueryVariables>(MyBetsDocument, options);
}
export function useMyBetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyBetsQuery, MyBetsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyBetsQuery, MyBetsQueryVariables>(MyBetsDocument, options);
}
export function useMyBetsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyBetsQuery, MyBetsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyBetsQuery, MyBetsQueryVariables>(MyBetsDocument, options);
}
export type MyBetsQueryHookResult = ReturnType<typeof useMyBetsQuery>;
export type MyBetsLazyQueryHookResult = ReturnType<typeof useMyBetsLazyQuery>;
export type MyBetsSuspenseQueryHookResult = ReturnType<typeof useMyBetsSuspenseQuery>;
export type MyBetsQueryResult = Apollo.QueryResult<MyBetsQuery, MyBetsQueryVariables>;
export const CoinHistoryDocument = gql`
  query CoinHistory(
    $dateFilter: DateFilterEnum
    $pageNo: Int!
    $limit: Int!
    $skipPagination: Boolean
    $sortKey: String
    $sortDir: SortDir
  ) {
    players {
      coinHistory(
        dateFilter: $dateFilter
        pageNo: $pageNo
        limit: $limit
        skipPagination: $skipPagination
        sortKey: $sortKey
        sortDir: $sortDir
      ) {
        totalItems
        items {
          txnId
          createdAt
          amount
          price
          currency
        }
        totalPages
        morePages
      }
    }
  }
`;

/**
 * __useCoinHistoryQuery__
 *
 * To run a query within a React component, call `useCoinHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoinHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoinHistoryQuery({
 *   variables: {
 *      dateFilter: // value for 'dateFilter'
 *      pageNo: // value for 'pageNo'
 *      limit: // value for 'limit'
 *      skipPagination: // value for 'skipPagination'
 *      sortKey: // value for 'sortKey'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useCoinHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<CoinHistoryQuery, CoinHistoryQueryVariables> &
    ({ variables: CoinHistoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CoinHistoryQuery, CoinHistoryQueryVariables>(CoinHistoryDocument, options);
}
export function useCoinHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CoinHistoryQuery, CoinHistoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CoinHistoryQuery, CoinHistoryQueryVariables>(CoinHistoryDocument, options);
}
export function useCoinHistorySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CoinHistoryQuery, CoinHistoryQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CoinHistoryQuery, CoinHistoryQueryVariables>(CoinHistoryDocument, options);
}
export type CoinHistoryQueryHookResult = ReturnType<typeof useCoinHistoryQuery>;
export type CoinHistoryLazyQueryHookResult = ReturnType<typeof useCoinHistoryLazyQuery>;
export type CoinHistorySuspenseQueryHookResult = ReturnType<typeof useCoinHistorySuspenseQuery>;
export type CoinHistoryQueryResult = Apollo.QueryResult<CoinHistoryQuery, CoinHistoryQueryVariables>;
export const InitDocument = gql`
  mutation Init($token: String!, $currency: String!) {
    players {
      init(token: $token, currency: $currency) {
        _id
        balance
        pbfCoin
        beToken
        operatorId
        isFTU
        badge
        kit
        kitColor
        kitColorDark
        extraData
      }
    }
  }
`;
export type InitMutationFn = Apollo.MutationFunction<InitMutation, InitMutationVariables>;

/**
 * __useInitMutation__
 *
 * To run a mutation, you first call `useInitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initMutation, { data, loading, error }] = useInitMutation({
 *   variables: {
 *      token: // value for 'token'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useInitMutation(baseOptions?: Apollo.MutationHookOptions<InitMutation, InitMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InitMutation, InitMutationVariables>(InitDocument, options);
}
export type InitMutationHookResult = ReturnType<typeof useInitMutation>;
export type InitMutationResult = Apollo.MutationResult<InitMutation>;
export type InitMutationOptions = Apollo.BaseMutationOptions<InitMutation, InitMutationVariables>;
export const MyTeamDocument = gql`
  query MyTeam {
    teamManager {
      myTeam {
        name
        badge
        kit
        kitColor
        kitColorDark
        attackRating
        defenseRating
        creativityRating
        overallRating
        chemistry
        players {
          _id
          booster
          chemistry
          sellingPrice
          fullName
          commonName
          displayName
          displayNameAbb
          club
          league
          currentPosition
          preferredPosition
          secondaryPosition1
          secondaryPosition2
          nationality
          nationalityImageUrl
          attackRating
          defenseRating
          creativityRating
          overallRating
          age
          weight
          height
          rarity
          imageUrl
          miniImageUrl
          extraData
        }
      }
    }
  }
`;

/**
 * __useMyTeamQuery__
 *
 * To run a query within a React component, call `useMyTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTeamQuery(baseOptions?: Apollo.QueryHookOptions<MyTeamQuery, MyTeamQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyTeamQuery, MyTeamQueryVariables>(MyTeamDocument, options);
}
export function useMyTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamQuery, MyTeamQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyTeamQuery, MyTeamQueryVariables>(MyTeamDocument, options);
}
export function useMyTeamSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyTeamQuery, MyTeamQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyTeamQuery, MyTeamQueryVariables>(MyTeamDocument, options);
}
export type MyTeamQueryHookResult = ReturnType<typeof useMyTeamQuery>;
export type MyTeamLazyQueryHookResult = ReturnType<typeof useMyTeamLazyQuery>;
export type MyTeamSuspenseQueryHookResult = ReturnType<typeof useMyTeamSuspenseQuery>;
export type MyTeamQueryResult = Apollo.QueryResult<MyTeamQuery, MyTeamQueryVariables>;
export const UpdateUserSettingsDocument = gql`
  mutation UpdateUserSettings($input: UpdateUserSettingsInput!) {
    players {
      updateUserSettings(input: $input) {
        _id
        rgsPlayerId
        operatorId
        balance
        pbfCoin
        isFTU
        settings {
          oddsDisplay
          audio
        }
      }
    }
  }
`;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables
>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(
    UpdateUserSettingsDocument,
    options,
  );
}
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables
>;
export const AllBadgesDocument = gql`
  query AllBadges {
    teamManager {
      allBadges {
        name
        url
      }
    }
  }
`;

/**
 * __useAllBadgesQuery__
 *
 * To run a query within a React component, call `useAllBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBadgesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllBadgesQuery(baseOptions?: Apollo.QueryHookOptions<AllBadgesQuery, AllBadgesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllBadgesQuery, AllBadgesQueryVariables>(AllBadgesDocument, options);
}
export function useAllBadgesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AllBadgesQuery, AllBadgesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllBadgesQuery, AllBadgesQueryVariables>(AllBadgesDocument, options);
}
export function useAllBadgesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllBadgesQuery, AllBadgesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AllBadgesQuery, AllBadgesQueryVariables>(AllBadgesDocument, options);
}
export type AllBadgesQueryHookResult = ReturnType<typeof useAllBadgesQuery>;
export type AllBadgesLazyQueryHookResult = ReturnType<typeof useAllBadgesLazyQuery>;
export type AllBadgesSuspenseQueryHookResult = ReturnType<typeof useAllBadgesSuspenseQuery>;
export type AllBadgesQueryResult = Apollo.QueryResult<AllBadgesQuery, AllBadgesQueryVariables>;
export const FtuNationalityDocument = gql`
  query FtuNationality {
    teamManager {
      ftuNationality {
        name
        imageUrl
      }
    }
  }
`;

/**
 * __useFtuNationalityQuery__
 *
 * To run a query within a React component, call `useFtuNationalityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFtuNationalityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFtuNationalityQuery({
 *   variables: {
 *   },
 * });
 */
export function useFtuNationalityQuery(
  baseOptions?: Apollo.QueryHookOptions<FtuNationalityQuery, FtuNationalityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FtuNationalityQuery, FtuNationalityQueryVariables>(FtuNationalityDocument, options);
}
export function useFtuNationalityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FtuNationalityQuery, FtuNationalityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FtuNationalityQuery, FtuNationalityQueryVariables>(FtuNationalityDocument, options);
}
export function useFtuNationalitySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FtuNationalityQuery, FtuNationalityQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FtuNationalityQuery, FtuNationalityQueryVariables>(FtuNationalityDocument, options);
}
export type FtuNationalityQueryHookResult = ReturnType<typeof useFtuNationalityQuery>;
export type FtuNationalityLazyQueryHookResult = ReturnType<typeof useFtuNationalityLazyQuery>;
export type FtuNationalitySuspenseQueryHookResult = ReturnType<typeof useFtuNationalitySuspenseQuery>;
export type FtuNationalityQueryResult = Apollo.QueryResult<FtuNationalityQuery, FtuNationalityQueryVariables>;
export const FtuUpdateDocument = gql`
  mutation FtuUpdate($input: FTUUpdateInput!) {
    teamManager {
      ftuUpdate(input: $input) {
        packName
        packImageUrl
        badge
        kit
        kitColor
        kitColorDark
        players {
          _id
          booster
          chemistry
          sellingPrice
          fullName
          commonName
          displayName
          displayNameAbb
          club
          league
          currentPosition
          preferredPosition
          secondaryPosition1
          secondaryPosition2
          nationality
          nationalityImageUrl
          attackRating
          defenseRating
          creativityRating
          overallRating
          age
          weight
          height
          rarity
          imageUrl
          miniImageUrl
          extraData
        }
        packSummary
        name
      }
    }
  }
`;
export type FtuUpdateMutationFn = Apollo.MutationFunction<FtuUpdateMutation, FtuUpdateMutationVariables>;

/**
 * __useFtuUpdateMutation__
 *
 * To run a mutation, you first call `useFtuUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFtuUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ftuUpdateMutation, { data, loading, error }] = useFtuUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFtuUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<FtuUpdateMutation, FtuUpdateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FtuUpdateMutation, FtuUpdateMutationVariables>(FtuUpdateDocument, options);
}
export type FtuUpdateMutationHookResult = ReturnType<typeof useFtuUpdateMutation>;
export type FtuUpdateMutationResult = Apollo.MutationResult<FtuUpdateMutation>;
export type FtuUpdateMutationOptions = Apollo.BaseMutationOptions<FtuUpdateMutation, FtuUpdateMutationVariables>;
export const MatchDetailsByPlatformTxnIdDocument = gql`
  query MatchDetailsByPlatformTxnId($platformTxnId: String!) {
    match {
      matchDetailsByPlatformTxnId(platformTxnId: $platformTxnId) {
        matchId
        bets {
          betId
          oddId
          betAmount
          winAmount
          toReturn
          payoutMultiplier
          marketType
          marketName
          xp
          xpBoostPercentage
          odd
          decimalOdd
          fractionalOdd
          americanOdd
          isResolved
          betStatus
          createdAt
          oddsDetails {
            win
            goals
            type
            value
            team1
            team2
            playerId
            teamId
            handicap
            xpBoostPercentage
          }
          currency
        }
        myTeam {
          name
          badge
          badgeUrl
          kit
          kitColor
          kitColorDark
          attackRating
          defenseRating
          creativityRating
          overallRating
          chemistry
        }
        opponentTeam {
          name
          badge
          badgeUrl
          kit
          kitColor
          kitColorDark
          attackRating
          defenseRating
          creativityRating
          overallRating
          chemistry
        }
        allPlayers {
          _id
          playerId
          teamId
          attackRating
          rarity
          name
          currentPosition
          preferredPosition
        }
        myTeamScore
        oppTeamScore
        currentStep
        lastStep
        currentMilestone
        lastMilestone
        currentLeague
        lastLeague
        myTeamGoalScorers {
          _id
          playerId
          name
          time
        }
        oppTeamGoalScorers {
          _id
          playerId
          name
          time
        }
        startDate
        endDate
      }
    }
  }
`;

/**
 * __useMatchDetailsByPlatformTxnIdQuery__
 *
 * To run a query within a React component, call `useMatchDetailsByPlatformTxnIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchDetailsByPlatformTxnIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchDetailsByPlatformTxnIdQuery({
 *   variables: {
 *      platformTxnId: // value for 'platformTxnId'
 *   },
 * });
 */
export function useMatchDetailsByPlatformTxnIdQuery(
  baseOptions: Apollo.QueryHookOptions<MatchDetailsByPlatformTxnIdQuery, MatchDetailsByPlatformTxnIdQueryVariables> &
    ({ variables: MatchDetailsByPlatformTxnIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MatchDetailsByPlatformTxnIdQuery, MatchDetailsByPlatformTxnIdQueryVariables>(
    MatchDetailsByPlatformTxnIdDocument,
    options,
  );
}
export function useMatchDetailsByPlatformTxnIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MatchDetailsByPlatformTxnIdQuery,
    MatchDetailsByPlatformTxnIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MatchDetailsByPlatformTxnIdQuery, MatchDetailsByPlatformTxnIdQueryVariables>(
    MatchDetailsByPlatformTxnIdDocument,
    options,
  );
}
export function useMatchDetailsByPlatformTxnIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MatchDetailsByPlatformTxnIdQuery, MatchDetailsByPlatformTxnIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MatchDetailsByPlatformTxnIdQuery, MatchDetailsByPlatformTxnIdQueryVariables>(
    MatchDetailsByPlatformTxnIdDocument,
    options,
  );
}
export type MatchDetailsByPlatformTxnIdQueryHookResult = ReturnType<typeof useMatchDetailsByPlatformTxnIdQuery>;
export type MatchDetailsByPlatformTxnIdLazyQueryHookResult = ReturnType<typeof useMatchDetailsByPlatformTxnIdLazyQuery>;
export type MatchDetailsByPlatformTxnIdSuspenseQueryHookResult = ReturnType<
  typeof useMatchDetailsByPlatformTxnIdSuspenseQuery
>;
export type MatchDetailsByPlatformTxnIdQueryResult = Apollo.QueryResult<
  MatchDetailsByPlatformTxnIdQuery,
  MatchDetailsByPlatformTxnIdQueryVariables
>;
export const ProfanityCheckDocument = gql`
  query ProfanityCheck($text: String!) {
    players {
      profanityCheck(text: $text) {
        isValid
      }
    }
  }
`;

/**
 * __useProfanityCheckQuery__
 *
 * To run a query within a React component, call `useProfanityCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfanityCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfanityCheckQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useProfanityCheckQuery(
  baseOptions: Apollo.QueryHookOptions<ProfanityCheckQuery, ProfanityCheckQueryVariables> &
    ({ variables: ProfanityCheckQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProfanityCheckQuery, ProfanityCheckQueryVariables>(ProfanityCheckDocument, options);
}
export function useProfanityCheckLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProfanityCheckQuery, ProfanityCheckQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProfanityCheckQuery, ProfanityCheckQueryVariables>(ProfanityCheckDocument, options);
}
export function useProfanityCheckSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfanityCheckQuery, ProfanityCheckQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProfanityCheckQuery, ProfanityCheckQueryVariables>(ProfanityCheckDocument, options);
}
export type ProfanityCheckQueryHookResult = ReturnType<typeof useProfanityCheckQuery>;
export type ProfanityCheckLazyQueryHookResult = ReturnType<typeof useProfanityCheckLazyQuery>;
export type ProfanityCheckSuspenseQueryHookResult = ReturnType<typeof useProfanityCheckSuspenseQuery>;
export type ProfanityCheckQueryResult = Apollo.QueryResult<ProfanityCheckQuery, ProfanityCheckQueryVariables>;
export const AddUpdateBetDocument = gql`
  mutation AddUpdateBet($input: AddUpdateBetInput!) {
    players {
      addUpdateBet(input: $input) {
        betId
        oddId
        betAmount
        winAmount
        toReturn
        marketType
        marketName
        xp
        xpBoostPercentage
        odd
        decimalOdd
        isResolved
        betStatus
        createdAt
        oddsDetails {
          win
          goals
          type
          value
          team1
          team2
          playerId
          teamId
          handicap
          xpBoostPercentage
        }
        fractionalOdd
        americanOdd
        payoutMultiplier
      }
    }
  }
`;
export type AddUpdateBetMutationFn = Apollo.MutationFunction<AddUpdateBetMutation, AddUpdateBetMutationVariables>;

/**
 * __useAddUpdateBetMutation__
 *
 * To run a mutation, you first call `useAddUpdateBetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateBetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateBetMutation, { data, loading, error }] = useAddUpdateBetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUpdateBetMutation(
  baseOptions?: Apollo.MutationHookOptions<AddUpdateBetMutation, AddUpdateBetMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddUpdateBetMutation, AddUpdateBetMutationVariables>(AddUpdateBetDocument, options);
}
export type AddUpdateBetMutationHookResult = ReturnType<typeof useAddUpdateBetMutation>;
export type AddUpdateBetMutationResult = Apollo.MutationResult<AddUpdateBetMutation>;
export type AddUpdateBetMutationOptions = Apollo.BaseMutationOptions<
  AddUpdateBetMutation,
  AddUpdateBetMutationVariables
>;
export const CurrentBetSlipDocument = gql`
  query CurrentBetSlip {
    players {
      currentBetSlip {
        betId
        oddId
        betAmount
        winAmount
        toReturn
        marketType
        marketName
        xp
        xpBoostPercentage
        odd
        decimalOdd
        fractionalOdd
        americanOdd
        isResolved
        betStatus
        createdAt
        payoutMultiplier
        oddsDetails {
          win
          goals
          type
          value
          team1
          team2
          playerId
          teamId
          handicap
          xpBoostPercentage
        }
      }
    }
  }
`;

/**
 * __useCurrentBetSlipQuery__
 *
 * To run a query within a React component, call `useCurrentBetSlipQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBetSlipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBetSlipQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentBetSlipQuery(
  baseOptions?: Apollo.QueryHookOptions<CurrentBetSlipQuery, CurrentBetSlipQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CurrentBetSlipQuery, CurrentBetSlipQueryVariables>(CurrentBetSlipDocument, options);
}
export function useCurrentBetSlipLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CurrentBetSlipQuery, CurrentBetSlipQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CurrentBetSlipQuery, CurrentBetSlipQueryVariables>(CurrentBetSlipDocument, options);
}
export function useCurrentBetSlipSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentBetSlipQuery, CurrentBetSlipQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CurrentBetSlipQuery, CurrentBetSlipQueryVariables>(CurrentBetSlipDocument, options);
}
export type CurrentBetSlipQueryHookResult = ReturnType<typeof useCurrentBetSlipQuery>;
export type CurrentBetSlipLazyQueryHookResult = ReturnType<typeof useCurrentBetSlipLazyQuery>;
export type CurrentBetSlipSuspenseQueryHookResult = ReturnType<typeof useCurrentBetSlipSuspenseQuery>;
export type CurrentBetSlipQueryResult = Apollo.QueryResult<CurrentBetSlipQuery, CurrentBetSlipQueryVariables>;
export const GetQuickBetsDocument = gql`
  query GetQuickBets {
    players {
      getQuickBets {
        bets
      }
    }
  }
`;

/**
 * __useGetQuickBetsQuery__
 *
 * To run a query within a React component, call `useGetQuickBetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickBetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickBetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickBetsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetQuickBetsQuery, GetQuickBetsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQuickBetsQuery, GetQuickBetsQueryVariables>(GetQuickBetsDocument, options);
}
export function useGetQuickBetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetQuickBetsQuery, GetQuickBetsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQuickBetsQuery, GetQuickBetsQueryVariables>(GetQuickBetsDocument, options);
}
export function useGetQuickBetsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuickBetsQuery, GetQuickBetsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetQuickBetsQuery, GetQuickBetsQueryVariables>(GetQuickBetsDocument, options);
}
export type GetQuickBetsQueryHookResult = ReturnType<typeof useGetQuickBetsQuery>;
export type GetQuickBetsLazyQueryHookResult = ReturnType<typeof useGetQuickBetsLazyQuery>;
export type GetQuickBetsSuspenseQueryHookResult = ReturnType<typeof useGetQuickBetsSuspenseQuery>;
export type GetQuickBetsQueryResult = Apollo.QueryResult<GetQuickBetsQuery, GetQuickBetsQueryVariables>;
export const PlaceBetDocument = gql`
  mutation PlaceBet {
    players {
      placeBet {
        currentXP
        currentVaultLevel
        availableSpins
        spinDetails {
          _id
          level
          xpRequired
          isRedeemed
        }
        xpNeededForLevel
        xpToNextLevel
        bets {
          betId
          oddId
          betAmount
          winAmount
          toReturn
          marketType
          marketName
          xp
          xpBoostPercentage
          odd
          decimalOdd
          payoutMultiplier
          isResolved
          betStatus
          createdAt
          oddsDetails {
            win
            goals
            type
            value
            team1
            team2
            playerId
            teamId
            handicap
            xpBoostPercentage
          }
          currency
        }
        totalXp
        lastCurrentXP
        lastVaultLevel
        progressUpdates {
          level
          xpFrom
          xpTo
          xpRequired
          spin
        }
      }
    }
  }
`;
export type PlaceBetMutationFn = Apollo.MutationFunction<PlaceBetMutation, PlaceBetMutationVariables>;

/**
 * __usePlaceBetMutation__
 *
 * To run a mutation, you first call `usePlaceBetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceBetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeBetMutation, { data, loading, error }] = usePlaceBetMutation({
 *   variables: {
 *   },
 * });
 */
export function usePlaceBetMutation(
  baseOptions?: Apollo.MutationHookOptions<PlaceBetMutation, PlaceBetMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PlaceBetMutation, PlaceBetMutationVariables>(PlaceBetDocument, options);
}
export type PlaceBetMutationHookResult = ReturnType<typeof usePlaceBetMutation>;
export type PlaceBetMutationResult = Apollo.MutationResult<PlaceBetMutation>;
export type PlaceBetMutationOptions = Apollo.BaseMutationOptions<PlaceBetMutation, PlaceBetMutationVariables>;
export const RemoveBetFromSlipDocument = gql`
  mutation RemoveBetFromSlip($betId: String!) {
    players {
      removeBetFromSlip(betId: $betId) {
        message
      }
    }
  }
`;
export type RemoveBetFromSlipMutationFn = Apollo.MutationFunction<
  RemoveBetFromSlipMutation,
  RemoveBetFromSlipMutationVariables
>;

/**
 * __useRemoveBetFromSlipMutation__
 *
 * To run a mutation, you first call `useRemoveBetFromSlipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBetFromSlipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBetFromSlipMutation, { data, loading, error }] = useRemoveBetFromSlipMutation({
 *   variables: {
 *      betId: // value for 'betId'
 *   },
 * });
 */
export function useRemoveBetFromSlipMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveBetFromSlipMutation, RemoveBetFromSlipMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveBetFromSlipMutation, RemoveBetFromSlipMutationVariables>(
    RemoveBetFromSlipDocument,
    options,
  );
}
export type RemoveBetFromSlipMutationHookResult = ReturnType<typeof useRemoveBetFromSlipMutation>;
export type RemoveBetFromSlipMutationResult = Apollo.MutationResult<RemoveBetFromSlipMutation>;
export type RemoveBetFromSlipMutationOptions = Apollo.BaseMutationOptions<
  RemoveBetFromSlipMutation,
  RemoveBetFromSlipMutationVariables
>;
export const OddsDocument = gql`
  query Odds {
    players {
      odds {
        _id
        matchId
        xpToAward
        teamA {
          name
          badge
          badgeUrl
          kit
          kitColor
          kitColorDark
          attackRating
          defenseRating
          creativityRating
          overallRating
          chemistry
        }
        teamB {
          name
          badge
          badgeUrl
          kit
          kitColor
          kitColorDark
          attackRating
          defenseRating
          creativityRating
          overallRating
          chemistry
        }
        allPlayers {
          _id
          playerId
          teamId
          attackRating
          rarity
          name
          currentPosition
          preferredPosition
        }
        finalResult {
          name
          type
          data {
            id
            win
            odd
            decimalOdd
            fractionalOdd
            americanOdd
            xpBoostPercentage
            maxBet
            payoutMultiplier
          }
        }
        goalsUnderOver {
          name
          type
          data
        }
        btts {
          name
          type
          data {
            id
            value
            odd
            fractionalOdd
            americanOdd
            decimalOdd
            xpBoostPercentage
            maxBet
            payoutMultiplier
          }
        }
        resultBtts {
          name
          type
          data {
            win
            values {
              id
              value
              odd
              decimalOdd
              fractionalOdd
              americanOdd
              xpBoostPercentage
              maxBet
              payoutMultiplier
            }
          }
        }
        correctScore {
          name
          type
          data {
            win
            values {
              id
              team1
              team2
              odd
              decimalOdd
              fractionalOdd
              americanOdd
              xpBoostPercentage
              maxBet
              payoutMultiplier
              price
            }
          }
        }
        goalscorerOdds {
          name
          type
          data {
            playerId
            teamId
            first {
              id
              odd
              decimalOdd
              fractionalOdd
              americanOdd
              xpBoostPercentage
              maxBet
              payoutMultiplier
            }
            last {
              id
              odd
              decimalOdd
              fractionalOdd
              americanOdd
              xpBoostPercentage
              maxBet
              payoutMultiplier
            }
            any {
              id
              odd
              decimalOdd
              fractionalOdd
              americanOdd
              xpBoostPercentage
              maxBet
              payoutMultiplier
            }
          }
        }
        handicaps {
          name
          type
          data {
            win
            values {
              id
              handicap
              odd
              decimalOdd
              fractionalOdd
              americanOdd
              xpBoostPercentage
              maxBet
              payoutMultiplier
            }
          }
        }
      }
    }
  }
`;

/**
 * __useOddsQuery__
 *
 * To run a query within a React component, call `useOddsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOddsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOddsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOddsQuery(baseOptions?: Apollo.QueryHookOptions<OddsQuery, OddsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OddsQuery, OddsQueryVariables>(OddsDocument, options);
}
export function useOddsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OddsQuery, OddsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OddsQuery, OddsQueryVariables>(OddsDocument, options);
}
export function useOddsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OddsQuery, OddsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OddsQuery, OddsQueryVariables>(OddsDocument, options);
}
export type OddsQueryHookResult = ReturnType<typeof useOddsQuery>;
export type OddsLazyQueryHookResult = ReturnType<typeof useOddsLazyQuery>;
export type OddsSuspenseQueryHookResult = ReturnType<typeof useOddsSuspenseQuery>;
export type OddsQueryResult = Apollo.QueryResult<OddsQuery, OddsQueryVariables>;
export const StartMatchDocument = gql`
  mutation StartMatch {
    match {
      startMatch {
        matchId
        myTeamScore
        oppTeamScore
        slots {
          matchHalf
          myTeamScore
          oppTeamScore
          time
          betIds {
            id
            isResolved
          }
          events {
            team
            players
            type
          }
        }
      }
    }
  }
`;
export type StartMatchMutationFn = Apollo.MutationFunction<StartMatchMutation, StartMatchMutationVariables>;

/**
 * __useStartMatchMutation__
 *
 * To run a mutation, you first call `useStartMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMatchMutation, { data, loading, error }] = useStartMatchMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartMatchMutation(
  baseOptions?: Apollo.MutationHookOptions<StartMatchMutation, StartMatchMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartMatchMutation, StartMatchMutationVariables>(StartMatchDocument, options);
}
export type StartMatchMutationHookResult = ReturnType<typeof useStartMatchMutation>;
export type StartMatchMutationResult = Apollo.MutationResult<StartMatchMutation>;
export type StartMatchMutationOptions = Apollo.BaseMutationOptions<StartMatchMutation, StartMatchMutationVariables>;
